import  { ChangeEvent } from "react";
import * as React from "react";
import { connect } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import {
  Container,
  Dropdown,
  Form,
  FormGroup,
  Button,
  Modal,
  ButtonGroup,
  ToggleButtonGroup,
  ToggleButton,
  Spinner,
  Accordion,
  Card,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { TransactionService } from "../Common/Services/TransactionService";
import { MdAddShoppingCart } from "react-icons/md";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp,faCartPlus } from "@fortawesome/free-solid-svg-icons";
import { FaPencilAlt } from 'react-icons/fa';
import { BiSolidSelectMultiple } from "react-icons/bi";
import BootstrapTable from "react-bootstrap-table-next";
import { ConfirmationModal } from "../Common/Components/ConfirmationModal";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import { JobServices } from "../Common/Services/JobServices";
import DatePicker from "react-datepicker";
import { Utils } from "../Common/Utilis";
import { VendorService } from "../Common/Services/VendorService";
import { ProductService } from "../Common/Services/ProductService";
import Customerorderslideout from './Customerorderslideout';
import { resolve, reject } from "q";
import chevronRight from "../Common/Assets/Images/icons/bx-chevron-right.svg";
import "../App.scss";
import "./slideout.scss";
import { VendorSearch } from "../Common/Components/VendorSearch";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import { FaArrowUpFromBracket, FaCircleMinus, FaCirclePlus, FaEllipsis } from "react-icons/fa6";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import moment from "moment";
import { CustomerService } from "../Common/Services/CustomerService";
import { Typeahead, Menu, MenuItem } from "react-bootstrap-typeahead";
import  JobCreations  from './JobCreations';
import { MdDesignServices } from "react-icons/md";
import { MdBuild } from 'react-icons/md';
import { confirmAlert } from "react-confirm-alert";
import { SingleDropdownListWithoutSearchBoot } from "../Common/Components/SingleDropdownListWithoutSearchBoot";
import { JOMultiSelect } from "../Common/Components/JOMultiSelect";
import { PartTemplateService } from "../Common/Services/PartTemplateService";
import { debug } from "console";
import Dropzone from "react-dropzone";
import {
  faPlus,
  faMinus,
  faPaperclip,
  faFile,
  faFileImage,
  faFileExcel,
  faFilePdf,
  faFileCsv,
  faFileWord,
} from "@fortawesome/free-solid-svg-icons";
import ScrollContainer from "react-indiana-drag-scroll";
import { CommentBox } from "../Common/Components/CommentBox";
import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import Row from 'react-bootstrap/Row';
import Tab from 'react-bootstrap/Tab';
import PDFViewer from "./pdf-viewer";
import { truncate } from "fs";
import { SearchMultiSelectItems } from "../Common/Components/SearchMultiSelectItems";
import { legacy_createStore } from "redux";
import { PickerPopup } from "rsuite/esm/internals/Picker";
let routeLeavingGuard: any = null;
let storage = JSON.parse(localStorage.getItem("storage")!);
let currentUtcTime = storage === null ? "America/Chicago" : (storage.currentUtcTime as any);
const formattedDate = Utils.convertUtcToTimezoneFormat(new Date(), currentUtcTime);
let docViewerFiles: any = [];

class Vendororderslideout extends React.Component<any, any> {
  private customerSearch: any;
  private trDate: any;
  private parentScroll: any;
  private ChildComment: any;
  private scrollheight: any;
  private footerchk: any;
  private fileInputRef: any;

  renderTooltip = (ids) => {
    return (
      <Tooltip className="LDtoolTipLettercodes" id="button-tooltip" {...ids}>
        {ids.toolTipLettercodes.replaceAll(",", ", ")}
      </Tooltip>
    );
  };
  LatterCodeFormater = (cell, row, rowIndex) => {
    if (row.deptName === "" && row.lettercode === "") {
      return <div style={{ color: "gray" }}>Select EHID</div>;
    } else if (row.lettercode === "" && row.deptName !== "") {
      return (
        <div className="required-cell-text">
          EHID <div>Required</div>
        </div>
      );
    } else {
      return (
        <div

          onWheel={this.hoverOutEllipsis.bind(this)}
        >

          <>
            {!row.lettercode.includes("+") ? (
              <span>{row.lettercode}</span>
            ) : (
              <OverlayTrigger
                placement="top"
                delay={{ show: 0, hide: 0 }}
                overlay={this.renderTooltip(row)}
              >
                <span>{row.lettercode}</span>
              </OverlayTrigger>
            )}
          </>

        </div>
      );
    }
  };

  private icheckselectedall = (column, colIndex) => {
    return (
      <div className="d-flex align-items-center txt-bold">
        <OverlayTrigger
          placement="bottom"
          overlay={
            <Tooltip id="postingRule">Click to copy below all parts</Tooltip>
          }
        >
          <a href="#">
          <FontAwesomeIcon
            icon={faCartPlus}
            size="xs"
            onClick={(e) => this.handleRowSelectionCheckAllMaterial(e, colIndex)}
            
          />
         </a>
        </OverlayTrigger>
      
        {/* <input

                type="checkbox"
                onChange={(e) => this.handleRowSelectionAll(e, colIndex)}
            /> */}
      </div>
    );
  };

  private icheckselectedalljob = (column, colIndex) => {
    return (
      <div className="d-flex align-items-center txt-bold">
        <OverlayTrigger
          placement="bottom"
          overlay={
            <Tooltip id="postingRule">Click to copy below all parts</Tooltip>
          }
        >
           <a href="#">
          <FontAwesomeIcon
            icon={faArrowUp}
            size="xs"
            onClick={(e) => this.handleRowSelectionCheckAllJob()}
          />
          </a>
        </OverlayTrigger>
        {/* <input

                type="checkbox"
                onChange={(e) => this.handleRowSelectionAll(e, colIndex)}
            /> */}
      </div>
    );
  };


  private transactionsColumns = [

    {
      dataField: "",
      text: "Sr No.",
      hidden: false,
      editable: false,
      headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
      formatter: (cell: any, row: any, rowIndex: any) => {

        return (
          <div>
            {rowIndex + 1}
          </div>
        );
      },
    },
    {
      dataField: "itemName",
      text: "Item Name",
      headerClasses: "coa",

      headerStyle: { width: "900px", textAlign: "start" },
      classes: "text-start",
      headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
      formatter: (cell: any, row: any, rowIndex: any) => {
        return (
          <div>
            {row.itemName}
          </div>
        );
      },
    },
    {
      dataField: "itemDesc",
      text: "Item Description",
      headerClasses: "coa",
      hidden: true,
      headerStyle: { width: "400px", textAlign: "left" },
      headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
      formatter: (cell: any, row: any, rowIndex: any) => {
        let id = "txtitemDesc" + rowIndex + "txt";
        return (
          <div>
            <Form.Control
              tabIndex={this.state.tabEnable}
              id={id}
              type="text"
              placeholder="Please enter item details"
              value={row.itemDesc}
              onChange={(e) => this.updateState(e, row, "itemDesc", id)}
              autoComplete="off"
              //pattern="[+-]?\d+(?:[.,]\d+)?"
              maxLength={200}
              disabled={false}
              title=""
            />
          </div>
        );
      },
    },
    // {
    //   dataField: "glcode",
    //   text: "MS Code",
    //   headerStyle: { width: "100px" },
    //   hidden: true,
    //   editable: false,
    //   headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
    //   formatter: (cell: any, row: any, rowIndex: any) => {
    //     let id = "txtglcode" + rowIndex + "txt";
    //     let disable = false;
    //     return (
    //       <div>
    //         <Form.Control
    //           tabIndex={this.state.tabEnable}
    //           id={id}
    //           type="text"
    //           placeholder=""
    //           value={row.glCode}
    //           onChange={(e) => this.updateState(e, row, "glcode", id)}
    //           autoComplete="off"
    //           //pattern="[+-]?\d+(?:[.,]\d+)?"
    //           maxLength={200}
    //           disabled={false}
    //           title=""
    //         />
    //         {/* {row.glCode}           */}
    //       </div>
    //     );
    //   },
    // },
    {
      dataField: "unit",
      text: "Unit",
      headerStyle: { width: "100px" },
      hidden: true,
      editable: false,
      headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
      formatter: (cell: any, row: any, rowIndex: any) => {
        let id = "txtunit" + rowIndex + "txt";
        let disable = true;
        return (
          <div>
            <Form.Control
              tabIndex={this.state.tabEnable}
              id={id}
              type="text"
              // placeholder="Enter Qty"
              value={row.unit}
              onChange={(e) => this.updateState(e, row, "unit", id)}
              autoComplete="off"
              pattern="[+-]?\d+(?:[.,]\d+)?"
              maxLength={20}
              disabled={false}
              title=""
            />
          </div>
        );
      },
    },

    {
      dataField: "qty",
      text: "Qty",
      headerStyle: { width: "250px" },
      hidden: true,
      editable: false,
      headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
      formatter: (cell: any, row: any, rowIndex: any) => {
        let id = "txtreqqty" + rowIndex + "txt";
        let disable = true;
        return (
          <div>
            <Form.Control
              tabIndex={this.state.tabEnable}
              id={id}
              type="text"
              // placeholder="Enter Qty"
              value={row.qty}
              onChange={(e) => this.updateState(e, row, "qty", id)}
              autoComplete="off"
              pattern="[+-]?\d+(?:[.,]\d+)?"
              maxLength={20}
              disabled={false}
              title=""
            />
          </div>
        );
      },
    },

    {
      dataField: "unitPrice",
      text: "Unit Price",
      headerStyle: { width: "100px" },
      hidden: true,
      editable: false,
      headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
      formatter: (cell: any, row: any, rowIndex: any) => {
        let id = "txtunitPrice" + rowIndex + "txt";
        let disable = true;
        return (
          <div>
            <Form.Control
              tabIndex={this.state.tabEnable}
              id={id}
              type="text"
              // placeholder="Enter Qty"
              value={row.unitPrice}
              onChange={(e) => this.updateState(e, row, "unitPrice", id)}
              onBlur={(e: any) => this.amountBlur(e, rowIndex, "unitPrice", row)}
              onFocus={(e: any) => this.onAmountFocus(e, rowIndex, id, "unitPrice")}
              autoComplete="off"
              pattern="[+-]?\d+(?:[.,]\d+)?"
              maxLength={20}
              disabled={false}
              title=""
            />
          </div>
        );
      },
    },

    {
      dataField: "amount",
      text: "Amount",
      hidden: true,
      headerStyle: { width: "150px" },
      editable: false,
      headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
      formatter: (cell: any, row: any, rowIndex: any) => {
        let id = "txtamount" + rowIndex + "txt";
        let disable = true;
        return (
          <div>
            <Form.Control
              tabIndex={this.state.tabEnable}
              id={id}
              type="text"
              // placeholder="Enter Qty"
              value={Utils.currencyFormat(Number(Utils.removeInvaildCharFromAmount(row.unitPrice)) * row.qty)}
              onChange={(e) => this.updateState(e, row, "amount", id)}
              autoComplete="off"
              pattern="[+-]?\d+(?:[.,]\d+)?"
              maxLength={20}
              disabled={disable}
              title=""
            />
          </div>
        );
      },
    },


  ];

  private templateColumns = [
    {
      dataField: "isSelected",
      text: "",
      headerFormatter: this.icheckselectedalljob,
      classes: "expanding-bar",
      formatter: (cell: any, row: any, rowIndex: any) => {
        // const prevOrderidselected = mainrow.orderid;
        // this.setState({ prevOrderidselected: prevOrderidselected });
        return (
          <div className="d-flex align-items-center txt-bold">
            <OverlayTrigger
              placement="bottom"
              overlay={
                <Tooltip id="toolp">Click to copy this part</Tooltip>
              }
            >
              <a href="#"> 
              <FontAwesomeIcon
                icon={faArrowUp}
                size="xs"
                onClick={(e) =>
                  this.handleRowSelectionCheckJob(
                    e,
                    rowIndex,
                    row,
                    "true"
                  )
                }
              />
              </a>
            </OverlayTrigger>
          </div>
        );
      },
    },
    {
      dataField: "",
      text: "Sr No.",

      hidden: false,
      editable: false,
      headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
      formatter: (cell: any, row: any, rowIndex: any) => {

        return (
          <div>
            {rowIndex + 1}
          </div>
        );
      },
    },
    {
      dataField: "JobNo",
      text: "Job No",

      formatter: (cell: any, row: any, rowIndex: any) => {
        return (
          <EllipsisWithTooltip placement="bottom">
            <Button className="btn-link" onClick={() => this.showSlideOut(row, 'job')}>
              {row.jobNo}
            </Button>
          </EllipsisWithTooltip>
        );
      },
    },

    // {
    //   dataField: 'type',
    //   text: 'Type',
    //   headerStyle: { width: '150px' },
    //   hidden: false,
    //   editable: false,
    //   headerAttrs: (column, colIndex) => (
    //     { 'tabIndex': '-1' }
    //   ),
    //   formatter: (cell: any, row: any, rowIndex: any) => {
    //     let id = "txttype" + rowIndex + "txt";
    //     let disable = false;
    //     return (
    //       <div>
    //         {row.type}
    //       </div>
    //     );



    //   },
    // },

    {
      dataField: "customerPoNumber",
      text: "CO No.",
      hidden: false,
      formatter: (cell: any, row: any, rowIndex: any) => {
        return (
          <EllipsisWithTooltip placement="bottom">
            <Button className="btn-link" onClick={() => this.showSlideOut(row, 'customer')}>
              {row.customerPoNumber}
            </Button>

          </EllipsisWithTooltip>

        );
      },
    },
    {
      dataField: 'tdescription',
      text: 'Description',
      headerStyle: { width: '400px', },
      hidden: false,
      editable: false,
      headerAttrs: (column, colIndex) => (
        { 'tabIndex': '-1' }
      ),

      formatter: (cell: any, row: any, rowIndex: any) => {
        let id = "txtjdescription" + rowIndex + "txt";
        return (
          <div>
            <Form.Control
              tabIndex={this.state.tabEnable}
              id={id}
              type="text"
              // placeholder="Enter Qty"
              value={row.jdescription}
              onChange={(e) => this.handleChange(e, 'jdescription', rowIndex)}
              autoComplete="off"
              //pattern="[+-]?\d+(?:[.,]\d+)?"
              maxLength={500}
              disabled={false}
              title=""
            />
          </div>
        );
      },

    },
    {
      dataField: 'processName',
      text: 'Process',
      headerStyle: { width: '200px' },
      hidden: false,
      editable: false,
      headerAttrs: (column, colIndex) => (
        { 'tabIndex': '-1' }
      ),
      formatter: (cell: any, row: any, rowIndex: any) => {
        return (
          <div>
            {row.processname}
          </div>
        );
      },

    }
    ,
    {
      dataField: 'orderedQty',
      text: 'Qty',
      headerStyle: { width: '100px' },
      hidden: false,
      editable: false,
      headerAttrs: (column, colIndex) => (
        { 'tabIndex': '-1' }
      ),
      formatter: (cell: any, row: any, rowIndex: any) => {
        return (
          <div>
            <Form.Control
              tabIndex={this.state.tabEnable}
              id="txtOrderedQty"
              type="text"
              placeholder="Enter Ordered Qty"
              value={row.qtyOrdered}
              onChange={(event: any) => this.handleChange(event, 'orderedqty', rowIndex)}
              autoComplete="off"

              disabled={false}
              title=""
            />

          </div>
        );
      },

    },
    {
      dataField: 'unitPrice',
      text: 'Unit Price',
      headerStyle: { width: '100px' },
      hidden: false,
      editable: false,
      headerAttrs: (column, colIndex) => (
        { 'tabIndex': '-1' }
      ),
      formatter: (cell: any, row: any, rowIndex: any) => {
        let id = "txtUnitPrice" + rowIndex + "txt";
        return (
          <div>
            <Form.Control
              tabIndex={this.state.tabEnable}
              id={id}
              type="text"
              placeholder="Enter Unit Price"
              value={row.unitPrice}
              onChange={(event: any) => this.handleChange(event, 'unitprice', rowIndex)}
              onBlur={(e: any) => this.amountBlurProcess(e, rowIndex, "unitPrice", row)}
              onFocus={(e: any) => this.onAmountFocusProcess(e, rowIndex, id, "unitPrice")}
              autoComplete="off"

              disabled={false}
              title=""
            />

          </div>
        );
      },

    },
    {
      dataField: 'amount',
      text: 'Amount',
      headerStyle: { width: '150px' },
      hidden: false,
      editable: false,
      headerAttrs: (column, colIndex) => (
        { 'tabIndex': '-1' }
      ),
      formatter: (cell: any, row: any, rowIndex: any) => {
        return (
          <div>
            <Form.Control
              tabIndex={this.state.tabEnable}
              id="txtAmount"
              type="text"
              placeholder="Enter Amount"
              value={Utils.currencyFormat(Number(Utils.removeInvaildCharFromAmount(row.unitPrice)) * row.qtyOrdered)}
              //onChange={(event: any) => this.handleChange(event, 'amount')} 
              autoComplete="off"

              disabled={false}
              title=""
            />

          </div>
        );
      },

    }
  ];

  private itemColumns = [
    {
      dataField: "srno",
      text: "No.",
    },
    {
      dataField: "itemName",
      text: "Item Name",
      headerClasses: "coa",

      headerStyle: { width: "500px" },
      headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),

      formatter: (cell: any, row: any, rowIndex: any) => {
        let btnId = "itemname" + rowIndex + "btn";
        let id = "itemname" + rowIndex + "ddl";
        const defaultitemname = row.defaultitemname;
        let disable = false;
        return (
          // <div className="disabled-area my-class" onClick={(e)=>this.onclickevent(e)}>
          <div
            //  onClick={() => $('#tbltemplate td.reset-expansion-style').css('overflow', 'inherit')}
            style={{ position: 'relative' }}
          >
            <div className="more-action single-select-image dropdown coa-select">

              {this.state.inventoryLoad && <Typeahead

                id={"itemname" + rowIndex + "ddl"}
                inputProps={{
                  className: "rbt-input-main form-control rbt-input form-control form-control itemname" + rowIndex + "ddl",
                  title: defaultitemname,
                  //onClick: () => this.hoverOutEllipsis()
                }}
                options={

                  this.state.inventorydata.filter((ele, ind) => ind === this.state.inventorydata.findIndex(elem => elem.itemname === ele.itemname && ele.itemname !== ""))

                }

                placeholder={"Enter item Name"}

                // labelKey="label"

                renderMenu={(results: any, menuProps) => (
                  <Menu style={{ zIndex: "-1" }}  {...menuProps}>
                    {results.map((result: any, index: any) => (
                      <>
                        {this.state.inventoryLoad}
                        {result.label !== "" && (
                          <MenuItem
                            option={result}
                            position={index}
                          //        onWheel={() => this.hoverOutEllipsis()}
                          >
                            <EllipsisWithTooltip placement="bottom">
                              {result.label}

                            </EllipsisWithTooltip>
                          </MenuItem>
                        )}

                        {result.itemname === "" && (
                          <MenuItem option={result} position={index}></MenuItem>
                        )}
                      </>
                    ))}
                  </Menu>
                )}

                onChange={this.handleSelectedItem.bind(
                  this,
                  1 + "_" + rowIndex + "_" + defaultitemname
                )}
                selected={row.defaultitemname}
                allowNew
                onBlur={this.handleOutsideClick.bind(this, rowIndex)}
              // onKeyDown={this.onTAB.bind(this, "itemname-" + rowIndex.toString() + "ddl", rowIndex)}

              />}


            </div>

            <FaPencilAlt

              onClick={() => this.handleEditClick(rowIndex, row.defaultitemname)}
              style={{
                position: 'absolute',
                right: '10px',
                top: '50%',
                transform: 'translateY(-50%)',
                cursor: 'pointer',
              }}
            />

          </div>
        );
      },
    },
    // {
    //   dataField: "CO#",
    //   text: "CO#",
    //   headerClasses: "coa",
    //   headerStyle: { width: "200px" },
    //   headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),

    //   formatter: (cell: any, row: any, rowIndex: any) => {
    //     let btnId = "itemname" + rowIndex + "btn";
    //     let id = "itemname" + rowIndex + "ddl";
    //     const defaultcustomerPoNumber = row.customerPoNumber;
    //     let disable = false;
    //     return (
    //       <div>
    //         <div className="more-action single-select-image dropdown coa-select">

    //           {/* {this.state.CODetails.length > 0 &&  */}
    //           <Typeahead

    //             id={"itemname" + rowIndex + "ddl"}
    //             inputProps={{
    //               className: "rbt-input-main form-control rbt-input form-control form-control itemname" + rowIndex + "ddl",
    //               title: defaultcustomerPoNumber,
    //             }}
    //             options={this.state.CODetails}

    //             placeholder={""}
    //             renderMenu={(results: any, menuProps) => (
    //               <Menu style={{ zIndex: "-1" }}  {...menuProps}>
    //                 {results.map((result: any, index: any) => (
    //                   <>
    //                     {this.state.CODetails.length > 0}
    //                     {result.label !== "" && (
    //                       <MenuItem
    //                         option={result}
    //                         position={index}
    //                       >
    //                         <EllipsisWithTooltip placement="bottom">
    //                           {result.label}

    //                         </EllipsisWithTooltip>
    //                       </MenuItem>
    //                     )}

    //                     {result.label === "" && (
    //                       <MenuItem option={result} position={index}></MenuItem>
    //                     )}
    //                   </>
    //                 ))}
    //               </Menu>
    //             )}

    //             onChange={this.handleSelectedItem.bind(
    //               this,
    //               6 + "_" + rowIndex + "_" + defaultcustomerPoNumber
    //             )}
    //             selected={row.defaultcustomerPoNumber}
    //             allowNew
    //             // onBlur={this.handleOutsideClickForAdditionalItems.bind(this, rowIndex)}
    //           // onKeyDown={this.onTAB.bind(this, "itemname-" + rowIndex.toString() + "ddl", rowIndex)}

    //           />
    //           {/* } */}

    //         </div>
    //       </div>
    //     );
    //   },
    // },
    // {
    //   dataField: "JO#",
    //   text: "JO#",
    //   editable: true,

    //   editorRenderer: (
    //     editorProps,
    //     value,
    //     row,
    //     column,
    //     rowIndex,
    //     columnIndex
    //   ) => (
    //     <div className="department-filter">

    //         <SearchMultiSelectItems
    //           itemsList={this.state.JODetails}
    //           itemsSelected={this.itemsSelected}
    //           selectedItems={row.selectedIDs}
    //           {...editorProps}
    //           value={value}
    //           placeholder={"Search Job"}
    //         />

    //     </div>
    //   ),
    // },


    {
      dataField: "JO#",
      text: "JO#",
      headerClasses: "coa",
      // headerStyle: { width: "600px" },
      headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),

      formatter: (cell: any, row: any, rowIndex: any) => {
        console.log("jo rowww", row);
        let btnId = "itemname" + rowIndex + "btn";
        let id = "itemname" + rowIndex + "ddl";
        const defaultjobno = row.jobNo;
        let disable = false;

        if (!row.JODetails || row.JODetails.length === 0) {
          return (
            <>
            </>
            //   <DropdownMultiSelect
            //   key={rowIndex}
            //   rowIndex={rowIndex}
            //   data={JODetails}
            //   label="label"
            //   value="value"
            //   placeHolder="Select"
            //   filtertitle="Search..."
            //   updateMultiSelectItem={(selectedItem) =>
            //     this.updateMultiSelectItem(selectedItem, rowIndex, 1)
            //   }
            // />
          );
        }

        return (
          <div className="m-1" style={{ width: "350px" }}>
            {row.JODetails && row.JODetails.length > 0 && (
              <JOMultiSelect
                name="JO"
                key={rowIndex}
                rowIndex={rowIndex}
                data={row.JODetails}
                label="label"
                value="value"
                placeHolder="Select"
                filtertitle="Search..."
                updateMultiSelectItem={(selectedItem) =>
                  this.updateMultiSelectItem(selectedItem, rowIndex, 2)
                }
              />
            )}
          </div>
        );
      },
    },
    // {
    //   dataField: "itemDesc",
    //   text: "Item Description",
    //   headerClasses: "coa",

    //   headerStyle: { width: "400px" },
    //   headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
    //   formatter: (cell: any, row: any, rowIndex: any) => {
    //     let id = "txtitemDesc" + rowIndex + "txt";
    //     return (
    //       <div>
    //         <Form.Control
    //           tabIndex={this.state.tabEnable}
    //           id={id}
    //           type="text"
    //           placeholder="Please enter item details"
    //           value={row.itemDesc}
    //           onChange={(e) => this.updateStateMisc(e, row, "itemDescForMisc", id)}
    //           autoComplete="off"
    //           //pattern="[+-]?\d+(?:[.,]\d+)?"
    //           maxLength={200}
    //           disabled={false}
    //           title=""
    //         />
    //       </div>
    //     );
    //   },
    // },
    ,
    // {
    //   dataField: "glcode",
    //   text: "MS Code",
    //   headerStyle: { width: "150px" },
    //   hidden: false,
    //   editable: false,
    //   headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
    //   formatter: (cell: any, row: any, rowIndex: any) => {
    //     let id = "txtglcode" + rowIndex + "txt";
    //     let disable = false;
    //     return (
    //       <div>
    //         <Form.Control
    //           tabIndex={this.state.tabEnable}
    //           id={id}
    //           type="text"
    //           placeholder="Enter MS Code"
    //           value={row.glCode}
    //           onChange={(e) => this.updateStateMisc(e, row, "glcode", id)}
    //           autoComplete="off"
    //           //onKeyDown={(e: any) => this.onTAB("glcode", rowIndex, e)}
    //           disabled={disable}
    //           title=""
    //         />
    //       </div>
    //     );
    //   },
    // },

    {
      dataField: "qty",
      text: "Qty",
      headerStyle: { width: "250px" },
      hidden: false,
      editable: false,
      headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
      formatter: (cell: any, row: any, rowIndex: any) => {
        let id = "txtreqqty" + rowIndex + "txt";
        let disable = true;
        return (
          <div>
            <Form.Control
              tabIndex={this.state.tabEnable}
              id={id}
              type="text"
              // placeholder="Enter Qty"
              value={row.qty}
              onChange={(e) => this.updateStateMisc(e, row, "qty", id)}
              autoComplete="off"
              pattern="[+-]?\d+(?:[.,]\d+)?"
              maxLength={20}
              disabled={false}
              title=""
            />
          </div>
        );
      },
    },

    {
      dataField: "unitPrice",
      text: "Unit Price",
      headerStyle: { width: "100px" },
      hidden: false,
      editable: false,
      headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
      formatter: (cell: any, row: any, rowIndex: any) => {
        let id = "txtunitPrice" + rowIndex + "txt";
        let disable = true;
        return (
          <div>
            <Form.Control
              tabIndex={this.state.tabEnable}
              id={id}
              type="text"
              // placeholder="Enter Qty"
              value={row.unitPrice}
              onChange={(e) => this.updateStateMisc(e, row, "unitPrice", id)}
              onBlur={(e: any) => this.amountBlurMisc(e, rowIndex, "unitPrice", row)}
              onFocus={(e: any) => this.onAmountFocusMisc(e, rowIndex, id, "unitPrice")}
              autoComplete="off"
              pattern="[+-]?\d+(?:[.,]\d+)?"
              maxLength={20}
              disabled={false}
              title=""
            />
          </div>
        );
      },
    },

    {
      dataField: "amount",
      text: "Amount",

      headerStyle: { width: "150px" },
      hidden: false,
      editable: false,
      headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
      formatter: (cell: any, row: any, rowIndex: any) => {
        let id = "txtamount" + rowIndex + "txt";
        let disable = true;
        return (
          <div>
            <Form.Control
              tabIndex={this.state.tabEnable}
              id={id}
              type="text"
              // placeholder="Enter Qty"
              value={Utils.currencyFormat(Number(Utils.removeInvaildCharFromAmount(row.unitPrice)) * row.qty)}
              onChange={(e) => this.updateStateMisc(e, row, "amount", id)}
              autoComplete="off"
              pattern="[+-]?\d+(?:[.,]\d+)?"
              maxLength={20}
              disabled={disable}
              title=""
            />
          </div>
        );
      },
    },
    {
      dataField: 'Attachment',
      text: '',
      //headerFormatter: this.iconFormatter,
      headerAttrs: (column, colIndex) => (
        { 'tabIndex': '-1' }
      ),
      formatter: (cell: any, row: any, rowIndex: any) => {
        let itemDetailConfirmModalContent = [
          {
            title: "Delete Row",
            desc: "Are you sure you want to delete?",
            cancleAction: "Cancel",
            ActionTrue: "Delete",
          },
        ];
        // if (this.state.misclistByItem.length >= 0 ) {
        //   return (
        //     <div></div>
        //   );
        // }
        // else {
        return (
          <Dropdown className="more-action confirmation-modal" tabIndex={this.state.tabDisable}>
            <Dropdown.Toggle className="btn-outline-primary btn btn-primary more fa-trash" id="dropdown-more-delete" tabIndex={this.state.tabDisable}>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 5.83329C4.53917 5.83329 4.16667 5.83329 4.16667 5.83329V16.6666C4.16667 17.5866 4.91333 18.3333 5.83333 18.3333H14.1667C15.0867 18.3333 15.8333 17.5866 15.8333 16.6666V5.83329C15.8333 5.83329 15.4608 5.83329 15 5.83329H5ZM8.33333 15.8333H6.66667V8.33329H8.33333V15.8333ZM13.3333 15.8333H11.6667V8.33329H13.3333V15.8333ZM13.8483 3.33329L12.5 1.66663H7.5L6.15167 3.33329H2.5V4.99996H6.66667H13.3333H17.5V3.33329H13.8483Z" />
              </svg>
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <ConfirmationModal
                confirmModalContent={itemDetailConfirmModalContent}
                ishandleDeletePosition={this.handleItemDetailDeleteRow.bind(
                  this,
                  row
                )}
              />
            </Dropdown.Menu>
          </Dropdown>
        );
        // }
      },
    },

  ];

  hoverOutEllipsis = () => {
    //$(".tooltip").removeClass("show");
  };


  

  constructor(props: any) {
    super(props);

    this.parentScroll = React.createRef();
    this.customerSearch = React.createRef();
    this.trDate = React.createRef();
    this.fileInputRef = React.createRef();
    this.handleVendorChange = this.handleVendorChange.bind(this);
    this.GetCustomerItems = this.GetCustomerItems.bind(this);
    this.scrollheight = React.createRef();
    this.GetUploadFileList = this.GetUploadFileList.bind(this);
    this.OpenViewer = this.OpenViewer.bind(this);
    this.ChildComment = React.createRef();
    templateColumns: this.templateColumns,
    
      this.state = {
        showPopup1:false,
        showPopup:false,
         unitList:[],
        productJobList:[],
        quotationNo:"",
        confirmPopup:false,
        sentDate:null,
        cancelDate:null,
        isAttachments:true,
        inventoryLoad:false,
        jobLoad:false,
        isQtyValidate:false,
        IsDeleted:true,
        fileSelect:
          "data:application/pdf;base64,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",
        defaultView: "doc-view", 
        bulkSelect: false,
        isprevious: false,
        files: [],
        files1: [],
        savedfiles: [],
        newSelectfiles: [],
        totalCount: 0,
        isOpenViewer: false,
        currentZoom: 0.7,
        fileSize: 5242880,
        moreActionFileUpload1: [
          { name: "Delete", eventKey: "delete" },
          { name: "Download", eventKey: "download" },
          { name: "View", eventKey: "view" },
        ],
        showOptionSelect: this.props.vendororderid == 0 ? true : false,
        qtyConf: true,
        CODetails: [],
        JODetails: [],
        optionss: [],
        processData: [],
        isApproved: false,
        invoiceCreated: false,
        showMailPanel: false,
        ship_via: "",
        showAfterSaveModelPopup: false,
        showCustomerSlideout: false,
        showJobSlideout: false,
        editMode: this.props.vendororderid > 0 ? true : false,
        mailContent: {
          MailTo: '',
          CC: '',
          Message: '',
          subject:''
        },
        CustomerPoNumber: this.props.CustomerPoNumber,
        id: this.props.id,
        productid: this.props.productid,
        partname: this.props.partname,
        partNo: this.props.partNo,
        qtyOrdered: this.props.qtyOrdered,
        itemNo: this.props.itemNo,
        poNumber: this.props.poNumber,
        dueDate: this.props.dueDate,
        jobDesc: this.props.jobDesc,
        selectedCustomer: this.props.selectedCustomer,
        orderdate: this.props.orderdate,
        tabEnable: 0,
        vendororderid: this.props.vendororderid,
        vendorordertype: this.props.vendorordertype,
        orderid: this.props.orderid,
        orderdetailid: 0,
        jobid: 0,
        address: this.props.address,
        customercode: this.props.customercode,
        customerNameLatest: this.props.selectedCustomer,
        jobOrderlistByItem: [],
        misclistByItem: [{
          JODetails: [],
          defaultitemname: [],
          srno: 1,
          itemDesc: '',
          itemNo: "1",
          id: 0,
          glCode: "",
          itemName: "",
          qty: 0,
          unitPrice:Number(Utils.removeInvaildCharFromAmount("0")),
          unit: "",
          jobNo: "",
        }],
        Defaultselected: [],
        options: [],
        additionalMaterialItems: [
          {
            productJobList:[],
            defaultjpartno: [],
             defaultunitname: [],
            partNo: "",
            partid: 0,
            JODetails: [],
            defaultitemname: [],
            defaultjobno: [],
            defaultcustomerPoNumber: [],
            srno: 1,
            itemDesc: '',
            itemNo: "1",
            id: 0,
            glCode: "",
            itemName: "",
            qty: 0,
            unitPrice:Number(Utils.removeInvaildCharFromAmount("0")),
            discount:Number(Utils.removeInvaildCharFromAmount("0")),
            // Utils.currencyFormat(0),
            unit: "",
            jobNo: "",
            jobid: 0,
            notes:""
          }
        ],

        orderlistitem: [],
        transactionsColumns: this.transactionsColumns,
        templateColumns: this.templateColumns,
        itemColumns: this.itemColumns,
        // AdditionalMaterialItemColumns: this.AdditionalMaterialItemColumns,

        orderData: [
          {
            defaultPartname: [],
            id: 0,
            orderID: 0,
            itemNo: 1,
            partname: "",
            partNo: "",
            dueDate: "",
            jobDesc: "",
            qtyOrdered: 0,
            unit: "",
            unitPrice: Number(Utils.removeInvaildCharFromAmount("0")),
            discount: 0,
            total: 0,
            tenantid: 0,
            productid: 0,

          },
          // ,
          // {
          //     // defaultPartname: [],
          //     id: 0, orderID: 0, itemNo: 2, partname: '', partNo: '', dueDate: '', jobDesc: '', qtyOrdered: 0, unit: '', unitPrice: 0, discount: 0, total: 0, tenantid: 0, productid: 0,
          // }
        ],

        jobdetailsdata: [],

        formData: {
          OrderID: 0,
          CustomerID: 0,
          POInitiated: false,
          CustomerName: "",
          CustomerPoNumber: "",
          shippingInstruction: "",
          OrderDate: new Date(Utils.convertUtcToTimezoneFormat(new Date(), currentUtcTime)),
          duedate: new Date(Utils.convertUtcToTimezoneFormat(new Date(), currentUtcTime)),
          ship_via: "",
          refNo:"",
          Address: "",
          firstname: "",
          VendorOrderType: "normal",
          customercode: "",
          Status:this.props.status == 'Cancelled' ? 'Inactive':this.props.status,
          IsEdit: "",
          OrderItems: [],
          Vendor3PartyOrderItems: [],
          VendorOrderItemDetails: [],
          ReceivingData: [],
        },
        itemListdatam: [],
        inventorydata: [],
        jobList: [],
        defaultitemname: [],
        itemdetailsdata: [
          {
            defaultitemname: [],
            itemNo: "1",
            id: 0,
            itemname: "",
            glcode: "",
            description: "",
            itemid: 0,
            stockqty: 0,
            qty: 0,
            orderqty: 0,
            unitPrice: Number(Utils.removeInvaildCharFromAmount("0")),
            unit: "",
          },

        ],
        itemdetailsdatanew: [
          {
            defaultitemname: [],
            srno: 1,
            itemDesc: '',
            itemNo: "1",
            id: 0,
            glCode: "",
            itemName: "",
            qty: 0,
            unitPrice: Number(Utils.removeInvaildCharFromAmount("0")),
            unit: "",
          },

        ],
      };
    this.scrollToBottom = this.scrollToBottom.bind(this);
    this.updatedCommentItem = this.updatedCommentItem.bind(this);
  }

  
  
  _renderMenu = (results, menuProps)  => {
    const items = results.map((result:any, index) => {
      if (result.divider === true) {
        return <li key={index} role="separator" className="divider"/>;
      }
      if (result.header === true) {
        return <li key={index} className="dropdown-header">{result.name}</li>;
      }
      return (
        <MenuItem key={index} option={result} position={index}>
          {result.name}<span className="badge badge-pill badge-primary color-green">{result.title}</span>
        </MenuItem>
      );
    });
    return <Menu {...menuProps}>{items}</Menu>;
  };

  handleChangeBuyer = (event: any) => {
    let Defaultselected: any = [];
    let formData = { ...this.state.formData };
    if (event.length > 0) {


      let objData: any = {};

      objData.id = event[0].id;
      objData.name = event[0].name;
      Defaultselected.push(objData);

      formData.firstname = event[0].name;
    }

    this.setState({ Defaultselected: Defaultselected, formData: formData, isStateChanged: true });

  };

  updateState = (e: any, row: any, type: any, txtID) => {
    if (this != undefined) {
      let isStateChanged = true;
      let start = e.target?.selectionStart;
      let end = e.target?.selectionEnd;



      let jobOrderlistByItem = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.jobOrderlistByItem))
      );

      let misclistByItem = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.misclistByItem))
      );



      if (type === "itemDesc") {
        e.preventDefault();

        let itemRows = jobOrderlistByItem.filter((x) => x.rowId == row.rowId);
        if (itemRows != null && itemRows.length > 0) {
          itemRows.forEach(element => {
            element.itemDesc = e.target.value;
          });
          //jobOrderlistByItem[index].itemName = e.target.value;
        }

        this.setState({ jobOrderlistByItem: jobOrderlistByItem, isStateChanged }, () => {


          $("#tblOrder")
            .find("input[id^='" + txtID + "']")
            .focus();
          let txtdesc = $("#tblOrder").find(
            "input[id^='" + txtID + "']"
          )[0] as any;
          if (txtdesc !== null && txtdesc !== undefined) {
            txtdesc.selectionStart = start;
            txtdesc.selectionEnd = end;
          }
        });
      }
      else if (type === "glcode") {
        e.preventDefault();

        let itemRows = jobOrderlistByItem.filter((x) => x.rowId == row.rowId);
        if (itemRows != null && itemRows.length > 0) {
          itemRows[0].glCode = e.target.value;
        }

        this.setState({ jobOrderlistByItem: jobOrderlistByItem, isStateChanged }, () => {


          $("#tblOrder")
            .find("input[id^='" + txtID + "']")
            .focus();
          let txtdesc = $("#tblOrder").find(
            "input[id^='" + txtID + "']"
          )[0] as any;
          if (txtdesc !== null && txtdesc !== undefined) {
            txtdesc.selectionStart = start;
            txtdesc.selectionEnd = end;
          }
        });
      }
      else if (type === "unitPrice") {
        e.preventDefault();

        let newVal = Utils.removeInvaildCharFromAmount(e.target.value);
        e.target.value = newVal;

        let itemRows = jobOrderlistByItem.filter((x) => x.rowId == row.rowId);
        if (itemRows != null && itemRows.length > 0) {
          itemRows.forEach(element => {
            element.unitPrice = e.target.value;
          });

        }



        this.setState({ jobOrderlistByItem: jobOrderlistByItem, isStateChanged }, () => {
          $("#tblOrder")
            .find("input[id^='" + txtID + "']")
            .focus();
          let txtdesc = $("#tblOrder").find(
            "input[id^='" + txtID + "']"
          )[0] as any;
          if (txtdesc !== null && txtdesc !== undefined) {
            txtdesc.selectionStart = start;
            txtdesc.selectionEnd = end;
          }
        });
      }
      else if (type === "qty") {
        e.preventDefault();

        let newVal = e.target.value.replace(/[^0-9\s]/g, '');
        e.target.value = newVal;

        // let newVal = Utils.removeInvaildCharFromAmount(e.target.value);
        // e.target.value = newVal;

        let itemRows = jobOrderlistByItem.filter((x) => x.rowId == row.rowId);
        if (itemRows != null && itemRows.length > 0) {
          itemRows.forEach(element => {
            element.qty = e.target.value;
          });
          //        jobOrderlistByItem[index].qty = e.target.value;

        }



        this.setState({ jobOrderlistByItem: jobOrderlistByItem, isStateChanged }, () => {
          $("#tblOrder")
            .find("input[id^='" + txtID + "']")
            .focus();
          let txtdesc = $("#tblOrder").find(
            "input[id^='" + txtID + "']"
          )[0] as any;
          if (txtdesc !== null && txtdesc !== undefined) {
            txtdesc.selectionStart = start;
            txtdesc.selectionEnd = end;
          }
        });
      }
      else if (type === "unit") {
        e.preventDefault();

        let newVal = e.target.value.replace(/[^0-9\s]/g, '');
        e.target.value = newVal;

        // let newVal = Utils.removeInvaildCharFromAmount(e.target.value);
        // e.target.value = newVal;

        let itemRows = jobOrderlistByItem.filter((x) => x.rowId == row.rowId);
        if (itemRows != null && itemRows.length > 0) {
          itemRows.forEach(element => {
            element.unit = e.target.value;
          });
          //        jobOrderlistByItem[index].qty = e.target.value;

        }



        this.setState({ jobOrderlistByItem: jobOrderlistByItem, isStateChanged }, () => {
          $("#tblOrder")
            .find("input[id^='" + txtID + "']")
            .focus();
          let txtdesc = $("#tblOrder").find(
            "input[id^='" + txtID + "']"
          )[0] as any;
          if (txtdesc !== null && txtdesc !== undefined) {
            txtdesc.selectionStart = start;
            txtdesc.selectionEnd = end;
          }
        });
      }
        else if (type === "expandqty") {
          e.preventDefault();

          let newVal = e.target.value.replace(/[^0-9\s]/g, '');
          e.target.value = newVal;

          // let newVal = Utils.removeInvaildCharFromAmount(e.target.value);
          // e.target.value = newVal;

          let itemRows = jobOrderlistByItem.filter((x) => x.rowId == row.rowId && x.rowType == 2);
          if (itemRows != null && itemRows.length > 0) {
            itemRows.forEach(element => {
              element.qty = e.target.value;
            });
            //        jobOrderlistByItem[index].qty = e.target.value;

          }



          this.setState({ jobOrderlistByItem: jobOrderlistByItem, isStateChanged }, () => {
            $("#tblCOAchild")
              .find("input[id^='" + txtID + "']")
              .focus();
            let txtdesc = $("#tblCOAchild").find(
              "input[id^='" + txtID + "']"
            )[0] as any;
            if (txtdesc !== null && txtdesc !== undefined) {
              txtdesc.selectionStart = start;
              txtdesc.selectionEnd = end;
            }
          });
        }
    }
  };


  amountBlur = (e, rowIndex, type: any, row: any) => {

    let jobOrderlistByItem = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.jobOrderlistByItem))
    );

    if (e.target.value.includes(".")) {
      const timeArray = e.target.value?.split(".");
      if (timeArray[1].length <= 0) {
        if (type === "unitPrice") {
          let itemRows = jobOrderlistByItem.filter((x) => x.rowId == row.rowId);

          if (itemRows != null && itemRows.length > 0) {
            itemRows.forEach(element => {
              element.unitPrice = Utils.currencyFormat(
                timeArray[0]
              );
            });

          }
        }
      } else {
        if (type === "unitPrice") {
          let itemRows = jobOrderlistByItem.filter((x) => x.rowId == row.rowId);

          if (itemRows != null && itemRows.length > 0) {
            itemRows.forEach(element => {
              element.unitPrice = Utils.currencyFormat(
                e.target.value
              );
            });

          }
        }


      }
      //this.setState({ jobOrderlistByItem });
      this.setState({ jobOrderlistByItem: jobOrderlistByItem }, () => { });
    } else {
      if (type === "unitPrice") {
        let itemRows = jobOrderlistByItem.filter((x) => x.rowId == row.rowId);

        if (itemRows != null && itemRows.length > 0) {
          itemRows.forEach(element => {
            element.unitPrice = e.target.value === ""
              ? ""
              : !isNaN(e.target.value)
                ? Utils.currencyFormat(e.target.value)
                : e.target.value;
          });

        }
      }

      this.setState({ jobOrderlistByItem: jobOrderlistByItem }, () => { });
    }
  };

  onAmountFocus = (e, index, txtID, type: any) => {

    let jobOrderlistByItem = Object.assign([], JSON.parse(JSON.stringify(this.state.jobOrderlistByItem)));
    //let newval = Utils.removecurrencyFormat(e.target.value);
    let start = e.target?.selectionStart;
    let end = e.target?.selectionEnd;
    if (type === "unitPrice") {
      let newVal = Utils.removeInvaildCharFromAmount(e.target.value);
      e.target.value = newVal;
      jobOrderlistByItem[index].unitPrice = e.target.value;

      this.setState({ jobOrderlistByItem }, () => {
        $("#tblOrder")
          .find("input[id^='" + txtID + "']")
          .focus();
        let txtdesc = $("#tblOrder").find(
          "input[id^='" + txtID + "']"
        )[0] as any;
        if (txtdesc !== null && txtdesc !== undefined) {
          txtdesc.selectionStart = start;
          txtdesc.selectionEnd = end;
        }
      });
    }

    if (type === "discount") {
      let newVal = Utils.removeInvaildCharFromAmount(e.target.value);
      e.target.value = newVal;
      jobOrderlistByItem[index].discount = e.target.value;

      this.setState({ jobOrderlistByItem }, () => {
        $("#tblOrder")
          .find("input[id^='" + txtID + "']")
          .focus();
        let txtdesc = $("#tblOrder").find(
          "input[id^='" + txtID + "']"
        )[0] as any;
        if (txtdesc !== null && txtdesc !== undefined) {
          txtdesc.selectionStart = start;
          txtdesc.selectionEnd = end;
        }
      });
    }


  };

  updateStateMisc = (e: any, row: any, type: any, txtID) => {
    if (this != undefined) {
      let isStateChanged = true;
      let start = e.target?.selectionStart;
      let end = e.target?.selectionEnd;


      let misclistByItem = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.misclistByItem))
      );



      if (type === "itemDescForMisc") {
        e.preventDefault();
        let itemRows = misclistByItem.filter((x) => x.srno == row.srno);
        if (itemRows != null && itemRows.length > 0) {
          itemRows[0].itemDesc = e.target.value;
        }

        this.setState({ misclistByItem: misclistByItem, isStateChanged }, () => {


          $("#tbltemplate")
            .find("input[id^='" + txtID + "']")
            .focus();
          let txtdesc = $("#tbltemplate").find(
            "input[id^='" + txtID + "']"
          )[0] as any;
          if (txtdesc !== null && txtdesc !== undefined) {
            txtdesc.selectionStart = start;
            txtdesc.selectionEnd = end;
          }
        });
      }
      else if (type === "glcode") {
        e.preventDefault();

        let itemRows = misclistByItem.filter((x) => x.srno == row.srno);
        if (itemRows != null && itemRows.length > 0) {
          itemRows[0].glCode = e.target.value;
        }

        this.setState({ misclistByItem: misclistByItem, isStateChanged }, () => {


          $("#tbltemplate")
            .find("input[id^='" + txtID + "']")
            .focus();
          let txtdesc = $("#tbltemplate").find(
            "input[id^='" + txtID + "']"
          )[0] as any;
          if (txtdesc !== null && txtdesc !== undefined) {
            txtdesc.selectionStart = start;
            txtdesc.selectionEnd = end;
          }
        });
      }
      else if (type === "unitPrice") {
        e.preventDefault();

        let newVal = Utils.removeInvaildCharFromAmount(e.target.value);
        e.target.value = newVal;

        let itemRows = misclistByItem.filter((x) => x.srno == row.srno);
        if (itemRows != null && itemRows.length > 0) {
          itemRows[0].unitPrice = e.target.value;
        }



        this.setState({ misclistByItem: misclistByItem, isStateChanged }, () => {
          $("#tbltemplate")
            .find("input[id^='" + txtID + "']")
            .focus();
          let txtdesc = $("#tbltemplate").find(
            "input[id^='" + txtID + "']"
          )[0] as any;
          if (txtdesc !== null && txtdesc !== undefined) {
            txtdesc.selectionStart = start;
            txtdesc.selectionEnd = end;
          }
        });
      }
      else if (type === "qty") {
        e.preventDefault();

        let newVal = e.target.value.replace(/[^0-9\s]/g, '');
        e.target.value = newVal;
        // let newVal = Utils.removeInvaildCharFromAmount(e.target.value);
        // e.target.value = newVal;

        let itemRows = misclistByItem.filter((x) => x.srno == row.srno);
        if (itemRows != null && itemRows.length > 0) {
          itemRows[0].qty = e.target.value;
        }



        this.setState({ misclistByItem: misclistByItem, isStateChanged }, () => {
          $("#tbltemplate")
            .find("input[id^='" + txtID + "']")
            .focus();
          let txtdesc = $("#tbltemplate").find(
            "input[id^='" + txtID + "']"
          )[0] as any;
          if (txtdesc !== null && txtdesc !== undefined) {
            txtdesc.selectionStart = start;
            txtdesc.selectionEnd = end;
          }
        });
      }
    }
  };

  amountBlurMisc = (e, rowIndex, type: any, row: any) => {

    let misclistByItem = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.misclistByItem))
    );

    if (e.target.value.includes(".")) {
      const timeArray = e.target.value?.split(".");
      if (timeArray[1].length <= 0) {
        if (type === "unitPrice") {

          let itemRows = misclistByItem.filter((x) => x.srno == row.srno);
          if (itemRows != null && itemRows.length > 0) {
            itemRows[0].unitPrice = Utils.currencyFormat(
              timeArray[0]
            );
          }
        }
      } else {
        if (type === "unitPrice") {



          let itemRows = misclistByItem.filter((x) => x.srno == row.srno);
          if (itemRows != null && itemRows.length > 0) {
            itemRows[0].unitPrice = Utils.currencyFormat(
              e.target.value
            );
          }
        }


      }
      //this.setState({ misclistByItem });
      this.setState({ misclistByItem: misclistByItem }, () => { });
    } else {
      if (type === "unitPrice") {

        let itemRows = misclistByItem.filter((x) => x.srno == row.srno);
        if (itemRows != null && itemRows.length > 0) {
          itemRows[0].unitPrice = e.target.value === ""
            ? ""
            : !isNaN(e.target.value)
              ? Utils.currencyFormat(e.target.value)
              : e.target.value;
        }
      }

      this.setState({ misclistByItem: misclistByItem }, () => { });
    }
  };

    handleType = (selectedId: any) => {
      const masg = "You have unsaved data. Are you sure you want to leave this tab? Your current data will be reset.";
      if (
        (this.state.additionalMaterialItems.length === 1 && this.state.additionalMaterialItems[0].id === 0 && this.state.additionalMaterialItems[0].defaultitemname.length === 0)
        // ||
        // (this.state.misclistByItem.length === 1 && this.state.misclistByItem[0].id === 0 && this.state.misclistByItem[0].defaultitemname.length === 0)
      ) {
        this.setState({ vendorordertype: selectedId, showSection: false });
      }
      else {
        confirmAlert({
          title: "Unsaved Data !",
          message: masg,
          buttons: [
            {
              label: "Confirm",
              onClick: () => {
                let JODetails1 = Object.assign([], JSON.parse(JSON.stringify(this.state.JODetails)));
                const additionalMaterialItems = [{
                  defaultitemname: [],
                  defaultjobno: [],
                  defaultcustomerPoNumber: [],
                  srno: 1,
                  itemDesc: '',
                  itemNo: "1",
                  id: 0,
                  glCode: "",
                  itemName: "",
                  qty: 0,
                  unitPrice: Number(Utils.removeInvaildCharFromAmount("0")),
                  unit: 0,
                  jobNo: "",
                  jobid: 0,
                  JODetails:JODetails1
                }];

            

                this.setState({ vendorordertype: selectedId, additionalMaterialItems, showSection: false });
              },
            },
            {
              label: "Discard",
              onClick: () => reject(),
            },
          ],
          closeOnEscape: false,
          closeOnClickOutside: false,
        });
      }
    };



  onAmountFocusMisc = (e, index, txtID, type: any) => {


    let misclistByItem = Object.assign([], JSON.parse(JSON.stringify(this.state.misclistByItem)));
    //let newval = Utils.removecurrencyFormat(e.target.value);
    let start = e.target?.selectionStart;
    let end = e.target?.selectionEnd;
    if (type === "unitPrice") {
      let newVal = Utils.removeInvaildCharFromAmount(e.target.value);
      e.target.value = newVal;
      misclistByItem[index].unitPrice = e.target.value;

      this.setState({ misclistByItem }, () => {
        $("#tbltemplate")
          .find("input[id^='" + txtID + "']")
          .focus();
        let txtdesc = $("#tbltemplate").find(
          "input[id^='" + txtID + "']"
        )[0] as any;
        if (txtdesc !== null && txtdesc !== undefined) {
          txtdesc.selectionStart = start;
          txtdesc.selectionEnd = end;
        }
      });
    }
  };

  updateStateAdditionalItems = (e: any, row: any, type: any, txtID) => {
    if (this != undefined) {
      let isStateChanged = true;
      let start = e.target?.selectionStart;
      let end = e.target?.selectionEnd;


      let additionalMaterialItems = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.additionalMaterialItems))
      );



      if (type === "itemDesc") {
        e.preventDefault();
        let itemRows = additionalMaterialItems.filter((x) => x.srno == row.srno);
        if (itemRows != null && itemRows.length > 0) {
          itemRows[0].itemDesc = e.target.value;
        }

        this.setState({ additionalMaterialItems: additionalMaterialItems, isStateChanged }, () => {


          $("#tblAdditionalMaterialItems")
            .find("input[id^='" + txtID + "']")
            .focus();
          let txtdesc = $("#tblAdditionalMaterialItems").find(
            "input[id^='" + txtID + "']"
          )[0] as any;
          if (txtdesc !== null && txtdesc !== undefined) {
            txtdesc.selectionStart = start;
            txtdesc.selectionEnd = end;
          }
        });
      }
      else if (type === "glcode") {
        e.preventDefault();
        let itemRows = additionalMaterialItems.filter((x) => x.srno == row.srno);
        if (itemRows != null && itemRows.length > 0) {
          itemRows[0].glCode = e.target.value;
        }

        this.setState({ additionalMaterialItems: additionalMaterialItems, isStateChanged }, () => {


          $("#tblAdditionalMaterialItems")
            .find("input[id^='" + txtID + "']")
            .focus();
          let txtdesc = $("#tblAdditionalMaterialItems").find(
            "input[id^='" + txtID + "']"
          )[0] as any;
          if (txtdesc !== null && txtdesc !== undefined) {
            txtdesc.selectionStart = start;
            txtdesc.selectionEnd = end;
          }
        });
      }
      else if (type === "unitPrice") {
        e.preventDefault();

        let newVal = Utils.removeInvaildCharFromAmount(e.target.value);
        e.target.value = newVal;

        let itemRows = additionalMaterialItems.filter((x) => x.srno == row.srno);
        if (itemRows != null && itemRows.length > 0) {
          itemRows[0].unitPrice = e.target.value;
        }



        this.setState({ additionalMaterialItems: additionalMaterialItems, isStateChanged }, () => {
          $("#tblAdditionalMaterialItems")
            .find("input[id^='" + txtID + "']")
            .focus();
          let txtdesc = $("#tblAdditionalMaterialItems").find(
            "input[id^='" + txtID + "']"
          )[0] as any;
          if (txtdesc !== null && txtdesc !== undefined) {
            txtdesc.selectionStart = start;
            txtdesc.selectionEnd = end;
          }
        });
      }else if (type === "discount") {
        e.preventDefault();

        let newVal = Utils.removeInvaildCharFromAmount(e.target.value);
        e.target.value = newVal;

        let itemRows = additionalMaterialItems.filter((x) => x.srno == row.srno);
        if (itemRows != null && itemRows.length > 0) {
          itemRows[0].discount = e.target.value;
        }



        this.setState({ additionalMaterialItems: additionalMaterialItems, isStateChanged }, () => {
          $("#tblAdditionalMaterialItems")
            .find("input[id^='" + txtID + "']")
            .focus();
          let txtdesc = $("#tblAdditionalMaterialItems").find(
            "input[id^='" + txtID + "']"
          )[0] as any;
          if (txtdesc !== null && txtdesc !== undefined) {
            txtdesc.selectionStart = start;
            txtdesc.selectionEnd = end;
          }
        });
      }
      else if (type === "qty") {
        e.preventDefault();
        let newVal = e.target.value.replace(/[^0-9\s]/g, '');
        e.target.value = newVal;
        //let newVal = Utils.removeInvaildCharFromAmount(e.target.value);
        // e.target.value = newVal;

        let itemRows = additionalMaterialItems.filter((x) => x.srno == row.srno);
        if (itemRows != null && itemRows.length > 0) {
          itemRows[0].qty = e.target.value;
        }



        this.setState({ additionalMaterialItems: additionalMaterialItems, isStateChanged }, () => {
          $("#tblAdditionalMaterialItems")
            .find("input[id^='" + txtID + "']")
            .focus();
          let txtdesc = $("#tblAdditionalMaterialItems").find(
            "input[id^='" + txtID + "']"
          )[0] as any;
          if (txtdesc !== null && txtdesc !== undefined) {
            txtdesc.selectionStart = start;
            txtdesc.selectionEnd = end;
          }
        });
      }
    //     else if (type === "qty") {
    //     e.preventDefault();
    //     const updateQuantityAndFocus = (newVal) => {

    //         let itemRows = additionalMaterialItems.filter((x) => x.srno == row.srno);
    //         if (itemRows != null && itemRows.length > 0) {
    //             itemRows[0].qty = newVal; 
    //         }
    
    //         this.setState({ additionalMaterialItems: additionalMaterialItems, isStateChanged }, () => {
    //           $("#tblAdditionalMaterialItems")
    //             .find("input[id^='" + txtID + "']")
    //             .focus();
    //           let txtdesc = $("#tblAdditionalMaterialItems").find(
    //             "input[id^='" + txtID + "']"
    //           )[0] as any;
    //           if (txtdesc !== null && txtdesc !== undefined) {
    //             txtdesc.selectionStart = start;
    //             txtdesc.selectionEnd = end;
    //           }
    //         });
    //       };

    //       if ((this.props.receivedStatus === 'Completed') && this.state.qtyConf) {
    //         confirmAlert({
    //             title: "Confirm Quantity Update",
    //             message: "If you update the quantity, the status will revert to its previous value. Do you wish to continue?",
    //             buttons: [
    //                 {
    //                     label: "Confirm",
    //                     onClick: () => {
    //                         // let newVal = e.target.value.replace(/[^0-9\s]/g, ''); 
    //                         // e.target.value = newVal;
    //                         // updateQuantityAndFocus(newVal);
    //                         this.setState({ qtyConf:false}, () => {
    //                           $("#tblAdditionalMaterialItems")
    //                             .find("input[id^='" + txtID + "']")
    //                             .focus();
                              
    //                         });
    //                     },
    //                 },
    //                 {
    //                     label: "Discard",
    //                     onClick: () => {
    //                     return;
    //                     }
    //                 },
    //             ],
    //             closeOnEscape: false,
    //             closeOnClickOutside: false,
    //         });
    //       }else {
    //         let newVal = e.target.value.replace(/[^0-9\s]/g, ''); 
    //         e.target.value = newVal;
    //         updateQuantityAndFocus(newVal);
    //     };
    // }    
      else if (type === "unit") {
        e.preventDefault();
        let newVal = e.target.value.replace(/[^0-9\s]/g, '');
        e.target.value = newVal;
        //let newVal = Utils.removeInvaildCharFromAmount(e.target.value);
        // e.target.value = newVal;

        let itemRows = additionalMaterialItems.filter((x) => x.srno == row.srno);
        if (itemRows != null && itemRows.length > 0) {
          itemRows[0].unit = e.target.value;
        }



        this.setState({ additionalMaterialItems: additionalMaterialItems, isStateChanged }, () => {
          $("#tblAdditionalMaterialItems")
            .find("input[id^='" + txtID + "']")
            .focus();
          let txtdesc = $("#tblAdditionalMaterialItems").find(
            "input[id^='" + txtID + "']"
          )[0] as any;
          if (txtdesc !== null && txtdesc !== undefined) {
            txtdesc.selectionStart = start;
            txtdesc.selectionEnd = end;
          }
        });
      }
    }
  };

  amountBlurAdditionalItems = (e, rowIndex, type: any, row: any) => {

    let additionalMaterialItems = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.additionalMaterialItems))
    );

    if (e.target.value.includes(".")) {
      const timeArray = e.target.value?.split(".");
      if (timeArray[1].length <= 0) {
        if (type === "unitPrice") {

          let itemRows = additionalMaterialItems.filter((x) => x.srno == row.srno);
          if (itemRows != null && itemRows.length > 0) {
            itemRows[0].unitPrice = Utils.currencyFormat(
              timeArray[0]
            );
          }
        } else if (type === "discount") {

          let itemRows = additionalMaterialItems.filter((x) => x.srno == row.srno);
          if (itemRows != null && itemRows.length > 0) {
            itemRows[0].discount = Utils.currencyFormat(
              timeArray[0]
            );
          }
        }
      } else {
        if (type === "unitPrice") {



          let itemRows = additionalMaterialItems.filter((x) => x.srno == row.srno);
          if (itemRows != null && itemRows.length > 0) {
            itemRows[0].unitPrice = Utils.currencyFormat(
              e.target.value
            );
          }
        }else if (type === "discount") {



          let itemRows = additionalMaterialItems.filter((x) => x.srno == row.srno);
          if (itemRows != null && itemRows.length > 0) {
            itemRows[0].discount = Utils.currencyFormat(
              e.target.value
            );
          }
        }


      }
      //this.setState({ additionalMaterialItems });
      this.setState({ additionalMaterialItems: additionalMaterialItems }, () => { });
    } else {
      if (type === "unitPrice") {

        let itemRows = additionalMaterialItems.filter((x) => x.srno == row.srno);
        if (itemRows != null && itemRows.length > 0) {
          itemRows[0].unitPrice = e.target.value === ""
            ? ""
            : !isNaN(e.target.value)
              ? Utils.currencyFormat(e.target.value)
              : e.target.value;
        }
      }else  if (type === "discount") {

        let itemRows = additionalMaterialItems.filter((x) => x.srno == row.srno);
        if (itemRows != null && itemRows.length > 0) {
          itemRows[0].discount = e.target.value === ""
            ? ""
            : !isNaN(e.target.value)
              ? Utils.currencyFormat(e.target.value)
              : e.target.value;
        }
      }

      this.setState({ additionalMaterialItems: additionalMaterialItems }, () => { });
    }
  };


  updateMultiSelectItem = (selectedItem: any, rowIndex: any, controlId: any) => {

    let additionalMaterialItems = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.additionalMaterialItems))
    );
    let misclistByItem = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.misclistByItem))
    );
    let JODetails = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.JODetails))
    );
     let productJobList = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.productJobList))
    );

     const isProcess = this.state.vendorordertype === "Process";

    if (controlId === 1) {
      console.log("slected job handle", selectedItem,rowIndex, additionalMaterialItems[rowIndex]);
      additionalMaterialItems[rowIndex].defaultjobno = selectedItem;
      const materialItem = additionalMaterialItems[rowIndex];
      materialItem.selectedPartIDs = materialItem.selectedPartIDs || [];
      materialItem.productJobList = materialItem.productJobList || [];
      const jobIds = selectedItem.map(item => item.jobid).join(',');
      const labels = selectedItem.map(item => item.label).join(',');
      const selectedids = selectedItem.map((item, index) => ({
        id: index,
        jobid: item.jobid,
        jobno: item.value
      }));

      selectedItem.forEach(selectedElement => {
        JODetails.forEach(jobDetail => {
          if (jobDetail.jobid === selectedElement.jobid) {
            jobDetail.isChecked = true;
             if (jobDetail.partid) {
                    if (!materialItem.selectedPartIDs.includes(jobDetail.partid)) {
                        materialItem.selectedPartIDs.push(jobDetail.partid);
                    }
                }
          }
        });
          materialItem.productJobList.forEach(pj => {
            if (pj.partid && pj.partid === selectedElement.partid) {
                pj.isChecked = true;
            }
        });
      });

      if(selectedItem[0].itemname !== null && selectedItem[0].itemid !== null && this.state.vendorordertype === "Material" ){
        console.log("selectedItem.itemname",selectedItem[0].itemname);
        const latestIndex = selectedItem.findLastIndex(item => item?.itemname);
        let defaultitemname: any = [];
        additionalMaterialItems[rowIndex].itemName = selectedItem[latestIndex].itemname;
        additionalMaterialItems[rowIndex].itemNo = selectedItem[latestIndex].itemid;
        additionalMaterialItems[rowIndex].glCode = "";
        additionalMaterialItems[rowIndex].itemDesc = "";

        let objPartname: any = {};
        objPartname.itemName = selectedItem[latestIndex].itemname;
        objPartname.label = selectedItem[latestIndex].itemname;
        objPartname.id = selectedItem[latestIndex].itemid;
        objPartname.glCode = "";
        objPartname.qty = 0;
        objPartname.unitPrice = 0;
        objPartname.unit = 0;
        objPartname.tenantid = 0;
        objPartname.itemDesc = 0;
        defaultitemname.push(objPartname);
        additionalMaterialItems[rowIndex].defaultitemname = defaultitemname;
      }

       if (isProcess && selectedItem.length > 0 && additionalMaterialItems[rowIndex].defaultitemname.length > 0) {
      const jobid = selectedItem[0].jobid;
      const itemNo = additionalMaterialItems[rowIndex].itemNo || additionalMaterialItems[0].productId;

      VendorService.GetJobDescription({ processid: itemNo, jobid: jobid })
          .then((result: any) => {
            if (result && result !== "") {
              additionalMaterialItems[rowIndex].defaultitemname[0].itemDesc = result;
              additionalMaterialItems[rowIndex].itemDesc = result;

            }
          })
          .catch((err: any) => {
            console.error("Error fetching job description", err);
          });
          }else{
            if(selectedItem && selectedItem.length > 0){
              const itemWithDesc = selectedItem.find(
                item => item.materialDesc && item.materialDesc.trim() != ""
              );

           if (itemWithDesc) {
            additionalMaterialItems[rowIndex].defaultitemname[0].itemDesc = itemWithDesc.materialDesc;
            additionalMaterialItems[rowIndex].itemDesc = itemWithDesc.materialDesc;
            }
          }
          }

      additionalMaterialItems[rowIndex].JODetails = JODetails;
      additionalMaterialItems[rowIndex].selectedIDs = selectedids;
      additionalMaterialItems[rowIndex].jobNo = labels;
      additionalMaterialItems[rowIndex].jobId = jobIds;

      //  this.setState(
      // { additionalMaterialItems, misclistByItem, isStateChanged: true });
         this.setState(
      { additionalMaterialItems:[], isStateChanged: true },
      () => {
 this.setState(
      { additionalMaterialItems:additionalMaterialItems});
      });

    } 
    else if (controlId === 2) {
       const selectedPartIDs = selectedItem.map(item => ({
        partid: item.partid,
        jobid: item.jobid
      }));

      selectedItem.forEach(selectedElement => {
        productJobList.forEach(jobDetail => {
          if (jobDetail.id === selectedElement.id) {
            jobDetail.isChecked = true;
          }
        });
      });

        if((!additionalMaterialItems[rowIndex].itemName || additionalMaterialItems[rowIndex].itemName == "") && selectedItem[0].itemname !== null && selectedItem[0].itemid !== null && this.state.vendorordertype === "Material" ){
        const latestIndex = selectedItem.findLastIndex(item => item?.itemname);
        let defaultitemname: any = [];
        additionalMaterialItems[rowIndex].itemName = selectedItem[latestIndex].itemname;
        additionalMaterialItems[rowIndex].itemNo = selectedItem[latestIndex].itemid;
        additionalMaterialItems[rowIndex].glCode = "";
        additionalMaterialItems[rowIndex].itemDesc = "";

        let objPartname: any = {};
        objPartname.itemName = selectedItem[latestIndex].itemname;
        objPartname.label = selectedItem[latestIndex].itemname;
        objPartname.id = selectedItem[latestIndex].itemid;
        objPartname.glCode = "";
        objPartname.qty = 0;
        objPartname.unitPrice = 0;
        objPartname.unit = 0;
        objPartname.tenantid = 0;
        objPartname.itemDesc = selectedItem[latestIndex].materialDesc;
        defaultitemname.push(objPartname);

            
        additionalMaterialItems[rowIndex].itemDesc = selectedItem[latestIndex].materialDesc;
        additionalMaterialItems[rowIndex].defaultitemname = defaultitemname;
      }

       if (isProcess && selectedItem.length > 0 && additionalMaterialItems[rowIndex].defaultitemname.length > 0) {
            const jobid = selectedItem[0].jobid;
            const itemNo = additionalMaterialItems[rowIndex].itemNo || additionalMaterialItems[0].productId;
      
            VendorService.GetJobDescription({ processid: itemNo, jobid: jobid })
                .then((result: any) => {
                  if (result && result !== "") {
                    additionalMaterialItems[rowIndex].defaultitemname[0].itemDesc = result;
                    additionalMaterialItems[rowIndex].itemDesc = result;
      
                  }
                })
                .catch((err: any) => {
                  console.error("Error fetching job description", err);
                });
                }else{
                  if(selectedItem && selectedItem.length > 0){
                    const itemWithDesc = selectedItem.find(
                      item => item.materialDesc && item.materialDesc.trim() != ""
                    );
      
                 if (itemWithDesc) {
                  additionalMaterialItems[rowIndex].defaultitemname[0].itemDesc = itemWithDesc.materialDesc;
                  additionalMaterialItems[rowIndex].itemDesc = itemWithDesc.materialDesc;
                  }
                }
                }

      additionalMaterialItems[rowIndex].productJobList = productJobList;
      additionalMaterialItems[rowIndex].selectedPartIDs = selectedPartIDs;

      
 this.setState(
      { additionalMaterialItems:additionalMaterialItems});

    } 
//     else if (controlId === 2) {
//       const previousPartIds = new Set(additionalMaterialItems[rowIndex].selectedPartIDs || []);
//       const partIds = selectedItem.map(item => item.partid);
//       const jodetails = additionalMaterialItems[rowIndex].JODetails || [];
//       const latestPartIds = partIds.filter(pid => !previousPartIds.has(pid));
//       const latestPartIdSet = new Set(latestPartIds);

//       selectedItem.forEach(selectedElement => {
//         productJobList.forEach(jobDetail => {
//           if (jobDetail.partid === selectedElement.partid) {
//             jobDetail.isChecked = true;
//           }
//         });
//       });

//       if (partIds.length > previousPartIds.size) {
//             jodetails.forEach(jobDetail => {
//         if (latestPartIdSet.has(jobDetail.partid)) {
//           jobDetail.isChecked = true;  
//         }
//       });
//       }
   
//        const selectedIDs = jodetails
//       .filter(jo => jo.isChecked)
//       .map((jo, index) => ({
//         id: index,
//         jobid: jo.jobid,
//         jobno: jo.value, 
//       }));

//       additionalMaterialItems[rowIndex].selectedIDs = selectedIDs;
//       additionalMaterialItems[rowIndex].productJobList = productJobList;
//       additionalMaterialItems[rowIndex].JODetails = jodetails;
//       additionalMaterialItems[rowIndex].selectedPartIDs = partIds;

//       this.setState(
//       { additionalMaterialItems:[], misclistByItem, isStateChanged: true },
//       () => {
//  this.setState(
//       { additionalMaterialItems:additionalMaterialItems});
//       });

//     } 
    else {
      misclistByItem[rowIndex].defaultjobno = selectedItem;
      const jobIds = selectedItem.map(item => item.jobid).join(',');
      const labels = selectedItem.map(item => item.label).join(',');
      const selectedids = selectedItem.map((item, index) => ({
        id: index,
        jobid: item.jobid,
        jobno: item.value
      }));
      selectedItem.forEach(selectedElement => {
        JODetails.forEach(jobDetail => {
          if (jobDetail.jobid === selectedElement.jobid) {
            jobDetail.isChecked = true;
          }
        });
      });
      misclistByItem[rowIndex].JODetails = JODetails;
      misclistByItem[rowIndex].selectedIDs = selectedids;
      console.log("selexted 2", misclistByItem[rowIndex], selectedids);

      misclistByItem[rowIndex].jobNo = labels;
      misclistByItem[rowIndex].jobId = jobIds;

    }

    // this.setState(
    //   { additionalMaterialItems, misclistByItem, isStateChanged: true });

  };

  onAmountFocusAdditionalItems = (e, index, txtID, type: any) => {


    let additionalMaterialItems = Object.assign([], JSON.parse(JSON.stringify(this.state.additionalMaterialItems)));
    //let newval = Utils.removecurrencyFormat(e.target.value);
    let start = e.target?.selectionStart;
    let end = e.target?.selectionEnd;
    if (type === "unitPrice") {
      let newVal = Utils.removeInvaildCharFromAmount(e.target.value);
      e.target.value = newVal;
      additionalMaterialItems[index].unitPrice = e.target.value;

      this.setState({ additionalMaterialItems }, () => {
        $("#tblAdditionalMaterialItems")
          .find("input[id^='" + txtID + "']")
          .focus();
        let txtdesc = $("#tblAdditionalMaterialItems").find(
          "input[id^='" + txtID + "']"
        )[0] as any;
        if (txtdesc !== null && txtdesc !== undefined) {
          txtdesc.selectionStart = start;
          txtdesc.selectionEnd = end;
        }
      });
    }else  if (type === "discount") {
      let newVal = Utils.removeInvaildCharFromAmount(e.target.value);
      e.target.value = newVal;
      additionalMaterialItems[index].discount = e.target.value;

      this.setState({ additionalMaterialItems }, () => {
        $("#tblAdditionalMaterialItems")
          .find("input[id^='" + txtID + "']")
          .focus();
        let txtdesc = $("#tblAdditionalMaterialItems").find(
          "input[id^='" + txtID + "']"
        )[0] as any;
        if (txtdesc !== null && txtdesc !== undefined) {
          txtdesc.selectionStart = start;
          txtdesc.selectionEnd = end;
        }
      });
    }
  };





  closeSlideOut = () => {
    this.props.closeSlideOut(this.state?.shouldReloadMainPage);
  };

  closeCustomerSlideout = () => {
    this.setState({ showCustomerSlideout: false, isSpinner: false, });
    this.onLoadData();
    this.GetorderEntryColoumn();
  };

  closeJobSlideout = () => {
    this.setState({ showJobSlideout: false, isSpinner: false, });
    this.onLoadData();
    this.GetorderEntryColoumn();
  };

  closeSlideOut2 = () => {
    this.setState({ showjobrModal: false, isSpinner: false, });
  };





  beforeunload(e: { preventDefault: () => void; returnValue: boolean }) {
    if (
      this.state.isStateChanged &&
      routeLeavingGuard !== "routeLeavingGuardTrue"
    ) {
      e.preventDefault();
      e.returnValue = true;
    }
  }

  routeLeavingGuardConfirm = (childState: any) => {
    if (childState === true) {
      routeLeavingGuard = "routeLeavingGuardTrue";
    } else {
      routeLeavingGuard = null;
    }
  };

  componentDidMount() {
     this.GetUnits();
    // this.GetJoblist();
    this.GetorderEntryColoumn();
    this.GetProductlist({});
    // this.getJoblist();
    this.onLoadData();
    // this.GetorderEntryColoumn();
    this.GetCustomerItems();
    this.getprocessMaster();

    // if (this.customerSearch.current) {
    //   this.customerSearch.current.focus();
    // }

  }

  componentDidUpdate(prevProps) {
    if (prevProps.locationId != this.props.locationId) {
      this.closeSlideOut();
    }
  }

  //  GetProductlist = (requestlist: any) => {  
  //  requestlist.customerid = 0;
  //     ProductService.GetProductOrderlist(requestlist)
  //       .then(async (result: any | null) => {
  //         if (result !== null) {
  //            result.forEach((element) => {
  //           let item: any = {};
  //           item.value = element.partno + " | " + element.partname;
  //           item.label = element.partno + " | " + element.partname;
  //           item.partid = element.id;
  //           item.isChecked = false;
  //           this.state.productJobList.push(item);
  //         });

  //         if (this.state.vendororderid === 0 || this.state.vendororderid == undefined) {
  //           let JODetails1 = Object.assign([], JSON.parse(JSON.stringify(this.state.productJobList)));

  //           const newItems = [...this.state.additionalMaterialItems];
  //           newItems[0] = {
  //             ...newItems[0],
  //             productJobList: JODetails1
  //           };

  //           this.setState({ additionalMaterialItems: newItems });
  //         }

  //         }
  //         resolve();
  //       })
  //       .catch((error) => {
  //         this.setState({ isSpinner: false });
  //         reject();
  //       }).finally(()=>{
  //                    this.GetItemlist();
  //     });
  //   };
  
GetProductlist = (requestlist: any) => {  
   
      VendorService.GetProductJobMapping(requestlist)
        .then(async (result: any | null) => {
          if (result !== null) {

             result.forEach((element) => {
          let item: any = {};

          let parts = [element.partno];

          if (element.jobno) {  
            parts.push(element.jobno);  
          }

          parts.push(element.partname);

          let combined = parts.join(" | ");

          item.value = element.rowid;
          item.label = combined;

          item.partid = element.partid;
          item.jobid = element.jobid;
          item.id = element.rowid;
          item.itemid = element.itemid;
          item.itemname = element.itemname;
          item.materialDesc = element.materialDesc || "";
          item.isChecked = false;

          this.state.productJobList.push(item);
        });

          if (this.state.vendororderid === 0 || this.state.vendororderid == undefined) {
            let JODetails1 = Object.assign([], JSON.parse(JSON.stringify(this.state.productJobList)));

            const newItems = [...this.state.additionalMaterialItems];
            newItems[0] = {
              ...newItems[0],
              productJobList: JODetails1
            };

            this.setState({ additionalMaterialItems: newItems });
          }

          }
          resolve();
        })
        .catch((error) => {
          this.setState({ isSpinner: false });
          reject();
        }).finally(()=>{
                     this.GetItemlist();
      });
    };
  

  getprocessMaster = () => {
    PartTemplateService.GetProcessListAll({})
      .then(async (result: any[] | null) => {
        if (result != null) {
          console.log("process data", result);
          
          const filteredData = result.filter(item => item.isFixed === 1);
          const formattedData = filteredData.map(item => ({
            description: item.pDescription,  
            id: item.id,
            // itemname: `${item.processName}\n${item.pDescription}`,
            itemname: item.processName,
            label:  item.processName,
            selectitem: item.processName,
            tenantid:item.tenantid,
            glcode:"",
            qty:0,
            stockqty: 0,
            unit: "",
            unitPrice: 0
          }));
  
          this.setState({ processData: formattedData });
        }
        resolve();
      })
      .catch((err: any) => {
        toast.error(`Server Error, ${err}`);
        this.setState({ isWait: false });
        reject();
      });
  };


  



  GetJoblistById(orderid: any) {
    let saveRequest: any = {};
    saveRequest.orderid = orderid;
    saveRequest.tenantid = 0;

    CustomerService.Getorderdataoptimize(saveRequest)
      .then(async (result) => {
        if (result != null) {
          this.setState({ JODetails: [] }, () => {
            const items = result.customerOrderDetailsToUpdateList.map(item => ({
              label: item.jobno,
              id: item.jobno,
              value: item.jobno,
              jobid: item.jobid,
              isChecked: false
            }));


            // this.setState({
            //   JODetails: items,
            // }, () => {
            //   console.log("Updated JODetails in state", this.state.JODetails);
            // });
          });
        }
        resolve();
      })
      .catch((err) => {
        toast.error(`Server Error, ${err}`);
        reject();  // Reject promise if you're using promises (ensure `reject` is defined)
      });
  }

  GetJoblist = () => {
    JobServices.GetJoblist({})
      .then(async (result: any[] | null) => {
        if (result != null) {
          result.forEach((element) => {
            let item: any = {};
            item.value = element.jobNo;
            item.label = element.jobNo;
            item.jobid = element.jobid;
            item.itemid = element.itemid;
            item.itemname = element.itemname;
            item.partid = element.partid;
            item.isChecked = false;
            item.materialDesc = element.materialDesc || "";
            this.state.JODetails.push(item);
          });

          if (this.state.vendororderid === 0 || this.state.vendororderid == undefined) {
            let JODetails1 = Object.assign([], JSON.parse(JSON.stringify(this.state.JODetails)));
            let JODetails2 = Object.assign([], JSON.parse(JSON.stringify(this.state.JODetails)));

            const newItems = [...this.state.additionalMaterialItems];
            newItems[0] = {
              ...newItems[0],
              JODetails: JODetails1
            };

            const newItemss = [...this.state.misclistByItem];
            newItemss[0] = {
              ...newItemss[0],
              JODetails: JODetails2
            };

            this.setState({ additionalMaterialItems: newItems, misclistByItem: newItemss });
          }


        }
        resolve();
      })
      .catch((err: any) => {
        toast.error(`Server Error, ${err}`);
        reject();
      })
      .finally(()=>{
        this.GetorderEntryColoumn();
      });
  };

  GetCustomerItems = () => {
    CustomerService.GetCustomerOrder()
      .then(async (result: any[] | null) => {
        if (result != null) {
          const items = result.map(item => ({
            label: item.customerPoNumber,
            id: item.customerPoNumber,
            orderid: item.orderID
          }));
          console.log("cust items------", items);
          this.setState({
            CODetails: items
          });
        }
        resolve();
      })
      .catch((err: any) => {
        toast.error(`Server Error, ${err}`);
        reject();
      });
  };

  GetItemlist = () => {

    let requestlist = { ...this.state.requestlist };
    let inventorydata: any = [];
    this.setState({ inventoryLoad: false });

    let TypeInventory: any = [];

    inventorydata = Object.assign([], JSON.parse(JSON.stringify(this.state.inventorydata)));

    JobServices.GetInventoryData(requestlist)
      .then(async (resultinv: any | null) => {

        if (resultinv !== null) {
          resultinv.forEach(element => {

            let value = element.product_name + (element.inventory_description != null && element.inventory_description.length > 0 ? " ( " + element.inventory_description + " )" : "");
            let item: any = {};
            item.id = element.product_id;
            item.itemname = value;
            item.label = value;
            item.selectitem = element.product_name;
            item.glcode = element.glcode;
            item.stockqty = element.stockqty,
              // + "-" + element.category_name + "-" + element.producttype_name + " (" + element.sizedesc + " )";
              item.description = element.description || "";
            item.qty = element.quantity_in_stock;
            item.unitPrice = 0;
            item.unit = element.unit;
            TypeInventory.push(item);

          });
          this.setState({ inventorydata: TypeInventory });

        }
        resolve();

      })
      .catch((error) => {

        reject();
      })
      .finally(() => {
      this.setState({ inventoryLoad: true });
      });

  };

    handleAttachment = (event) => {
  this.setState({
    isAttachments: event.target.checked,
  });
};


  getJoblist = () => {

    let requestlist = { ...this.state.requestlist };
    this.setState({jobLoad:false});
    JobServices.GetJoblist(requestlist)
      .then(async (resultinv: any | null) => {

        if (resultinv !== null) {
          resultinv.forEach(element => {
            element.label = element.jobNo;
          });
          this.setState({ jobList: resultinv});

        }
        resolve();

      })
      .catch((error) => {
        reject();
      })
      .finally(() => {
      this.setState({ jobLoad: true });
      });

  };


  getOptions = (requestlist: any, id: any) => {
    VendorService.GetVendorlist(requestlist)
      .then(async (result: any | null) => {

        if (result !== null) {
          const matchedRecord = result.find((record: any) => record.vendor_id === id);
          const {mailContent} = this.state;
          
          if (matchedRecord && matchedRecord.vendorContact) {
            const options: any[] = [];
            matchedRecord.vendorContact.forEach((element: any) => {
              let item: any = {};
              item.id = element.id;
              item.name = element.firstname;
              item.title = element.title;
              options.push(item);
            });

             const defaultContact = matchedRecord.vendorContact.find(
                (contact: any) => contact.isDefault == true
              );
              const defaultEmail = defaultContact?.email || "";
              mailContent.MailTo = defaultEmail;
            this.setState({ options: options,mailContent });

          }
          
        }
        resolve();
      })
      .catch((error) => {
        reject();
      });
  };

 GetUnits = () => {

    let TypeInventory: any = [];

    VendorService.GetUnits({})
      .then(async (resultinv: any | null) => {

        if (resultinv !== null) {
          resultinv.forEach(element => {

            let value = element.name;
            let item: any = {};
            item.id = element.id;
            item.itemname = value;
            item.label = value;
            item.selectitem = element.name;
            TypeInventory.push(item);

          });
          this.setState({ unitList: TypeInventory });

        }
        resolve();

      })
      .catch((error) => {

        reject();
      });

  };

  GetorderEntryColoumn = () => {
    let request: any = {};
    let requestlist: any = {};
    const isQtyValidate = false;
    request.orderid = this.state.vendororderid;
    request.tenantid = 0;
    request.vendorordertype = this.state.vendorordertype;
    request.jobid = this.props.jobid;

    let orderData: any = [];
    VendorService.Getorderdata(request)
      .then(async (result: any | null) => {
        if (result !== null) {
          console.log(result);


          if (result.vendorOrderToUpdateList.length > 0) {

            let options: any = [];

            result.vendorContact.forEach(element => {

              let item: any = {};
              item.id = element.id;
              item.name = element.firstname;
              item.title = element.title;
              options.push(item);

            });
            let custommerSelected: any = [];
            let mainArray = result.vendorOrderToUpdateList[0];
            let formData = { ...this.state.formData };
            formData.OrderID = mainArray.orderID;
            formData.CustomerID = mainArray.vendorID;
            formData.CustomerName = mainArray.vendorName;
            formData.customercode = mainArray.vendorcode;
            formData.CustomerPoNumber = mainArray.vendorPoNumber;
            formData.ship_via = mainArray.ship_via;
            formData.refNo = mainArray.refNo;
            formData.OrderDate = mainArray.orderDate;
            formData.duedate = mainArray.dueDate;
            formData.Status = mainArray.status;
            formData.POInitiated = mainArray.poInitiated;
            let isApproved = mainArray.poInitiated == true ? false : true;
            formData.Address = mainArray.address;
            formData.firstname = mainArray.contactName == null ? "" : mainArray.contactName;
            custommerSelected.company_name = mainArray.vendorName;
            custommerSelected.address = mainArray.address;
            custommerSelected.customer_id = mainArray.vendorID;
            custommerSelected.customercode = mainArray.vendorcode;

            if (mainArray.vendorID) this.getOptions(requestlist, mainArray.vendorID);

            let Defaultselected: any = [];
            let objData: any = {};

            objData.id = mainArray.contactName;
            objData.name = mainArray.contactName == null ? "" : mainArray.contactName;
            Defaultselected.push(objData);

            this.customerSearch?.current.handleSelectFromParent(
              custommerSelected
            );
            // this.state.mailContent.MailTo = mainArray.vendorEmail;


            const isQtyValidate = mainArray.orderDetails?.some(
              (item) => item.received === "Partial"
            );


            this.setState(
              {
                isApproved: isApproved,
                ship_via: formData.ship_via,
                orderData: orderData,
                formData: formData,
                Defaultselected: Defaultselected,
                productid: 0,
                isQtyValidate,
                sentDate:mainArray.sentDate || null,
                cancelDate:mainArray.cancelDate || null,
                quotationNo:mainArray.quotationNo,
                isSpinner: false,
              },
              () => { }
            );
          }

          let jobdetails: any = [];
          console.log(" result.vendor3PartyOrderDetailList", result.vendor3PartyOrderDetailList);
          if (result.vendor3PartyOrderDetailList.length > 0) {
            jobdetails = result.vendor3PartyOrderDetailList;

            jobdetails.forEach((element, idx) => {
              element.unitPrice = Utils.currencyFormat(element.unitPrice);
            });
            let job = jobdetails.filter((x) => x.selected == true);
            if (job && job.length > 0) {
              this.state.mailContent.Message = `Dear ${this.state.formData.CustomerName}`
                + "\n\nPlease find attached Purchase Order and Order Attachments below. Kindly review the details of this order at your earliest convenience.\n\nThank you for your cooperation. \n\nBest Regards,\n" + result.vendorOrderToUpdateList[0].companyName;
               this.state.mailContent.subject = `Purchase Order - ${this.state.formData.CustomerPoNumber} requested from ${result.vendorOrderToUpdateList[0].companyName}`;
            }
          }

          if (result.vendorOrderDetailsToUpdateList.length > 0) {
            let job = result.vendorOrderDetailsToUpdateList.filter((x) => x.selected == true);
            if (job && job.length > 0) {

              const qtys = job.map(obj => obj.qty);
              const totalSum = qtys.reduce((acc, curr) => acc + curr, 0);
              this.state.mailContent.Message = `Dear ${this.state.formData.CustomerName}`
                + "\n\nPlease find attached Purchase Order and Order Attachments below. Kindly review the details of this order at your earliest convenience.\n\nThank you for your cooperation. \n\nBest Regards,\n" + result.vendorOrderToUpdateList[0].companyName;
              this.state.mailContent.subject = `Purchase Order - ${this.state.formData.CustomerPoNumber} requested from ${result.vendorOrderToUpdateList[0].companyName}`;
            }
          }
          let misclistByItem = this.state.misclistByItem;
          // if (this.state.vendorordertype == 'Miscellaneous' && result.vendorOrderItemDetails.length > 0) {
          //   misclistByItem = [];
          //   result.vendorOrderItemDetails.forEach((element, idx) => {

          //     let item: any = {};
          //     item.srno = idx + 1;
          //     item.itemDesc = element.itemDesc;
          //     item.qty = element.qtyOrdered;
          //     item.unit = element.unit || 0;
          //     item.itemName = element.itemName;
          //     item.itemNo = element.itemNo;
          //     item.glCode = element.msCode;
          //     item.itemDesc = element.itemDesc;
          //     item.id = element.id;
          //     item.orderId = element.orderId;
          //     item.jobdetailid=element.jobdetailid==undefined ? element.jobdetailId ==undefined ? 0 : element.jobdetailId : element.jobdetailid;
          //     //item.unitPrice = element.unitPrice;
          //     item.unitPrice = Utils.currencyFormat(element.unitPrice);


          //     let defaultitemname: any = [];
          //     let objPartname: any = {};
          //     objPartname.itemName = element.itemName;
          //     objPartname.label = element.itemName;
          //     objPartname.id = element.id;
          //     objPartname.glCode = element.msCode;
          //     objPartname.qty = element.qtyOrdered;
          //     objPartname.unit = element.itemName || 0;
          //     objPartname.unitPrice = element.unitPrice;
          //     objPartname.unit = element.unit;
          //     objPartname.tenantid = 0;

          //     defaultitemname.push(objPartname);

          //     item.defaultitemname = defaultitemname;

          //     misclistByItem.push(item);

          //   });
          // }

          let jobOrderlistByItem = result.vendorOrderDetailsToUpdateList.filter((x) => !x.isAdditionItem);
          if (jobOrderlistByItem.length > 0) {
            jobOrderlistByItem.forEach((element, idx) => {
              element.unitPrice = Utils.currencyFormat(element.unitPrice);
            });

          }

          
          // let additionalMaterialItems = result.vendorOrderItemDetails?.filter((x) => x.isAdditionItem) || [];

          let additionalMaterialItems = result.vendorOrderItemDetails;

          if (additionalMaterialItems.length > 0) {
            misclistByItem = [];
            additionalMaterialItems.forEach((element, idx) => {

               let defaultunitname: any = [];
              let objUnitname: any = {};

              objUnitname.itemName = element.unit;
              objUnitname.label = element.unit;
              objUnitname.id = 0;
              defaultunitname.push(objUnitname);
              element.defaultunitname = defaultunitname;

              let defaultitemname: any = [];
              let objPartname: any = {};

              objPartname.itemName = element.itemName;
              objPartname.label = element.itemName;
              objPartname.id = element.id;
              objPartname.glCode = element.msCode;
              objPartname.qty = element.qtyOrdered;
              objPartname.itemDesc = element.itemDesc;
              objPartname.unitPrice = element.unitPrice;
              objPartname.unit = element.unit;
              objPartname.tenantid = 0;

              defaultitemname.push(objPartname);
              element.srno = idx + 1;
              element.defaultitemname = defaultitemname;
              element.unitPrice = Utils.currencyFormat(element.unitPrice);
              element.discount = Utils.currencyFormat(element.discount);
              element.notes = element.notes ? element.notes : "";
              element.glCode = element.msCode;
              element.qty = element.qtyOrdered;

              let defaultjobno: any = [];

              let JODetails = Object.assign(
                [],
                JSON.parse(JSON.stringify(this.state.JODetails))
              );

               let productJobList = Object.assign(
                [],
                JSON.parse(JSON.stringify(this.state.productJobList))
              );

        

              element.selectedPartIDs.forEach(selectedElement => {
              productJobList.forEach(jobDetail => {
                if (
                  jobDetail.partid === selectedElement.partid &&
                  jobDetail.jobid === selectedElement.jobid
                ) {
                  jobDetail.isChecked = true;
                }
              });
            });


              // element.selectedIDs.forEach(selectedElement => {
              //   JODetails.forEach(jobDetail => {
              //     if (jobDetail.jobid === selectedElement.jobid) {
              //       jobDetail.isChecked = true;
              //     }
              //   });
              // });

              console.log("JO DETEAIL EXISTIG", JODetails);
              element.JODetails = JODetails;
              element.productJobList = productJobList;
              //   element.selectedIDs.forEach(element => {
              //     let objjobno: any = {};
              //     objjobno.jobNo = element.jobno;  
              //     objjobno.label = element.jobno; 
              //     objjobno.jobId = element.jobid; 
              //     objjobno.value = element.jobno;
              //     defaultjobno.push(objjobno);
              // });


              //   element.defaultjobno = defaultjobno;

            });
          }
          else
            additionalMaterialItems = this.state.additionalMaterialItems;

          console.log("updated additionmaterial", additionalMaterialItems);
          this.setState({ invoiceCreated: result.invoiceCreated, misclistByItem: misclistByItem, jobOrderlistByItem: jobOrderlistByItem, jobdetailsdata: jobdetails, additionalMaterialItems: additionalMaterialItems });
          this.GetUploadFileList( this.state.vendororderid, 1);

        }
        resolve();
      })
      .catch((error) => {
        this.setState({ isSaveSpinner: false });
        reject();
      });
  };


  GetUploadFileList = (uniqueNo, type) => {
      let requestlist: any = {};
  
      requestlist.transactionID = this.state.vendororderid > 0? this.state.vendororderid:uniqueNo;
      requestlist.transactionType = "vendorOrder";
  
      TransactionService.GetUploadFileWithFileCodeTransaction(requestlist)
        .then(async (result: any | null) => {
          if (result.length > 0) {
            for (let i = 0; i < result.length; i++) {
              this["myRef" + i] = React.createRef();
            }
            let filelist: any[] = [];
            result.forEach((element, i) => {
              element.fileCode =
                "data:application/pdf;base64," + element.fileCode;
              element.fileName = element.name;
              element.newname = element.name.toString().toLowerCase();
              filelist.push(element);
            });
            //filelist = _.sortBy(filelist, "newname");
            this.setState({savedfiles:[]}, () => {
              this.setState(
                (prevState) => ({
                  savedfiles: filelist,
                  isAttachmentLoading: false,
                  isOpenViewer: false,
                  newSelectedfiles: [],
                  files: [],
                  bulkSelect: true,
                }),
                () => {
                  setTimeout(() => {
                    this.scrollheight.current?.getElement().scrollTo({
                      top: Number(this.state.currentScreenTop),
                      behavior: "smooth",
                    });
                  }, 500);
                }
              );
            }
  
  
            );
           
          
          } else {
            this.setState({
              isOpenViewer: false,
              savedfiles: [],
              newSelectedfiles: [],
              files: [],
              bulkSelect: false,
            });
          }
  
          resolve();
        })
        .catch((error) => {
          reject();
          this.setState({
            isOpenViewer: false,
            savedfiles: [],
            newSelectedfiles: [],
            files: [],
            bulkSelect: false,
          });
        });
    };

  onLoadData() {
    this.setState({ isjobcreate: false, isStateChanged: false });
    let pros = this.props;
    let requestlist = { ...this.state.requestlist };
    if (this.customerSearch.current !== null) {
      this.customerSearch.current.GetCustomerTranlist(requestlist);
    }
  }

  updateCustomerList = (result: any) => {
    this.setState({ customerList: [] }, () => {
      this.setState({ customerList: result });
    });
  };

  handleChange = (event: any, FieldType: string, index: any) => {
    let isStateChanged = true;
    let start = 0;
    let end = 0;



    let formData = { ...this.state.formData };
    let jobdetails = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.jobdetailsdata))
    );


    if (FieldType === "orderDate") {
      //   formData.OrderDate = event.target.value.trim().length > 0 ? event.target.value : "";
      let today = new Date(event);
      let dateNew =
        today.getMonth() +
        1 +
        "/" +
        today.getDate() +
        "/" +
        today.getFullYear().toString().substring(2, 4);
      let todaynew = new Date(dateNew);
      let dateNewt =
        todaynew.getMonth() +
        1 +
        "/" +
        todaynew.getDate() +
        "/" +
        todaynew.getFullYear().toString().substring(0, 4);
      formData.OrderDate = dateNewt;
      this.setState({ formData, isStateChanged });
    } else if (FieldType === "dueDate") {
      let today = new Date(event);
      let dateNew =
        today.getMonth() +
        1 +
        "/" +
        today.getDate() +
        "/" +
        today.getFullYear().toString().substring(2, 4);
      let todaynew = new Date(dateNew);
      let dateNewt =
        todaynew.getMonth() +
        1 +
        "/" +
        todaynew.getDate() +
        "/" +
        todaynew.getFullYear().toString().substring(0, 4);
      formData.duedate = dateNewt;
      this.setState({ formData, isStateChanged });
    } else if (FieldType === "check") {
      if (event.target.value.length > 0) {
        if (Number(event.target.value)) {
          formData.checkNo = Number(event.target.value);
        }
      } else {
        formData.checkNo = event.target.value;
      }
    } else if (FieldType === "repeat") {
      formData.isRepeat = event.target.checked ? "Yes" : "No";
      this.setState({ isRepeat: event.target.checked });
    } else if (FieldType === "ship_via") {
      formData.ship_via = event.target.value;
      this.setState({ ship_via: event.target.value });
    }else if (FieldType === "refNo") {
      formData.refNo = event.target.value;
    }  else if (FieldType === "orderedqty") {

      event.preventDefault();
      let newVal = Utils.removeInvaildCharFromAmount(event.target.value);
      event.target.value = newVal;
      jobdetails[index].qtyOrdered = event.target.value;

      this.setState({ jobdetailsdata: jobdetails, isStateChanged }, () => {
        //$("#tblOrder")
        //  .find("input[id^='" + txtID + "']")
        //  .focus();


      });
    } else if (FieldType === "unitprice") {
      event.preventDefault();
      let newVal = Utils.removeInvaildCharFromAmount(event.target.value);
      event.target.value = newVal;
      jobdetails[index].unitPrice = event.target.value;

      this.setState({ jobdetailsdata: jobdetails, isStateChanged }, () => {
        let txtID = "txtUnitPrice" + index + "txt";
        $("#tbltemplate")
          .find("input[id^='" + txtID + "']")
          .focus();
      });


    }
    else if (FieldType === "jdescription") {
      event.preventDefault();
      jobdetails[index].jdescription = event.target.value;
      this.setState({ jobdetailsdata: jobdetails, isStateChanged }, () => {
        /*let txtID = "txtUnitPrice" + index + "txt";
        $("#tbltemplate")
         .find("input[id^='" + txtID + "']")
         .focus();*/
      });
    }
    else if (FieldType === "Message") {
      event.preventDefault();
      this.state.mailContent.Message = event.target.value;
    }
    else if (FieldType === "CC") {
      event.preventDefault();
      this.state.mailContent.CC = event.target.value;
    } else if (FieldType === "subject") {
      event.preventDefault();
      this.state.mailContent.subject = event.target.value;
    }
    else if (FieldType === "MailTo") {
      event.preventDefault();
      this.state.mailContent.MailTo = event.target.value;
    }






    this.setState({ formData, isStateChanged, isSpinner: false }, () => {
      if (FieldType === "invoiceno") {
        let txtID = "txtInvoice";
        let txtInvoice = $("input[id^='" + txtID + "']")[0] as any;
        txtInvoice.selectionStart = start;
        txtInvoice.selectionEnd = end;
      }
    });
  };


  handleEditClick = (rowIndex, currentDesc) => {
    console.log("desc---------------", currentDesc);
    let currentNote = "";
    
    // if (this.state.vendorordertype === "Process") {
    //   // currentNote = currentDesc[0]?.itemName ? currentDesc[0].itemName : "";
    //   currentNote = currentDesc[0]?.itemName ? `${currentDesc[0].itemName}\n${currentDesc[0]?.itemDesc?currentDesc[0].itemDesc:""}` : "";

    // } else {
    //   currentNote = currentDesc[0]?.itemName ? `${currentDesc[0].itemName}\n${currentDesc[0]?.itemDesc?currentDesc[0].itemDesc:""}` : "";
    // }

    if(currentDesc[0].customOption){
      currentNote = currentDesc[0]?.label ? `${currentDesc[0].label}\n${currentDesc[0]?.itemDesc?currentDesc[0].itemDesc:""}` : "";
    }else{
      currentNote = currentDesc[0]?.itemName ? `${currentDesc[0].itemName}\n${currentDesc[0]?.itemDesc?currentDesc[0].itemDesc:""}` : "";
    }

    this.setState({
      editingIndex: rowIndex,
      currentNote: currentNote,
      showPopup: true,
    });
};

handleNotesSave = () => { 
  let additionalMaterialItems = Object.assign(
    [], 
    JSON.parse(JSON.stringify(this.state.additionalMaterialItems))
  );

  const { editingIndex, currentNote } = this.state;
  console.log("prev notes--------", additionalMaterialItems[editingIndex]);
  
  const noteLines = currentNote.split('\n');
  const firstLine = noteLines[0]; 
  const restOfLines = noteLines.slice(1).join('\n'); 
  
  if (additionalMaterialItems[editingIndex].defaultitemname.length > 0) {
      additionalMaterialItems[editingIndex].defaultitemname[0].itemName = firstLine;
      additionalMaterialItems[editingIndex].defaultitemname[0].label = firstLine;
      additionalMaterialItems[editingIndex].defaultitemname[0].itemDesc = restOfLines;
  } else {
      let objPartname:any= {};
      objPartname.itemName = firstLine;
      objPartname.label = firstLine;
      objPartname.itemDesc = restOfLines;
      additionalMaterialItems[editingIndex].defaultitemname.push(objPartname);
  }
  
  additionalMaterialItems[editingIndex].itemName = firstLine;
  additionalMaterialItems[editingIndex].itemDesc = restOfLines;

  this.setState({ 
      showPopup: false, 
      editingIndex: null, 
      currentNote: '', 
      additionalMaterialItems, 
      isStateChanged: true 
  });
};


 handleEditClick1 = (rowIndex, currentDesc) => {
   
    this.setState({
      editingIndex1: rowIndex,
      currentNote1: currentDesc,
      showPopup1: true,
    });
  };

    handleNotesSave1 = () => {

    let additionalMaterialItems = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.additionalMaterialItems))
    );

    const { editingIndex1, currentNote1 } = this.state;
    additionalMaterialItems[editingIndex1].notes = currentNote1;
    this.setState({ showPopup1: false, editingIndex1: null, currentNote1: '' ,additionalMaterialItems, isStateChanged: true});
  };

  amountBlurProcess = (e, rowIndex, type: any, row: any) => {

    let jobdetails = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.jobdetailsdata))
    );

    if (e.target.value.includes(".")) {
      const timeArray = e.target.value?.split(".");
      if (timeArray[1].length <= 0) {
        if (type === "unitPrice") {
          jobdetails[rowIndex].unitPrice = Utils.currencyFormat(
            timeArray[0]
          );

        }
      } else {
        if (type === "unitPrice") {

          jobdetails[rowIndex].unitPrice = Utils.currencyFormat(
            e.target.value
          );

        }


      }
      //this.setState({ jobdetails });
      this.setState({ jobdetailsdata: jobdetails }, () => { });
    } else {
      if (type === "unitPrice") {


        jobdetails[rowIndex].unitPrice = e.target.value === ""
          ? ""
          : !isNaN(e.target.value)
            ? Utils.currencyFormat(e.target.value)
            : e.target.value;

      }

      this.setState({ jobdetailsdata: jobdetails }, () => { });
    }
  };

  onAmountFocusProcess = (e, index, txtID, type: any) => {


    let jobdetails = Object.assign([], JSON.parse(JSON.stringify(this.state.jobdetailsdata)));
    //let newval = Utils.removecurrencyFormat(e.target.value);
    let start = e.target?.selectionStart;
    let end = e.target?.selectionEnd;
    if (type === "unitPrice") {
      let newVal = Utils.removeInvaildCharFromAmount(e.target.value);
      e.target.value = newVal;
      jobdetails[index].unitPrice = e.target.value;

      this.setState({ jobdetailsdata: jobdetails }, () => {
        $("#tbltemplate")
          .find("input[id^='" + txtID + "']")
          .focus();
        let txtdesc = $("#tbltemplate").find(
          "input[id^='" + txtID + "']"
        )[0] as any;
        if (txtdesc !== null && txtdesc !== undefined) {
          txtdesc.selectionStart = start;
          txtdesc.selectionEnd = end;
        }
      });
    }
  };

  handleDatePicker = (event: any, refName: any) => {
    refName.current.setOpen(true);
  };

  handleVendorChange = (e: any) => {

    let isStateChanged = true;
    let formData = { ...this.state.formData };
    if (e.length > 0) {
      this.setState({
        CustomerName: e[0].company_name,
        address: e[0].address,
        customercode: e[0].vendorcode,
        isStateChanged: isStateChanged,
      });
      this.state.formData.CustomerID = e[0].vendor_id;
      this.state.formData.CustomerName = e[0].company_name;
      this.state.formData.ship_via = e[0].ship_via;

      this.state.formData.Address =
        e[0].firstname +
        "\n" +
        e[0].address +
        "\n" +
        e[0].apartment +
        "\n" +
        e[0].city +
        ", " +
        e[0].state +
        ", " +
        e[0].zipcode +
        "\n" +
        e[0].country;
      this.state.formData.customercode = e[0].vendorcode;

      let options: any = [];
      e[0].vendorContact.forEach(element => {

        let item: any = {};
        item.id = element.id;
        item.name = element.firstname;
        item.title = element.title;
        options.push(item);

      });

      let objData: any = {};
      let Defaultselected: any = [];
      let defaultname: any = e[0].vendorContact.filter(
        (x) => x.isDefault == true
      );
      if (defaultname.length > 0) {

        objData.id = defaultname[0].firstname;
        objData.name = defaultname[0].firstname;
        Defaultselected.push(objData);
        formData.firstname = defaultname[0].firstname;
        this.state.formData.firstname = defaultname[0].firstname;
      };


      // this.state.options = options;
      this.setState({
        options: options, Defaultselected: Defaultselected
      });
      //this.GetProductlist(requestlist);

      //this.GetorderEntryColoumn();

      let txtID = "txtDueDate";
      setTimeout(() => {
        this.trDate.current.setOpen(true);
        $("input[id^='" + txtID + "']").focus();
      }, 50);
    } else {
    }
  };




  handleEdit() {
    this.setState({ isStateChanged: true, editMode: true, showOptionSelect: true });
  }

  onTAB = (control, rowIndex1, event) => {
    let controlID = control.split("-")[0];
    let rowIndex = Number(rowIndex1);

    if (event.key.toLowerCase() === "enter") {
      if (controlID === "txtOrderDate") {
        let txtID = "txtNotes";
        setTimeout(() => {
          $("input[id^='" + txtID + "']").focus();
        }, 50);
      } else if (controlID === "txtDueDate") {
        let txtID = "txtNotes";
        setTimeout(() => {
          $("input[id^='" + txtID + "']").focus();
        }, 50);
      }
    }

    if (event.key.toLowerCase() === "tab") {
      let ChecktxtID = "partname" + rowIndex + "ddl";
      console.log("ppppp----",controlID);

      if(controlID === "qty"){

        let txtID = "txtunitPrice" + rowIndex + "txt";
        console.log("ppppp",txtID);
          setTimeout(() => {
            const inputField = $("input[id^='" + txtID + "']");
            inputField.focus();
            inputField.select(); 
                    }, 50);

      }

      if (controlID === "itemname") {

        let txtID = "txtglcode" + rowIndex + "txt";       
          setTimeout(() => {
           
            $("input[id^='" + txtID + "']").focus();

                    }, 50);

      }

      if (controlID === "txtduedate") {
        let txtID = "txtdescription" + rowIndex + "txt";

        $("#tblOrder")
          .find("input[id^='" + txtID + "']")
          .focus();
      }

      if (controlID === "txtOrderDate") {
        let txtID = "txtNotes";
        setTimeout(() => {
          $("input[id^='" + txtID + "']").focus();
        }, 50);
      }
    }

    if (event.key.toLowerCase() === "backspace" && controlID !== "qty") {
      let controlID = control.split("-")[0];
      let rowIndex = Number(rowIndex1);
      let orderData = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.orderData))
      );
      let defaultPartname: any = [];
      let productList = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.productList))
      );

      orderData[rowIndex].partname = event.target.value;
      orderData[rowIndex].productid = 0;
      orderData[rowIndex].partNo = "";
      orderData[rowIndex].unitPrice = 0;
      orderData[rowIndex].unit = "";
      orderData[rowIndex].jobDesc = "";

      let objPartname: any = {};
      objPartname.partname = event.target.value;
      objPartname.label = event.target.value;
      objPartname.id = 0;
      objPartname.partno = "";

      objPartname.tenantid = 0;
      objPartname.unit = "";
      objPartname.unitPrice = 0;
      objPartname.noofday = null;
      objPartname.jobDesc = "";
      defaultPartname.push(objPartname);
      productList.push(objPartname);

      //element.defaultPartname = defaultPartname;
      orderData[rowIndex].defaultPartname = defaultPartname;

      this.setState({ orderData, defaultPartname, productList }, () => {
        let txtID =
          "rbt-input-main form-control rbt-input partname" + rowIndex + "ddl";
        $("#tblOrder")
          .find("input[class^='" + txtID + "']")
          .focus();
      });

      let txtID =
        "rbt-input-main form-control rbt-input partname" + rowIndex + "ddl";

      let tvalue =
        event.target.value.trim().length > 0 ? event.target.value : "";
      if (tvalue === "") {
        setTimeout(() => {
          $("input[class^='" + txtID + "']").focus();
        }, 50);
      }
    }
  };

  HidecloseSlideOut() {
    this.props.closeSlideOut();
    this.setState({ isSaveSpinner: false });
  }


  Hidespinner() {
    this.setState({ isSpinner: false });
  }

  saveOrderfinal = (entryType, isSubmit, isprint, files?: any) => {

  if (this.state.isQtyValidate) {
    confirmAlert({
      title: 'Confirm Update – Receiving Details May Reset',
     message: (
        'You have partially entered data in the Receiving tab that has not been fully saved. ' +
        'Updating quantities will reset the received details (status and quantity) and result in the loss of entered information.' +
        '\n\nAre you sure you want to continue?'
      ),
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            this.continueSaveOrder(entryType, isSubmit, isprint, files);
          },
        },
        {
          label: 'No',
          onClick: () => {
          },
        },
      ],
      closeOnEscape: false,
      closeOnClickOutside: false,
    });
    return; 
  }

  this.continueSaveOrder(entryType, isSubmit, isprint, files);
};


  continueSaveOrder = (entryType, isSubmit, isprint,files?:any) => {
    console.log("this.state.formData", this.state.formData);
    let isFormValid = true;
    let request: any = {};
    let orderlistitem: any = [];
    let jobOrderList = this.state.jobOrderlistByItem;
    let additionalMaterialItems = this.state.additionalMaterialItems;
    let misclistByItem = this.state.misclistByItem;
    let Vendor3PartyOrderItems: any = [];

    jobOrderList.forEach(element => {
      console.log("additionalMaterialItems", additionalMaterialItems);
      let item: any = {};
      
      if (element.selected) {
        item.orderID = element.orderId;
        item.itemNo = element.itemId;
        item.itemname = element.itemName;
        item.glcode = element.glCode;
        item.dueDate = element.dueDate === "" || element.dueDate === undefined || element.dueDate === null ? new Date(Utils.convertUtcToTimezoneFormat(new Date(), currentUtcTime)) : Utils.toLocalISOString(new Date(element.dueDate));
        item.jobDesc = element.jobDesc;
        item.unit = element.unit;
        item.unitPrice = Utils.removeInvaildCharFromAmount(element.unitPrice);

        if (item.unitPrice == "" || item.unitPrice == null) {

          item.unitPrice = 0;
        }


        item.qtyOrdered = element.qty;
        item.total = element.total;



        item.tenantid = element.tenantid;
        item.JobId = element.jobId;

        if (element.productid == 0 || element.productid == null || element.productid == undefined) {
          item.productid = 0;
        }
        else {
          if (element.productid[0] == undefined) {
            item.productid = 0;

          }
          else {
            item.productid = element.productid[0].id === undefined ? element.productid : element.productid[0].id;
          }
        }
        orderlistitem.push(item);
      }
    });




    //OrderItems items
    additionalMaterialItems.length > 0 && this.state.vendorordertype !== 'Miscellaneouss' && additionalMaterialItems.forEach(element => {
      

      let jobIds;
      // if (element.jobId == undefined) {
      //   jobIds = [];

      // }
      // else {
        
      // jobIds = element.selectedIDs;
      jobIds = (element.selectedPartIDs || []).filter(
        item => item.jobid !== null && item.jobid !== undefined
      );

      // let jobIds = element.jobId.split(',');
      // }
      console.log("jobids........", element.jobId);
      //element.jobId.split(',');

      if (jobIds != undefined) {
        
        if (jobIds.length == 0) {



          let item: any = {};

          if (element.itemName !== '' && element.processname !== '') {
            item.orderID = element.orderId == undefined ? element.orderid : element.orderId;
            item.itemNo = element.itemNo;

            item.itemname = element.processname || element.itemName;
            item.partid = element.selectedPartIDs?.[0]?.partid || 0;
            item.glcode = element.glCode == undefined ? "" : element.glCode;
            item.dueDate = element.dueDate === "" || element.dueDate === undefined || element.dueDate === null
              ? new Date(Utils.convertUtcToTimezoneFormat(new Date(), currentUtcTime))
              : Utils.toLocalISOString(new Date(element.dueDate));
            item.jobDesc = element.jdescription || element.itemDesc;
            item.unit = element.unit;
            item.unitPrice = Utils.removeInvaildCharFromAmount(element.unitPrice);
            if (item.unitPrice == "" || item.unitPrice == null) {
              item.unitPrice = 0;
            }
             item.discount = Utils.removeInvaildCharFromAmount(element.discount);
            if (item.discount == "" || item.discount == null) {
              item.discount = 0;
            }

            item.qtyOrdered = element.qty;
            item.total = element.total;
            item.isAdditionItem = false;
            item.tenantid = element.tenantid;
            item.JobId = 0;
            item.jobdetailId = element.jobdetailId == undefined ? element.jobdetailid==undefined ? 0 : element.jobdetailid : element.jobdetailId;
            // Handle productid
            if (element.productid == 0 || element.productid == null || element.productid == undefined) {
              item.productid = 0;
            } else {
              if (element.productid[0] == undefined) {
                item.productid = 0;
              } else {
                item.productid = element.productid[0].id === undefined ? element.productid : element.productid[0].id;
              }
            }

            // Push the item with the specific jobId into the list
            orderlistitem.push(item);
          }


        }
        else {
          jobIds.forEach(jobId => {
            let item: any = {};
            
            if (element.itemName !== '' && element.processname !== '') {
              
              item.orderID = element.orderId == undefined ? element.orderid : element.orderId;
              item.itemNo = element.itemNo;
              //  item.itemname = element.itemName;

              item.itemname = element.processname || element.itemName;
              item.partid = 0;

              item.glcode = element.glCode == undefined ? "" : element.glCode;
              item.dueDate = element.dueDate === "" || element.dueDate === undefined || element.dueDate === null
                ? new Date(Utils.convertUtcToTimezoneFormat(new Date(), currentUtcTime))
                : Utils.toLocalISOString(new Date(element.dueDate));
              item.jobDesc = element.jdescription || element.itemDesc;
              item.unit = element.unit;
              item.unitPrice = Utils.removeInvaildCharFromAmount(element.unitPrice);
              if (item.unitPrice == "" || item.unitPrice == null) {
                item.unitPrice = 0;
              }
                item.discount = Utils.removeInvaildCharFromAmount(element.discount);
                if (item.discount == "" || item.discount == null) {
                  item.discount = 0;
                }

              item.qtyOrdered = element.qty;
              item.total = element.total;
              item.isAdditionItem = false;
              item.tenantid = element.tenantid;
              item.JobId = parseInt(jobId.jobid);
              item.jobdetailId =element.jobdetailId == undefined ? element.jobdetailid==undefined ? 0 : element.jobdetailid : element.jobdetailId;
              // Handle productid
              if (element.productid == 0 || element.productid == null || element.productid == undefined) {
                item.productid = 0;
              } else {
                if (element.productid[0] == undefined) {
                  item.productid = 0;
                } else {
                  item.productid = element.productid[0].id === undefined ? element.productid : element.productid[0].id;
                }
              }

              // Push the item with the specific jobId into the list
              orderlistitem.push(item);
            }
          });
        }
      }
      else
      {

        let item: any = {};

        if (element.itemName !== '' && element.processname !== '') {
          item.orderID = element.orderId == undefined ? element.orderid ==undefined ? 0 : element.orderid  : element.orderId;
          item.itemNo = element.itemNo;

          item.itemname = element.processname || element.itemName;
          item.partid = 0;
          item.glcode = element.glCode == undefined ? "" : element.glCode;
          item.dueDate = element.dueDate === "" || element.dueDate === undefined || element.dueDate === null
            ? new Date(Utils.convertUtcToTimezoneFormat(new Date(), currentUtcTime))
            : Utils.toLocalISOString(new Date(element.dueDate));
          item.jobDesc = element.jdescription || element.itemDesc;
          item.unit = element.unit;
          item.unitPrice = Utils.removeInvaildCharFromAmount(element.unitPrice);
          if (item.unitPrice == "" || item.unitPrice == null) {
            item.unitPrice = 0;
          }
            item.discount = Utils.removeInvaildCharFromAmount(element.discount);
            if (item.discount == "" || item.discount == null) {
              item.discount = 0;
            }

          item.qtyOrdered = element.qty;
          item.total = 0;
          item.isAdditionItem = false;
          item.tenantid = 0;
          item.JobId = 0;
          item.jobdetailId = element.jobdetailId == undefined ? element.jobdetailid==undefined ? 0 : element.jobdetailid : element.jobdetailId;
          // Handle productid
          if (element.productid == 0 || element.productid == null || element.productid == undefined) {
            item.productid = 0;
          } else {
            if (element.productid[0] == undefined) {
              item.productid = 0;
            } else {
              item.productid = element.productid[0].id === undefined ? element.productid : element.productid[0].id;
            }
          }

          // Push the item with the specific jobId into the list
          orderlistitem.push(item);
        }        
      }



    });

    this.state.formData.OrderItems = orderlistitem;
    ///////

    //VendorOrderItemDetails
    let orderItemDetails: any = [];
    if (this.state.vendorordertype === 'Miscellaneouss') {
      console.log("pppp", this.state.misclistByItem);
      let itemList = this.state.misclistByItem;
      itemList.forEach(element => {
        if (element.itemName != '') {
          let item: any = {};
          let orderjob: any = [];

          item.id = element.id;
          item.orderId = orderlistitem.length > 0 ? orderlistitem[0].orderID : 0;
          item.itemNo = element.itemNo;
          item.itemname = element.itemName;
          item.ItemDesc = element.itemDesc == "" ? element.itemName : element.itemDesc;
          item.MSCode = element.glCode;
          item.Unit = element.unit;
          item.ProductId = element.itemNo;
          item.unitPrice = Utils.removeInvaildCharFromAmount(element.unitPrice);
          if (item.unitPrice == "" || item.unitPrice == null) {

            item.unitPrice = 0;
          }
            item.discount = Utils.removeInvaildCharFromAmount(element.discount);
            if (item.discount == "" || item.discount == null) {
              item.discount = 0;
            }
          item.qtyOrdered = element.qty;
          item.TenantId = orderlistitem.length > 0 ? orderlistitem[0].tenantid : 0;
          let jobIds = element.selectedIDs == undefined ? element.jobId.split(',') : element.selectedIDs;

          jobIds.forEach(jobId => {
            let itemjob: any = {};
            itemjob.jobid = element.selectedIDs == undefined ? parseInt(jobId) : parseInt(jobId.jobid);
            orderjob.push(itemjob);
          });

          item.selectedIds = orderjob;
          orderItemDetails.push(item);
        }
      });

      // misclistByItem.forEach(element => {
      //   let orderjob: any = [];
      //   let item: any = {};
      //   if (element.itemName !== '') {
      //     item.id = element.id;
      //     item.orderID = orderlistitem.length > 0 ? orderlistitem[0].orderID : 0;
      //     item.itemNo = element.itemNo;
      //     item.itemname = element.itemName;
      //     item.ItemDesc = element.itemDesc == "" ? element.itemName : element.itemDesc;
      //     item.MSCode = element.glCode;
      //     item.Unit = element.unit;
      //     item.unitPrice = Utils.removeInvaildCharFromAmount(element.unitPrice);
      //     item.qtyOrdered = element.qty;
      //     item.TenantId = orderlistitem.length > 0 ? orderlistitem[0].tenantid : 0;
      //     item.isAdditionItem = true;


      //     let jobIds = element.selectedIDs ==undefined ?  element.jobId.split(',') :element.selectedIDs ;

      //     jobIds.forEach(jobId => {
      //       let itemjob: any = {};
      //       itemjob.jobid=element.selectedIDs ==undefined ?    parseInt(jobId) : parseInt(jobId.jobid);  
      //       orderjob.push(itemjob);
      //     });

      //     item.selectedIds=orderjob;
      //     console.log("ooooooooooo",orderjob);
      //     orderItemDetails.push(item);
      //   }

      // });

    }
    else {
      console.log("additionalMaterialItemsadditionalMaterialItems",additionalMaterialItems);
      // let itemList = jobOrderList.filter((x) => x.rowType == 1 && jobOrderList.filter((y) => y.selected == true && y.itemId == x.itemId).length > 0);
      // itemList.forEach(element => {

      //   let item: any = {};

      //   if (element.itemName != '') {
      //     item.id = element.id;
      //     item.orderId = orderlistitem[0].orderID;
      //     item.itemNo = element.itemId;
      //     item.itemname = element.itemName;
      //     item.ItemDesc = element.itemDesc == "" ? element.itemName : element.itemDesc;
      //     item.MSCode = element.glCode;
      //     item.Unit = element.unit;
      //     item.unitPrice = Utils.removeInvaildCharFromAmount(element.unitPrice);
      //     if (item.unitPrice == "" || item.unitPrice == null) {

      //       item.unitPrice = 0;
      //     }
      //     item.qtyOrdered = element.qty;
      //     item.TenantId = orderlistitem[0].tenantid;
      //     item.jobdetailId = element.jobdetailId == undefined ? element.jobdetailid==undefined ? 0 : element.jobdetailid : element.jobdetailId;

      //     orderItemDetails.push(item);
      //   }

      // });

      additionalMaterialItems.forEach(element => {
        let orderjob: any = [];
        let item: any = {};
        if (element.defaultitemname.length > 0 && element.itemName !== '' && element.processname !== '') {
          item.id = element.id;
          // item.orderID = orderlistitem[0].orderID;
          item.orderId = orderlistitem.length > 0 ? orderlistitem[0].orderID : 0;

          item.itemNo = element.itemNo;
          // item.itemname =this.state.vendorordertype === 'Process' ?  element.processname : element.itemName ;
          // item.ItemDesc = element.itemDesc == "" ? element.itemName : element.itemDesc;
          item.itemname = element.processname || element.itemName;
          item.ItemDesc = element.jdescription || element.itemDesc;
          item.MSCode = element.glCode;
          item.Unit = element.unit;
          item.notes =  element.notes ? element.notes : "";
          item.unitPrice = Utils.removeInvaildCharFromAmount(element.unitPrice);
          if (item.unitPrice == "" || item.unitPrice == null) {

            item.unitPrice = 0;
          }
            item.discount = Utils.removeInvaildCharFromAmount(element.discount);
            if (item.discount == "" || item.discount == null) {
              item.discount = 0;
            }
          item.qtyOrdered = element.qty;
          // item.TenantId = orderlistitem[0].tenantid;
          item.TenantId = orderlistitem.length > 0 ? orderlistitem[0].tenantid : 0;
          item.isAdditionItem = true;
          item.selectedIDs = element.selectedIDs;
          item.selectedPartIDs = element.selectedPartIDs || [];
          item.jobdetailId = element.jobdetailId == undefined ? element.jobdetailid==undefined ? 0 : element.jobdetailid : element.jobdetailId;

          //let jobIds = element.jobId.split(',');
          // let jobIds = element.selectedIDs == undefined ? element.jobId.split(',') : element.selectedIDs;
          if (item.selectedIDs && item.selectedIDs.length == 0) {

            let jobIds;
            if (element.jobId == undefined || element.selectedIDs == undefined) {
              jobIds = [];

            }
            else {

              jobIds = element.selectedIDs == undefined ? element.jobId.split(',') : element.selectedIDs;
              // let jobIds = element.jobId.split(',');
            }
            jobIds.forEach(jobId => {

              let itemjob: any = {};
              itemjob.jobid = element.selectedIDs == undefined ? parseInt(jobId) : parseInt(jobId.jobid);
              orderjob.push(itemjob);
            });

            item.selectedIds = orderjob;
          }
          orderItemDetails.push(item);
        }

      });
    }
      console.log("additionalMaterialerialItems",orderItemDetails);

    this.state.formData.VendorOrderItemDetails = orderItemDetails;
    //////

    if (this.state.vendorordertype === 'Process') {

      let saveItems: any = [];
      let jobdetailsList = this.state.jobdetailsdata;
      let isvalid: any = 0;

      if (isvalid == 0) {
        additionalMaterialItems[0].defaultitemname.length > 0 && additionalMaterialItems.forEach(element => {
          let item: any = {};
     
            let jobIds;
    
      debugger;
      if(element.defaultitemname.length > 0){
      if (jobIds != undefined) {
  debugger;
        if (jobIds.length == 0) {
      jobIds = element.selectedIDs;
          jobIds.forEach(jobId => {
          
          item.orderid = element.orderid || element.orderId;
          item.jobid =element.selectedIDs == undefined ? parseInt(jobId) : parseInt(jobId.jobid);
          item.processid = element.processid || element.defaultitemname[0].id;
          item.processname = element.processname || element.defaultitemname[0].itemName;
          item.type = element.type;
          item.MSCode = element.glCode || element.defaultitemname[0].glCode;
          item.jdescription = element.jdescription || element.itemDesc;
          item.tenantid = element.tenantid || element.tenantId;
          item.qtyOrdered = element.qty;
          item.unitPrice = Utils.removeInvaildCharFromAmount(element.unitPrice);
          if (item.unitPrice == "" || item.unitPrice == null) {

            item.unitPrice = 0;
          }
          item.jobdetailId = element.jobdetailId == undefined ? element.jobdetailid==undefined ? 0 : element.jobdetailid : element.jobdetailId;
          saveItems.push(item);
          
          });
        }
        else
        {
          debugger;
          item.orderid = this.state.vendororderid;
          item.jobid =0;
          item.processid = element.processid || element.defaultitemname[0].id;
          item.processname = element.processname || element.defaultitemname[0].itemName;
          item.type = element.type;
          item.MSCode = element.glCode || element.defaultitemname[0].glCode;
          item.jdescription = element.jdescription || element.itemDesc;
          item.tenantid = element.tenantid || element.tenantId;
          item.qtyOrdered = element.qty;
          item.unitPrice = Utils.removeInvaildCharFromAmount(element.unitPrice);
          if (item.unitPrice == "" || item.unitPrice == null) {

            item.unitPrice = 0;
          }
          item.jobdetailId = element.jobdetailId == undefined ? element.jobdetailid==undefined ? 0 : element.jobdetailid : element.jobdetailId;
          saveItems.push(item);
        }
      
      }
        else
        {

            
          item.orderid = this.state.vendororderid;
          item.jobid =0;

          item.processid = element.processid || element.defaultitemname[0].id;
          item.processname = element.processname || element.defaultitemname[0].itemName;
          item.type = element.type;
          item.MSCode = element.glCode || element.defaultitemname[0].glCode;
          item.jdescription = element.jdescription || element.itemDesc;
          item.tenantid = element.tenantid || element.tenantId;
          item.qtyOrdered = element.qty;
          item.unitPrice = Utils.removeInvaildCharFromAmount(element.unitPrice);
          if (item.unitPrice == "" || item.unitPrice == null) {

            item.unitPrice = 0;
          }
          item.jobdetailId = element.jobdetailId == undefined ? element.jobdetailid==undefined ? 0 : element.jobdetailid : element.jobdetailId;
          saveItems.push(item);
        }
          }
        });



        this.state.formData.Vendor3PartyOrderItems = saveItems;
      }
    }
    if (this.state.vendorordertype === 'Process') {
      if (this.state.formData.Vendor3PartyOrderItems.length == 0) {
        //alert('Please select at least one item to save');
        toast.error("Please select at least one item to save", {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "OrderSlideout",
        });

        return;
      }



      // if (this.state.formData.Vendor3PartyOrderItems.filter((x) => x.qtyOrdered < 0 || x.qtyOrdered == 0 || x.qtyOrdered == "" || x.qtyOrdered == undefined).length != 0) {

      //   toast.error("Please check Qty.", {
      //     position: toast.POSITION.BOTTOM_RIGHT,
      //     containerId: "OrderSlideout",
      //   });
      //   return;
      // }

      // if(this.state.formData.Vendor3PartyOrderItems.filter((x) => Number(Utils.removeInvaildCharFromAmount(x.unitPrice)) <0 || Number(Utils.removeInvaildCharFromAmount(x.unitPrice)) ==0 || x.unitPrice ==""  || x.unitPrice ==undefined).length != 0)
      // {

      //   toast.error("Please check Unit price.", {
      //     position: toast.POSITION.BOTTOM_RIGHT,
      //     containerId: "OrderSlideout",
      //   });
      //   return;
      // }
    }
    else if (this.state.vendorordertype === 'Miscellaneouss') {
      if (this.state.formData.VendorOrderItemDetails.length == 0) {
        //alert('Please select at least one item to save');
        toast.error("Please add at least one item to save", {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "OrderSlideout",
        });
        return;
      }

      // if (this.state.formData.VendorOrderItemDetails.filter((x) => x.qtyOrdered == 0 || x.qtyOrdered == '' || x.qtyOrdered == undefined).length > 0) {
      //   //alert('Please select at least one item to save');
      //   toast.error("Please check Qty.", {
      //     position: toast.POSITION.BOTTOM_RIGHT,
      //     containerId: "OrderSlideout",
      //   });
      //   return;
      // }

      // if(this.state.formData.VendorOrderItemDetails.filter((x)=>Number(Utils.removeInvaildCharFromAmount(x.unitPrice)) == 0 || Utils.removeInvaildCharFromAmount(x.unitPrice)=='').length > 0)
      // {
      //          //alert('Please select at least one item to save');
      //          toast.error("Please check Unit Price.", {
      //           position: toast.POSITION.BOTTOM_RIGHT,
      //           containerId: "OrderSlideout",
      //         });
      //          return;
      // }
    }
    else {

      //       let itemList  = jobOrderList.filter((x)=>x.rowType == 2 && ( x.qty<0 || x.qty=="") && jobOrderList.filter((y)=> y.selected == true && y.itemId == x.itemId).length > 0);


      // if(itemList!=0)
      // {
      //      //alert('Please select at least one item to save');
      //      toast.error("Please check qty.", {
      //       position: toast.POSITION.BOTTOM_RIGHT,
      //       containerId: "OrderSlideout",
      //     });
      //      return;
      // }

      // if (this.state.formData.OrderItems.length == 0) {
      //   //alert('Please select at least one item to save');
      //   toast.error("Please select at least one item to save", {
      //     position: toast.POSITION.BOTTOM_RIGHT,
      //     containerId: "OrderSlideout",
      //   });
      //   return;
      // }

      if (this.state.formData.VendorOrderItemDetails.length == 0) {
        //alert('Please select at least one item to save');
        toast.error("Please add at least one item to save", {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "OrderSlideout",
        });
        return;
      }


      // if (this.state.formData.VendorOrderItemDetails.filter((x) => x.qtyOrdered == 0 || x.qtyOrdered == '' || x.qtyOrdered == undefined).length > 0) {
      //   //alert('Please select at least one item to save');
      //   toast.error("Please check Qty.", {
      //     position: toast.POSITION.BOTTOM_RIGHT,
      //     containerId: "OrderSlideout",
      //   });
      //   return;
      // }

      // if(this.state.formData.VendorOrderItemDetails.filter((x)=>Number(Utils.removeInvaildCharFromAmount(x.unitPrice)) == 0 || Utils.removeInvaildCharFromAmount(x.unitPrice)=='').length > 0)
      // {
      //          //alert('Please select at least one item to save');
      //          toast.error("Please check Unit Price.", {
      //           position: toast.POSITION.BOTTOM_RIGHT,
      //           containerId: "OrderSlideout",
      //         });
      //          return;
      // }

      // if (additionalMaterialItems.filter((x) => x.qty == 0 && x.itemName !== '').length > 0) {
      //   //alert('Please select at least one item to save');
      //   toast.error("Please check Qty on Additional Section.", {
      //     position: toast.POSITION.BOTTOM_RIGHT,
      //     containerId: "OrderSlideout",
      //   });
      //   return;
      // }

      // if(additionalMaterialItems.filter((x)=>Number(Utils.removeInvaildCharFromAmount(x.unitPrice)) == 0  && x.itemName !== '').length > 0)
      // {
      //          //alert('Please select at least one item to save');
      //          toast.error("Please check Unit Price on Additional Section.", {
      //           position: toast.POSITION.BOTTOM_RIGHT,
      //           containerId: "OrderSlideout",
      //         });
      //          return;
      // }

      // if(additionalMaterialItems.filter((x)=>(x.jobNo == undefined  || x.jobNo == '') && x.itemName !== '').length > 0)
      //   {
      //            //alert('Please select at least one item to save');
      //            toast.error("Please check Job on additional section.", {
      //             position: toast.POSITION.BOTTOM_RIGHT,
      //             containerId: "OrderSlideout",
      //           });
      //            return;
      //   }


    }

    if (this.state.formData.CustomerID === 0) {
      toast.error("Please select Vendor.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "OrderSlideout",
      });

      return false;
    }



    if (new Date(this.state.formData.duedate) < new Date(this.state.formData.OrderDate)) {
      toast.error("Due Date cannot be less then order date.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "OrderSlideout",
      });

      return false;
    }


    // const hasDuplicateJobIdForSameItem = this.state.formData.VendorOrderItemDetails.some((currentItem, index) => {
    //   return this.state.formData.VendorOrderItemDetails
    //     .slice(index + 1)
    //     .some((compareItem) => {
    //       if (currentItem.itemname === compareItem.itemname) {
    //         return currentItem.selectedIDs
    //           .map((currentSelected) => currentSelected.jobid)
    //           .some((jobid) =>
    //             compareItem.selectedIDs.some(
    //               (compareSelected) => compareSelected.jobid === jobid
    //             )
    //           );
    //       }
    //       return false;
    //     });
    // });
    
    // if (hasDuplicateJobIdForSameItem) {
    //   toast.error("Duplicate JO# for same item name.", {
    //     position: toast.POSITION.BOTTOM_RIGHT,
    //     containerId: "OrderSlideout",
    //   });
    //   return;
    // }


    this.setState({ ispopupshow: false, isSpinner: true });
    this.state.formData.VendorOrderType = this.state.vendorordertype;
    this.state.formData.POInitiated = this.state.formData.POInitiated == true ? this.state.formData.POInitiated : isSubmit;


    request = Object.assign({}, JSON.parse(JSON.stringify(this.state.formData)));
    // request.Vendor3PartyOrderItems = Vendor3PartyOrderItems;
    request.contactName = this.state.formData.firstname;
    request.OrderDate = Utils.toLocalISOString(new Date(request.OrderDate));
    request.duedate = Utils.toLocalISOString(new Date(request.duedate));


    isFormValid = true;


    if (isFormValid) {
      console.log("req save", request);
      this.setState({ ispopupshow: false,isSpinner:true });
      // return;
      if(files){
        request.VendorOrderItemDetails = this.state.formData.VendorOrderItemDetails.map(item => {
          return {
              Id: item.id,                        
              IsAdditionItem: item.isAdditionItem, 
              ItemNo: item.itemNo,                
              ItemName: item.itemname,           
              JobDetailId: item.jobdetailId,       
              OrderId: item.orderId,              
              QtyOrdered: item.qtyOrdered,         
              UnitPrice: item.unitPrice ,
              ...item             
             };
      });
      request.DueDate = Utils.toLocalISOString(new Date(this.state.formData.duedate));
        VendorService.SaveorderFiles(request,files)
        .then(async (result: any | null) => {
          if (result !== null) {
         

              if (this.state.vendororderid === 0 || this.state.vendororderid == undefined) {
                this.state.formData.OrderID = result.orderID;
                this.state.formData.CustomerPoNumber = result.vendorPoNumber;
                this.setState({ vendororderid: result.orderID, isApproved: true, },()=>{
                    this.GetUploadFileList( this.state.vendororderid, 1);
                });
                let message = result.vendorPoNumber + " order has been created.";
                toast.success(message, {
                  position: toast.POSITION.BOTTOM_RIGHT,
                  containerId: "OrderSlideout",
                });
              }
              else {
                this.GetUploadFileList( this.state.vendororderid, 1);
                  let message = "The Order has been updated.";
                  toast.success(message, {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    containerId: "OrderSlideout",
                  });

              }

              if (isSubmit == true) {

                this.closeSlideOut();
              }

              this.setState({ showAfterSaveModelPopup: false, editMode: true, isSpinner: false, isStateChanged: false, });

          }
          resolve();
        })
        .catch((error) => {
          this.setState({ isdefaultColDisabled: false, isSpinner: false });
          reject();
        });
      }else{
      VendorService.Saveorder(request)
        .then(async (result: any | null) => {
          if (result !== null) {
            if (this.state.vendororderid === 0 || this.state.vendororderid == undefined) {
              this.state.formData.OrderID = result.orderID;
              this.state.formData.CustomerPoNumber = result.vendorPoNumber;
              this.setState({ vendororderid: result.orderID, isApproved: true});
              let message = result.vendorPoNumber + " order has been created.";
              toast.success(message, {
                position: toast.POSITION.BOTTOM_RIGHT,
                containerId: "OrderSlideout",
              });
            }
            else {

                let message = this.state.formData.Status == "Inactive" ? "The Order has been cancelled." : "The Order has been updated.";
                toast.success(message, {
                  position: toast.POSITION.BOTTOM_RIGHT,
                  containerId: "OrderSlideout",
                });

            }

              if (isSubmit == true && isprint != 2) {

                this.closeSlideOut();
              }

              this.setState({ showAfterSaveModelPopup: false, editMode: true, isSpinner: false, isStateChanged: false, },()=>{
                 this.GetItemlist();
              this.GetorderEntryColoumn();   
              });

              if (isprint == 1) {
                this.printOrder();
              }
              if (isprint == 2) {

                this.mailOrder();
              }


          }
          resolve();
        })
        .catch((error) => {
          this.setState({ isdefaultColDisabled: false, isSpinner: false });
          reject();
        });
      }
    }
  };


  saveOrder = (entryType, isSubmit) => {
    this.saveOrderfinal("order", isSubmit, 0);
  };

  deleteVendorOrder = () => {
    this.setState({ isSpinner: true });
    let request = { ...this.state.requestlist };
    request.vendororderid = this.state.vendororderid;
    request.vendorid = this.state.formData.CustomerID;
    VendorService.DeleteVendorOrder(request)
      .then(async (result: any | null) => {
        if (result !== null) {

          this.closeSlideOut();

          toast.success("Vendor Order has been deleted.", {
            position: toast.POSITION.BOTTOM_RIGHT,
            containerId: "OrderSlideout",
          });



          this.setState({ isSpinner: false });

        }
        resolve();
      })
      .catch((error) => {
        this.setState({ isdefaultColDisabled: false, isSpinner: false });
        reject();
      });
  };


  downloadVendorOrderFile = (file: any) => {
    let request: any = {};
    request.orderid = this.state.vendororderid;
    request.tenantid = 0;
    request.vendorordertype = this.state.vendorordertype;
    request.jobid = this.props.jobid;

    this.setState({ isSpinner: true });

    VendorService.DownloadVendorOrderFile(request)
      .then(async (result: any | null) => {
        //this.HidecloseSlideOut();
        this.setState({ showAfterSaveModelPopup: false, isSpinner: false, });
        resolve();
      })
      .catch((error) => {
        reject();
        this.setState({ showAfterSaveModelPopup: false, isSpinner: false, });
      });
  };
   base64ToFile = (base64String: string, fileName: string): File => {
    const arr = base64String.split(',');
    const mime = arr[0].match(/:(.*?);/)![1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], fileName, { type: mime });
  };


  SendMailToVendor = () => {
    let request: any = {};
    request.orderid = this.state.vendororderid;
    request.tenantid = 0;
    request.vendorordertype = this.state.vendorordertype;
    request.jobid = this.props.jobid;

    //let selectedVendor = this.state.customerList.filter((x) => x.vendor_id === this.state.formData.CustomerID); 
    if (this.state.mailContent.MailTo == '')
      return;

    
      const files = this.state.isAttachments
    ? (this.state.savedfiles || []).map(f => this.base64ToFile(f.fileCode, f.fileName))
    : [];

    let item: any = {};
    item.mailTo = this.state.mailContent.MailTo; //selectedVendor[0].email;
    item.mailCC = this.state.mailContent.CC;
    // item.subject = 'Vendor Order';
    item.subject =  this.state.mailContent.subject;
    item.mailBody = this.state.mailContent.Message; //3'Please find the attachment for order detail.';
    item.isBodyHtml = true;
    item.sendFrom = '';
    item.mailFrom = '';

  const formData = new FormData();
  formData.append('mailTo', this.state.mailContent.MailTo);
  formData.append('mailCC', this.state.mailContent.CC);
  formData.append('subject', this.state.mailContent.subject);
  formData.append('mailBody', this.state.mailContent.Message);
  formData.append('isBodyHtml', 'true');
  formData.append('sendFrom', '');
  formData.append('mailFrom', '');

  files.forEach(file => {
    formData.append('files', file);
  });

    this.setState({ isSpinner: true });
    VendorService.SendMailToVendor(request, formData)
      .then(async (result: any | null) => {
        //this.HidecloseSlideOut();
        toast.success("Email sent to vendor.", {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "OrderSlideout",
        });

        this.setState({ showAfterSaveModelPopup: false, isSpinner: false, },()=>{
             VendorService.VendorEmailTrack({orderid:this.state.vendororderid})
                .then(async (result: any[] | null) => {
                  if (result != null) {
                   this.setState({sentDate:result});
                  }
                  resolve();
                })
                .catch((err: any) => {
                  toast.error(`Server Error, ${err}`);
                  reject();
                });
        });
        resolve();
      })
      .catch((error) => {
        reject();
        this.setState({ showAfterSaveModelPopup: false, isSpinner: false, });
      });
  };


  rowEvents = {
    onClick: (e: any, row: any, rowIndex: any) => {
      //this.setState({ showSlideout: true ,orderid:row.orderID
      // });
    },
  };


  handleRowSelectionCheckAllMaterial = (e,index) => {
    const {prevOrderidselected} = this.state;
    let splitDetail: any = [];
    splitDetail = this.state.jobOrderlistByItem.filter(
      (x) => x.itemId === prevOrderidselected && x.rowType === 2 
      // (x) => x.itemId === prevOrderidselected && x.rowType === 2 && (x.selected === true || x.selected === false|| this.state.vendororderid == 0)
    );
    
console.log("splitDetail",splitDetail);
      if (splitDetail.length > 0) {
        // splitDetail.forEach((element: any, index: any) => {
        //   setTimeout(() => {
            this.handleRowSelectionCheck("", null, null, true,"all",splitDetail);
          // }, 100 * index);
        };
        
      

      //  this.setState(prevState => ({
      //   additionalMaterialItems: [...prevState.additionalMaterialItems, data]    }));
  };


  handleRowSelectionCheckAllJob = () => {
    console.log("handleRowSelectionCheckAllJob ------");
    if (this != undefined) {

      let data = this.state.jobdetailsdata.filter((x) => x.selected === true || this.state.editMode || this.state.vendororderid == 0);

      if (data.length > 0) {
        data.forEach((element: any, index: any) => {
          //  this.handleRowSelectionn(e,0,prevorderid);
          this.handleRowSelectionCheckJob("", index, element, "all");
        });
      }

      console.log("data", data);
      //  this.setState(prevState => ({
      //   additionalMaterialItems: [...prevState.additionalMaterialItems, data]    }));
    }
  };

  
  handleRowSelectionCheckAllJobMat = () => {
    console.log("handleRowSelectionCheckAllJob");
    if (this != undefined) {

      let data = this.state.jobOrderlistByItem.filter((x) => x.selected === true || this.state.editMode || this.state.vendororderid == 0);

      if (data.length > 0) {
        data.forEach((element: any, index: any) => {
          //  this.handleRowSelectionn(e,0,prevorderid);
          this.handleRowSelectionCheckJob("", index, element, "all");
        });
      }

      console.log("data", data);
      //  this.setState(prevState => ({
      //   additionalMaterialItems: [...prevState.additionalMaterialItems, data]    }));
    }
  };


  handleRowSelectionCheck = (e, rowData, row, selected, type,splitDetail) => {
    let updatedItems = [...this.state.additionalMaterialItems];

    if(type == "all"){
      const duplicateJobId = updatedItems.some(item =>
        Array.isArray(item.selectedIDs) && 
        item.selectedIDs.some(selectedItem =>
          splitDetail.some(rowItem => rowItem.jobId === selectedItem.jobid)
        )
      );
  
      // console.log("validation testing", updatedItems,row,duplicateJobId);
  
      if (duplicateJobId) {
        toast.error("Duplicate record not allowed", {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "OrderSlideout",
        });
        return; 
      }
    }else{
      const duplicateJobId = updatedItems.some(item =>
        Array.isArray(item.selectedIDs) && 
        item.selectedIDs.some(selectedItem => selectedItem.jobid === row.jobId)
      );
  
      console.log("validation testing", updatedItems,row,duplicateJobId);
  
      if (duplicateJobId) {
        toast.error("Duplicate record not allowed", {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "OrderSlideout",
        });
        return; 
      }
    }
   

    if (updatedItems[updatedItems.length - 1].glCode === "" && updatedItems[updatedItems.length - 1].defaultitemname.length === 0 && updatedItems[updatedItems.length - 1].defaultjobno.length === 0 && updatedItems[updatedItems.length - 1].qty === 0 && (updatedItems[updatedItems.length - 1].unit === "" || updatedItems[updatedItems.length - 1].unit === 0) && (updatedItems[updatedItems.length - 1].unitPrice === Utils.currencyFormat(0) || updatedItems[updatedItems.length - 1].unitPrice === 0)) {
      updatedItems.pop();
    }

    this.setState({ additionalMaterialItems: updatedItems }, () => {
      if(type==="all"){
        this.updateRowSelectionCheckMaterial(splitDetail);
      }else{
        this.updateRowSelectionCheck(e, rowData, row, selected);
      }
    });
  };

  updateRowSelectionCheckMaterial = (rows) => {
    let updatedItems = [...this.state.additionalMaterialItems];
  
    let JODetails = this.state.JODetails.map(jobDetail => ({
      ...jobDetail,
      isChecked: rows.some(row => row.jobId === jobDetail.jobid) ? true : jobDetail.isChecked,
    }));
  
    const aggregatedMaterialItem = {
       ...rows[0],
       srno: this.state.additionalMaterialItems.length +1 ,
      itemNo: rows[0].itemId || 0,
      defaultitemname: [{
        itemName: rows[0].itemName,
        label: rows[0].itemName,
        unitPrice: rows[0].unitPrice,
        qty: rows.reduce((sum, row) => sum + parseInt(row.qty, 10), 0),
        id: rows[0].itemId,
      }],
      defaultjobno: rows.map(row => ({
        jobNo: row.jobNo,
        label: row.jobNo,
        jobId: row.jobId,
      })),
      defaultcustomerPoNumber: [{
        customerPoNumber: rows[0].customerPoNumber,
        label: rows[0].customerPoNumber,
        id: rows[0].id,
      }],
      JODetails: JODetails,
      jobdetailId: rows[0].jobdetailId === undefined ? rows[0].jobdetailid : rows[0].jobdetailId,
      selectedIDs: rows.map(row => ({
        id: 0,
        jobid: row.jobId,
        jobno: row.jobNo,
      })),
      qty: rows.reduce((sum, row) => sum + parseInt(row.qty, 10), 0),
    };
  
    updatedItems.push(aggregatedMaterialItem);
    this.setState({ additionalMaterialItems: updatedItems }, () => {
      console.log("State updated with new material item:", this.state.additionalMaterialItems);
    });
  };
  


  updateRowSelectionCheck = (e, rowData, row, selected) => {
    let updatedItems = [...this.state.additionalMaterialItems];
    let JODetails = this.state.JODetails.map(jobDetail => ({
      ...jobDetail,
      isChecked: jobDetail.jobid === row.jobId ? true : jobDetail.isChecked,
    }));

    const newMaterialItem = {
      ...row,
      srno: this.state.additionalMaterialItems.length + 1,
      itemNo:row.itemId || 0,
      defaultitemname: [{
        itemName: row.itemName,
        label: row.itemName,
        unitPrice: row.unitPrice,
        qty: row.qty,
        id: row.itemId,
      }],
      defaultjobno: [{
        jobNo: row.jobNo,
        label: row.jobNo,
        jobId: row.jobId,
      }],
      defaultcustomerPoNumber: [{
        customerPoNumber: row.customerPoNumber,
        label: row.customerPoNumber,
        id: row.id,
      }],
      JODetails: JODetails,
      jobdetailId: row.jobdetailId==undefined ? row.jobdetailid : row.jobdetailId,
      selectedIDs: [{
        id: 0,
        jobid: row.jobId,
        jobno: row.jobNo,
      }]
    };

    updatedItems.push(newMaterialItem);
    this.setState({ additionalMaterialItems: [...updatedItems] }, () => {
      console.log("State updated with new material item:", this.state.additionalMaterialItems);
    });
  };


  handleRowSelectionCheckJob = (e, rowData, row, selected) => {
    debugger;
    let updatedItems = [...this.state.additionalMaterialItems];
   console.log("updated",updatedItems,row);
   const duplicateJobId = updatedItems.some(item => item.jobid === row.jobid &&  item.jobdetailId === row.jobdetailId);
   if (duplicateJobId) {
     toast.error("Duplicate record not allowed", {
       position: toast.POSITION.BOTTOM_RIGHT,
       containerId: "OrderSlideout",
     });
     return; 
   }
    if(updatedItems[updatedItems.length - 1].glCode === "" && updatedItems[updatedItems.length - 1].defaultitemname.length === 0 && updatedItems[updatedItems.length - 1].defaultjobno.length === 0 && updatedItems[updatedItems.length - 1].qty === 0 && (updatedItems[updatedItems.length - 1].unit === 0 || updatedItems[updatedItems.length - 1].unit === "" ) && (updatedItems[updatedItems.length - 1].unitPrice === Utils.currencyFormat(0) ||  updatedItems[updatedItems.length - 1].unitPrice === 0)){
      updatedItems.pop();   
     }
  
    this.setState({ additionalMaterialItems: updatedItems }, () => {
      this.updateRowSelectionCheckJob(e, rowData, row, selected);
    });
  };


  updateRowSelectionCheckJob = (e, rowData, row, selected) => {
    console.log("job----", this.state.jobdetailsdata);


    console.log("row select", row, rowData);
    console.log("selected", row.qtyOrdered);
    console.log("material select", this.state.additionalMaterialItems);

    let JODetails = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.JODetails))
    );


    JODetails.forEach(jobDetail => {
      if (jobDetail.jobid === row.jobid) {
        jobDetail.isChecked = true;
      }
    });





    const newMaterialItem = {
      ...row,
      srno: selected === "true" ? this.state.additionalMaterialItems.length + 1 : this.state.additionalMaterialItems.length + rowData + 1,
      defaultitemname: [{
        itemName: `${row.processname}\n${row.jdescription}`,
        label: row.processname,
        unitPrice: row.unitPrice,
        qty: row.qtyOrdered,
        id: row.id,
      }],
      defaultjobno: [{
        jobNo: row.jobNo,
        label: row.jobNo,
        jobId: row.jobid
      }],
      defaultcustomerPoNumber: [{
        customerPoNumber: row.customerPoNumber,
        label: row.customerPoNumber,
        id: row.id
      }],
      JODetails: JODetails,
      itemNo:row.processid || 0,
      qty: row.qtyOrdered,
      jobid: row.jobid,
      jobdetailId:  row.jobdetailId==undefined ? row.jobdetailid : row.jobdetailId,
      selectedIDs: [{
        id: 0,
        jobid: row.jobid,
        jobno: row.jobNo
      }]
    };



    this.setState(prevState => {
      const updatedItems = [...prevState.additionalMaterialItems];
      updatedItems.push(newMaterialItem);

      return {
        additionalMaterialItems: updatedItems
      };
    });



  };



  handleOnSelect = (row, isSelect) => {

    let jobOrderlistByItem = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.jobOrderlistByItem))
    );

    let listItem = jobOrderlistByItem.filter(
      (x) => x.rowId === row.rowId
    );

    listItem[0].selected = isSelect;

    this.setState({ jobOrderlistByItem: jobOrderlistByItem });


  };

  handleOnSelectAll = (isSelect, rows) => {

    const ids = rows.map(r => r.rowId);

    let jobOrderlistByItem = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.jobOrderlistByItem))
    );

    let listItems = jobOrderlistByItem.filter(
      (x) => ids.includes(x.rowId)
    );

    if (listItems.length > 0) {
      listItems.forEach((element: any, index: any) => {
        element.selected = isSelect;
      });
    };

    this.setState({ jobOrderlistByItem: jobOrderlistByItem });
  };

  handleOnSelectForJob = (row, isSelect) => {

    let jobdetailsItem = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.jobdetailsdata))
    );

    let listItem = jobdetailsItem.filter(
      (x) => x.id === row.id
    );

    listItem[0].selected = isSelect;

    this.setState({ jobdetailsdata: jobdetailsItem });


  };

  handleOnSelectAllForJob = (isSelect, rows) => {

    const ids = rows.map(r => r.id);

    let jobdetailsItem = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.jobdetailsdata))
    );

    let listItems = jobdetailsItem.filter(
      (x) => ids.includes(x.id)
    );

    if (listItems.length > 0) {
      listItems.forEach((element: any, index: any) => {
        element.selected = isSelect;
      });
    };

    this.setState({ jobdetailsdata: jobdetailsItem });
  };

  showSlideOut = (row, type) => {
    debugger;
    if (type === 'customer') {
      this.setState({ showCustomerSlideout: true, isStateChanged: false, showJobSlideout: false, orderid: row.customerOrderId ? row.customerOrderId : row.orderId });
    }
    else if (type === 'job') {

      let itemNo = Utils.extractNumberAfterHyphen(row.jobNo);
      this.setState({ showJobSlideout: true, showCustomerSlideout: false, isStateChanged: false, orderdetailid: row.customerOrderDetailId ? row.customerOrderDetailId : row.orderDetailId, jobid: row.jobid==undefined ? row.jobId : row.jobid, qtyOrdered: row.qty, partname: row.partName, partNo: row.partNo, selectedCustomer: row.customerName, productid: row.partId, CustomerPoNumber: row.customerPoNumber, itemNo: itemNo });
    }
  };

  handleClose = () => {
    this.setState({ showAfterSaveModelPopup: false, isSpinner: false, });
  };

  actionclick = (eventKey: any) => {
    if (eventKey == "Delete") {
      // this.deleteVendorOrder();
      let masg = "";

      masg = "Are you sure you want to delete this vendor order?";

      confirmAlert({
        title: "Delete Order",

        message: masg,
        buttons: [
          {
            label: "Yes",
            onClick: () => this.deleteVendorOrder(),
          },
          {
            label: "No",
            onClick: () => reject(),
          },
        ],

        closeOnEscape: false,
        closeOnClickOutside: false,
      });
    }
    else if (eventKey == "Print") {

      if (this.state.isStateChanged == true) {

        this.saveOrderfinal("order", false, 1);

      }
      else {
        this.printOrder();
      }
    }
    else if (eventKey == "Email") {

      if (this.state.isStateChanged == true) {

        this.saveOrderfinal("order", false, 2);

      }
      else {
        this.mailOrder();
      }

    }else if (eventKey == "Cancel") {
      this.setState({confirmPopup:true});
    }else if (eventKey == "confirmCancel") {
      const {formData} = this.state;
      formData.Status = 'Inactive';
      this.setState({formData,confirmPopup:false},()=>{
        this.saveOrder("order", false);
      });
    }
    else {
      this.props.reopenSlideOutWithReworkJob();
    }
  };

  ConfirmSendtoBack = () => {

    let masg = "";

    masg = "Are you sure you want to send  back to receiving?";

    confirmAlert({
      title: "Send back to Receiving",

      message: masg,
      buttons: [
        {
          label: "Yes",
          onClick: () => this.sendBackToReceiving(),
        },
        {
          label: "No",
          onClick: () => reject(),
        },
      ],

      closeOnEscape: false,
      closeOnClickOutside: false,
    });

  };

  sendBackToReceiving = () => {

    let request: any = {};
    let receivingData: any = [];
    let vendorDetails: any = [];

    // if(this.state.vendorordertype === 'Material')
    // {
    //   vendorDetails = this.state.jobOrderlistByItem;
    // }
    // else if(this.state.vendorordertype === 'Miscellaneous')
    //   {
    //     vendorDetails = this.state.misclistByItem;
    //   }
    // else{
    //   vendorDetails = this.state.jobdetailsdata;
    // }
    //   vendorDetails= this.state.vendorOrderToUpdateList;
    //   vendorDetails.forEach(element => {
    // 
    let item: any = {};
    //     if(element.id > 0)
    //     {
    item.id = -1;
    item.received = '';
    item.qtyReceived = 0;
    item.vendorOrderType = this.state.vendorordertype;
    item.orderID = this.state.formData.OrderID;
    receivingData.push(item);
    //   }
    // });

    this.state.formData.ReceivingData = receivingData;
    request = Object.assign({}, JSON.parse(JSON.stringify(this.state.formData)));

    VendorService.SaveReceivingData(request)
      .then(async (result: any | null) => {
        if (result !== null) {
          this.closeSlideOut();
          toast.success("Order has been updated.", {
            position: toast.POSITION.BOTTOM_RIGHT,
            containerId: "OrderSlideout",
          });
        }
        resolve();
        this.setState({ isStateChanged: false, isSpinner: false });
      })
      .catch((error) => {
        this.setState({ isdefaultColDisabled: false, isSpinner: false, isStateChanged: false });
        reject();
      });

  };


  printOrder = () => {
    this.downloadVendorOrderFile(null);
    this.setState({ showAfterSaveModelPopup: false });
  };

  mailOrder = () => {
    // this.SendMailToVendor();
    this.setState({ showAfterSaveModelPopup: false, showMailPanel: true });
  };

  sendMail = () => {

    this.setState({ showMailPanel: false });
    this.SendMailToVendor();
    //this.setState({ showAfterSaveModelPopup: false });
  };

  cancelSendMail = () => {
    this.setState({ showMailPanel: false });
  };

  handleNewRowitems = () => {
    let misclistByItem: any = [];
    let newRow: any = {};
    let isStateChanged = true;
    let inventorydata: any = [];
    inventorydata = Object.assign([], JSON.parse(JSON.stringify(this.state.inventorydata)));
    const jodetails = Object.assign([], JSON.parse(JSON.stringify(this.state.JODetails)));

    misclistByItem = Object.assign([], JSON.parse(JSON.stringify(this.state.misclistByItem)));
    newRow = Object.assign({}, JSON.parse(JSON.stringify(this.state.itemdetailsdatanew)));

    let maxValueOfRow = Math.max(...misclistByItem.map(o => o.itemNo), 0);
    let len = misclistByItem.length;

    let maxSrno = len == 0 ? 0 : misclistByItem[len - 1].itemNo;
    newRow.srno = len == 0 ? 1 : (len + 1);
    newRow.itemNo = Number(maxSrno) + 1;
    newRow.unitPrice = 0;
    newRow.itemListdata = inventorydata;
    newRow.JODetails = jodetails;
    misclistByItem.push(newRow);

    this.setState({ misclistByItem: [] }, () => {
      this.setState({ misclistByItem: misclistByItem, isStateChanged });
    });
  };



  handleNewRowAdditionalMaterialItems = () => {

    //let misclistByItem: any = [];
    let newRow: any = {};
    let isStateChanged = true;
    let inventorydata: any = [];
    inventorydata = Object.assign([], JSON.parse(JSON.stringify(this.state.inventorydata)));
    const jodetails = Object.assign([], JSON.parse(JSON.stringify(this.state.JODetails)));
    const productJobList = Object.assign([], JSON.parse(JSON.stringify(this.state.productJobList)));
    console.log("additional new row", jodetails);
    let additionalMaterialItems = Object.assign([], JSON.parse(JSON.stringify(this.state.additionalMaterialItems)));
    console.log("upate data add new row add", additionalMaterialItems);
    // newRow = Object.assign({}, JSON.parse(JSON.stringify(this.state.itemdetailsdatanew)));

    let maxValueOfRow = Math.max(...additionalMaterialItems.map(o => o.itemNo), 0);
    let len = additionalMaterialItems.length;

    let maxSrno = len == 0 ? 0 : additionalMaterialItems[len - 1].itemNo;
    newRow.srno = len == 0 ? 1 : (len + 1);
    newRow.itemNo = Number(maxSrno) + 1;
    newRow.unitPrice = Number(Utils.removeInvaildCharFromAmount("0")),
    newRow.discount = Number(Utils.removeInvaildCharFromAmount("0")),
    newRow.itemListdata = inventorydata;
    newRow.JODetails = jodetails;
    newRow.productJobList = productJobList;
    newRow.defaultitemname = [];
    newRow.defaultunitname = [];
    newRow.qty = 0;
    newRow.defaultjobno = [];
    newRow.glCode="",
    newRow.unit="",
    additionalMaterialItems.push(newRow);

    this.setState({ additionalMaterialItems: [] }, () => {
      this.setState({ additionalMaterialItems: additionalMaterialItems, isStateChanged });
    });
  };

  handleButtonClick = () => {
    if (this.fileInputRef.current) {
      this.fileInputRef.current.click();
    }
  };

  handleItemDetailDeleteRow(row: any, mode: any) {
    if (mode) {

      let misclistByItem = Object.assign([], JSON.parse(JSON.stringify(this.state.misclistByItem)));

      this.setState({ misclistByItem: [] }, () => {


        const misclistByItemNewc = misclistByItem.filter(item => item.id !== row.id).map((item, index) => {
          //item.templateno = index + 1;
          return item;
        });

        this.setState({
          misclistByItem: misclistByItemNewc
        },
          () => {


          });
      });
    }
  }

   isdeleteconfirm(row: any) {
          
          let masg = "";
      
          masg = "Are you sure you want to delete this item?";
      
          confirmAlert({
            title: "Delete Item",
      
            message: masg,
            buttons: [
              {
                label: "Yes",
                onClick: () => this.handleAdditionalItemsDeleteRow(row, true),
              },
              {
                label: "No",
                onClick: () => reject(),
              },
            ],
      
            closeOnEscape: false,
            closeOnClickOutside: false,
          });
        }


  handleAdditionalItemsDeleteRow(row: any, mode: any) {
    if (mode) {

      let additionalMaterialItems = Object.assign([], JSON.parse(JSON.stringify(this.state.additionalMaterialItems)));

      this.setState({ additionalMaterialItems: [] }, () => {


        const additionalMaterialItemsNewc = additionalMaterialItems.filter(item => item.srno !== row.srno).map((item, index) => {
          //item.templateno = index + 1;
          return item;
        });

        this.setState({
          additionalMaterialItems: additionalMaterialItemsNewc, isStateChanged: true
        },
          () => { });
      });
    }
  }

  handleSelectedItem = (control: any, id: any) => {
    console.log("main id", id);
    if (this != undefined) {
      let isStateChanged = true;


      let formData = { ...this.state.formData };
      let controlID = Number(control.split("_")[0]);
      let rowIndex = Number(control.split("_")[1]);


      let defaultitemname: any = [];
      let defaultjobno: any = [];

      let inventorydata = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.inventorydata))
      );

       let unitList = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.unitList))
      );

      let misclistByItem = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.misclistByItem))
      );
      let additionalMaterialItems = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.additionalMaterialItems))
      );

      if (controlID === 1) {

        if (id.length > 0) {
          if (id[0].id > 0) {
            misclistByItem[rowIndex].itemName = id[0].selectitem;
            misclistByItem[rowIndex].itemNo = id[0].id;
            // misclistByItem[rowIndex].unitPrice = id[0].unitPrice;
            // misclistByItem[rowIndex].unit = id[0].unit;
            misclistByItem[rowIndex].glCode = id[0].description;
            // misclistByItem[rowIndex].qty = id[0].stockqty;


            misclistByItem[rowIndex].itemDesc = id[0].description;

            let objPartname: any = {};
            objPartname.itemName = id[0].selectitem;
            objPartname.label = id[0].selectitem;
            objPartname.id = id[0].id;
            objPartname.glCode = id[0].glcode;
            objPartname.qty = id[0].stockqty;
            objPartname.unitPrice = id[0].unitPrice;
            objPartname.unit = id[0].unit;
            objPartname.tenantid = 0;

            objPartname.itemDesc = id[0].description;
            defaultitemname.push(objPartname);

            misclistByItem[rowIndex].defaultitemname = defaultitemname;
            this.setState(
              { misclistByItem, defaultitemname, inventorydata, isStateChanged },
              () => {



                // 
                // let txtID ="rbt-input-main form-control rbt-input form-control form-control itemname" + rowIndex +"ddl";
                // $("input[class^='" + txtID + "']").focus();

              }
            );
            // this.setState(
            //   { itemdetailsdata, defaultitemname, inventorydata, isStateChanged },
            //   () => {

            //     let txtID = "txtglcode" + rowIndex + "txt";
            //     $("#tbltemplate")
            //       .find("input[id^='" + txtID + "']")
            //       .focus();
            //   }
            // );
          } else {
            misclistByItem[rowIndex].itemName = id[0].label;
            misclistByItem[rowIndex].id = 0;
            misclistByItem[rowIndex].glCode = "";
            misclistByItem[rowIndex].qty = 0;
            misclistByItem[rowIndex].unit = "";
            misclistByItem[rowIndex].unitPrice = 0;

            misclistByItem[rowIndex].itemDesc = "";

            let objPartname: any = {};
            objPartname.itemName = id[0].label;
            objPartname.label = id[0].label;
            objPartname.id = 0;
            objPartname.glCode = "";
            objPartname.unit = "";
            objPartname.qty = 0;

            objPartname.tenantid = 0;

            objPartname.unitPrice = 0;

            objPartname.itemDesc = "";
            defaultitemname.push(objPartname);
            inventorydata.push(objPartname);


            misclistByItem[rowIndex].defaultitemname = id;
            this.setState(
              { misclistByItem, defaultitemname, inventorydata, isStateChanged },
              () => {



                // 
                // let txtID ="rbt-input-main form-control rbt-input form-control form-control itemname" + rowIndex +"ddl";
                // $("input[class^='" + txtID + "']").focus();

              }
            );
            // this.setState(
            //   { itemdetailsdata, defaultitemname, inventorydata, isStateChanged },
            //   () => {

            //     let txtID = "txtglcode" + rowIndex + "txt";
            //     $("#tbltemplate")
            //       .find("input[id^='" + txtID + "']")
            //       .focus();
            //   }
            // );
          }
        } else {

          misclistByItem[rowIndex].itemName = "";
          misclistByItem[rowIndex].id = 0;
          misclistByItem[rowIndex].glCode = "";
          misclistByItem[rowIndex].qty = 0;
          misclistByItem[rowIndex].unitPrice = 0;
          misclistByItem[rowIndex].itemDesc = "";

          let objPartname: any = {};
          objPartname.itemName = "";
          objPartname.label = "";
          objPartname.id = 0;
          objPartname.glCode = "";
          objPartname.unit = "";
          objPartname.qty = 0;
          objPartname.tenantid = 0;

          objPartname.unitPrice = 0;

          objPartname.itemDesc = "";
          defaultitemname.push(objPartname);
          //inventorydata.push(objPartname);

          //element.defaultPartname = defaultPartname;
          misclistByItem[rowIndex].defaultitemname = id;
          this.setState(
            { misclistByItem, defaultitemname, inventorydata, isStateChanged },
            () => {



              // 
              // let txtID ="rbt-input-main form-control rbt-input form-control form-control itemname" + rowIndex +"ddl";
              // $("input[class^='" + txtID + "']").focus();

            }
          );

        }


      }
      else if (controlID === 2) {
        if (id.length > 0) {
          if (id[0].id > 0) {
            additionalMaterialItems[rowIndex].itemName = this.state.vendorordertype === "Material" ? id[0].selectitem: id[0].itemname;
            additionalMaterialItems[rowIndex].itemNo = id[0].id;
            // additionalMaterialItems[rowIndex].unitPrice = id[0].unitPrice;
            // additionalMaterialItems[rowIndex].unit = id[0].unit;
            additionalMaterialItems[rowIndex].glCode =  this.state.vendorordertype === "Material" ? id[0].description : "";
            // additionalMaterialItems[rowIndex].qty = id[0].stockqty;


            additionalMaterialItems[rowIndex].itemDesc = id[0].description;

            let objPartname: any = {};
            objPartname.itemName = this.state.vendorordertype === "Material" ? id[0].selectitem: id[0].itemname;
            objPartname.label = id[0].selectitem;
            objPartname.id = id[0].id;
            objPartname.glCode = id[0].glcode;
            objPartname.qty = id[0].stockqty;
            objPartname.unitPrice = id[0].unitPrice;
            objPartname.unit = id[0].unit;
            objPartname.tenantid = 0;
            objPartname.itemDesc = id[0].description;
            defaultitemname.push(objPartname);
            additionalMaterialItems[rowIndex].defaultitemname = defaultitemname;

          } else {
            additionalMaterialItems[rowIndex].itemName = id[0].label;
            additionalMaterialItems[rowIndex].id = 0;
            additionalMaterialItems[rowIndex].glCode = "";
            // additionalMaterialItems[rowIndex].qty = 0;
            // additionalMaterialItems[rowIndex].unit = "";
            // additionalMaterialItems[rowIndex].unitPrice = 0;

            additionalMaterialItems[rowIndex].itemDesc = "";

              let objPartname: any = {};
              objPartname.itemName = id[0].label;
              objPartname.label = id[0].label;
              objPartname.id = 0;
              objPartname.glCode = "";
              objPartname.unit = "";
              objPartname.qty = 0;
              objPartname.tenantid = 0;
              objPartname.unitPrice = 0;
              objPartname.itemDesc = "";
              defaultitemname.push(objPartname);
              inventorydata.push(objPartname); 
              additionalMaterialItems[rowIndex].defaultitemname =  this.state.vendorordertype === "Process" ? defaultitemname : id;

          }
        } else {

          additionalMaterialItems[rowIndex].itemName = "";
          additionalMaterialItems[rowIndex].id = 0;
          additionalMaterialItems[rowIndex].glCode = "";
          // additionalMaterialItems[rowIndex].qty = 0;
          // additionalMaterialItems[rowIndex].unitPrice = 0;
          additionalMaterialItems[rowIndex].itemDesc = "";

          let objPartname: any = {};
          objPartname.itemName = "";
          objPartname.label = "";
          objPartname.id = 0;
          objPartname.glCode = "";
          objPartname.unit = "";
          objPartname.qty = 0;
          objPartname.tenantid = 0;

          objPartname.unitPrice = 0;

          objPartname.itemDesc = "";
          defaultitemname.push(objPartname);
          additionalMaterialItems[rowIndex].defaultitemname = id;

        }

        this.setState(
          { additionalMaterialItems, defaultitemname, inventorydata, isStateChanged },
          () => {
            let txtID = "txtitemDesc" + rowIndex + "txt";
            $("#tblAdditionalMaterialItems").find("input[id^='" + txtID + "']").focus();
          });


      }
      else if (controlID === 3) {
        console.log("id---", id);

        if (id.length > 0) {
          if (id[0].jobid > 0) {
            // additionalMaterialItems[rowIndex].jobNo = id[0].jobNo;
            // additionalMaterialItems[rowIndex].jobId = id[0].jobid;

            // let objjobno: any = {};
            // objjobno.jobNo = id[0].jobNo;
            // objjobno.label = id[0].jobNo;
            // objjobno.jobId = id[0].jobid;
            // defaultjobno.push(objjobno);

            // additionalMaterialItems[rowIndex].defaultjobno = defaultjobno;

            additionalMaterialItems[rowIndex].defaultjobno = id;

          } else {
            // additionalMaterialItems[rowIndex].jobNo = id[0].label;
            // additionalMaterialItems[rowIndex].jobId = 0;

            // let objPartname: any = {};
            // objPartname.jobNo = id[0].label;
            // objPartname.label = id[0].label;
            // objPartname.jobId = 0;
            // defaultjobno.push(objPartname);
            additionalMaterialItems[rowIndex].defaultjobno = id;

          }
        } else {

          additionalMaterialItems[rowIndex].defaultjobno = [];

          // additionalMaterialItems[rowIndex].jobNo = "";
          // additionalMaterialItems[rowIndex].jobId = 0;

          // let objPartname: any = {};
          // objPartname.itemName = "";
          // objPartname.label = "";
          // objPartname.id = 0;

          // defaultjobno.push(objPartname);
          // additionalMaterialItems[rowIndex].defaultjobno = id;

        }
        this.setState(
          { additionalMaterialItems, isStateChanged },
          () => {
            // let txtID = "txtreqqty" + rowIndex + "txt";
            // $("#tblAdditionalMaterialItems").find("input[id^='" + txtID + "']").focus();
          });
      } else if (controlID === 4) {
        console.log("customerpo", id);

        if (id[0] && id[0].orderid > 0) {

          const orderid = id[0].orderid;
          this.GetJoblistById(orderid);
          additionalMaterialItems[rowIndex].defaultcustomerPoNumber = id;
        } else {
          additionalMaterialItems[rowIndex].defaultcustomerPoNumber = [];
        }
        this.setState(
          { additionalMaterialItems, isStateChanged },
          () => {
            // let txtID = "txtreqqty" + rowIndex + "txt";
            // $("#tblAdditionalMaterialItems").find("input[id^='" + txtID + "']").focus();
          });
      } else if (controlID === 5) {

        if (id.length > 0) {
          if (id[0].jobid > 0) {

            misclistByItem[rowIndex].defaultjobno = id;

          } else {

            misclistByItem[rowIndex].defaultjobno = id;

          }
        } else {

          misclistByItem[rowIndex].defaultjobno = [];

        }
        this.setState(
          { misclistByItem, isStateChanged },
          () => {
            // let txtID = "txtreqqty" + rowIndex + "txt";
            // $("#tblAdditionalMaterialItems").find("input[id^='" + txtID + "']").focus();
          });
      } else if (controlID === 6) {


        if (id[0] && id[0].orderid > 0) {

          const orderid = id[0].orderid;
          this.GetJoblistById(orderid);
          misclistByItem[rowIndex].defaultcustomerPoNumber = id;
        } else {
          misclistByItem[rowIndex].defaultcustomerPoNumber = [];
        }
        this.setState(
          { misclistByItem, isStateChanged },
          () => {
            // let txtID = "txtreqqty" + rowIndex + "txt";
            // $("#tblAdditionalMaterialItems").find("input[id^='" + txtID + "']").focus();
          });
      }else if (controlID === 7) {
        if (id.length > 0) {
          if (id[0].id > 0) {
            additionalMaterialItems[rowIndex].unit =  id[0].selectitem;


            let objPartname: any = {};
            objPartname.itemName =  id[0].selectitem;
            objPartname.label = id[0].selectitem;
            objPartname.id = id[0].id;
            defaultitemname.push(objPartname);
            additionalMaterialItems[rowIndex].defaultunitname = defaultitemname;

          } else {
            additionalMaterialItems[rowIndex].unit = id[0].label;

              let objPartname: any = {};
              objPartname.itemName = id[0].label;
              objPartname.label = id[0].label;
              objPartname.id = 0;
              defaultitemname.push(objPartname);
              unitList.push(objPartname); 
              additionalMaterialItems[rowIndex].defaulunitname =  defaultitemname;

          }
        } else {

          additionalMaterialItems[rowIndex].unit = "";

          let objPartname: any = {};
          objPartname.itemName = "";
          objPartname.label = "";
          objPartname.id = 0;
          defaultitemname.push(objPartname);
          additionalMaterialItems[rowIndex].defaultunitname = id;

        }

        this.setState(
          { additionalMaterialItems, defaultitemname, unitList, isStateChanged },
          () => {
            let txtID = "txtitemDesc" + rowIndex + "txt";
            $("#tblAdditionalMaterialItems").find("input[id^='" + txtID + "']").focus();
          });


      }
      // this.setState(
      //   { misclistByItem, defaultitemname, inventorydata, isStateChanged },
      //   () => {
      //     let txtID = "txtitemDesc" + rowIndex + "txt";
      //     //$("input[class^='" + txtID + "']").focus();
      //     //$("#tbltemplate").find("input[id^='" + txtID + "']").focus();

      //   }
      // );
    }
  };


    handleOutsideClickForAdditionalItemsUnit = (rowIndex: any, e: any) => {

      let btnId = "unit" + rowIndex + "btn";
      let id = "unit" + rowIndex + "ddl";
      let relatedTargetID = e.relatedTarget?.id;

      let defaultitemname: any = [];
      let unitList = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.unitList))
      );

      let additionalMaterialItems = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.additionalMaterialItems))
      );

      additionalMaterialItems[rowIndex].unit = e.target.value;



      if (e.target.value != "") {
        let objPartname: any = {};
        objPartname.itemName = e.target.value;
        objPartname.label = e.target.value;
        objPartname.id = 0;
        defaultitemname.push(objPartname);
        // unitList.push(objPartname);




        additionalMaterialItems[rowIndex].defaultunitname = defaultitemname;

        this.setState({ additionalMaterialItems, defaultitemname, unitList }, () => {


        });
      }
      else {

        this.setState({ additionalMaterialItems: [] }, () =>
          this.setState({ additionalMaterialItems }, () => {
          })
        );
      }

      $("#tblAdditionalMaterialItems")
        .find("button[id^='" + btnId + "']")
        .css("display", "none");
      $("#tblAdditionalMaterialItems")
        .find("div[id^='" + id + "']")
        .css("display", "none");
    };

  handleOutsideClick = (rowIndex: any, e: any) => {

    let btnId = "itemname" + rowIndex + "btn";
    let id = "itemname" + rowIndex + "ddl";
    let relatedTargetID = e.relatedTarget?.id;

    let defaultitemname: any = [];
    let inventorydata = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.inventorydata))
    );

    let misclistByItem = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.misclistByItem))
    );

    misclistByItem[rowIndex].itemName = e.target.value;
    misclistByItem[rowIndex].id = 0;
    misclistByItem[rowIndex].qty = 0;
    misclistByItem[rowIndex].unitPrice = 0;
    //misclistByItem[rowIndex].itemDesc = "";



    if (e.target.value != "") {
      let objPartname: any = {};
      objPartname.itemname = e.target.value;
      objPartname.label = e.target.value;
      objPartname.id = 0;
      //objPartname.glcode = "";
      objPartname.qty = 0;
      objPartname.unit = "";

      objPartname.tenantid = 0;

      objPartname.unitPrice = 0;

      objPartname.description = "";
      defaultitemname.push(objPartname);
      inventorydata.push(objPartname);




      misclistByItem[rowIndex].defaultitemname = defaultitemname;

      this.setState({ misclistByItem, defaultitemname, inventorydata }, () => {


      });
    }
    else {

      this.setState({ misclistByItem: [] }, () =>
        this.setState({ misclistByItem }, () => {
        })
      );
    }

    $("#tbltemplate")
      .find("button[id^='" + btnId + "']")
      .css("display", "none");
    $("#tbltemplate")
      .find("div[id^='" + id + "']")
      .css("display", "none");
  };


    handleOutsideClickForAdditionalItems = (rowIndex: any, e: any) => {

      let btnId = "itemname" + rowIndex + "btn";
      let id = "itemname" + rowIndex + "ddl";
      let relatedTargetID = e.relatedTarget?.id;

      let defaultitemname: any = [];
      let inventorydata = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.inventorydata))
      );

      let additionalMaterialItems = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.additionalMaterialItems))
      );

      additionalMaterialItems[rowIndex].itemName = e.target.value;
      additionalMaterialItems[rowIndex].id = 0;
      // additionalMaterialItems[rowIndex].qty = 0;
      // additionalMaterialItems[rowIndex].unitPrice = 0;
      //misclistByItem[rowIndex].itemDesc = "";



      if (e.target.value != "") {
        let objPartname: any = {};
        objPartname.itemName = e.target.value;
        objPartname.label = e.target.value;
        objPartname.itemDesc = additionalMaterialItems[rowIndex]?.itemDesc ||"",
        objPartname.id = 0;
        //objPartname.glcode = "";
        objPartname.qty = 0;
        objPartname.unit = "";

        objPartname.tenantid = 0;

        objPartname.unitPrice = 0;

        objPartname.description = "";
        defaultitemname.push(objPartname);
        inventorydata.push(objPartname);




        additionalMaterialItems[rowIndex].defaultitemname = defaultitemname;

        this.setState({ additionalMaterialItems, defaultitemname, inventorydata }, () => {


        });
      }
      else {

        this.setState({ additionalMaterialItems: [] }, () =>
          this.setState({ additionalMaterialItems }, () => {
          })
        );
      }

      $("#tblAdditionalMaterialItems")
        .find("button[id^='" + btnId + "']")
        .css("display", "none");
      $("#tblAdditionalMaterialItems")
        .find("div[id^='" + id + "']")
        .css("display", "none");
    };

  itemsSelected = (Chieldstate: any) => {
    let data = Object.assign([], JSON.parse(JSON.stringify(Chieldstate)));
    this.setState({ selectedItems: data, isChange: true });
  };

onFileChange = (event: any, mode) => {
  
      // 
      let newfiles: any = [];
      if (event.target.files.length > 0) {
        for (let i = 0; i < event.target.files.length; i++) {
          let fileRow = event.target.files[i];
          newfiles.push(fileRow);
        }
        this.onDrop(newfiles, mode);
          if (this.fileInputRef && this.fileInputRef.current) {
      this.fileInputRef.current.value = null;
    }
        let fileList = document.getElementById("formControlsFile") as any;
        fileList.value = "";
      }
    };
  
    onDrop = (filelist: any, mode: any) => {
      let size = this.state.fileSize; //5242880//5MB
      let newfiles: any = [];
      let files: any = [];
      let isReturn = true;
      let filestext = "";
      let filesizeval = Number(Number(this.state.fileSize) / (1024 * 1024));
      filelist.forEach((element) => {
        if (element.size > size) {
          filestext = filestext + element.name + ",";
          isReturn = false;
        }
      });
  
      if (!isReturn) {
        let msg = "One or more files are greater than " + filesizeval + "MB.";
        toast.error(msg, {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "OrderSlideout",
        });
        this.setState({ isSpinner: false});
        return false;
      }
      let isInvalidFile = false;
      filelist.forEach((element) => {
        if (
          (element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "pdf" ||
            element.name
              .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
              .toLowerCase() === "doc" ||
            element.name
              .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
              .toLowerCase() === "docx" ||
            element.name
              .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
              .toLowerCase() === "xls" ||
            element.name
              .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
              .toLowerCase() === "xlsx" ||
            element.name
              .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
              .toLowerCase() === "csv" ||
            element.name
              .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
              .toLowerCase() === "txt" ||
            element.name
              .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
              .toLowerCase() === "bmp" ||
            element.name
              .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
              .toLowerCase() === "tif" ||
            element.name
              .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
              .toLowerCase() === "ppt" ||
            element.name
              .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
              .toLowerCase() === "pptx" ||
            element.name
              .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
              .toLowerCase() === "rtf" ||
            element.name
              .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
              .toLowerCase() === "jpg" ||
            element.name
              .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
              .toLowerCase() === "jpeg" ||
            element.name
              .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
              .toLowerCase() === "png" ||
            element.name
              .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
              .toLowerCase() === "msg" ||
            element.name
              .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
              .toLowerCase() === "eml") &&
          element.size <= size
        ) {
          newfiles.push(element);
          files.push(element);
        } else {
          isInvalidFile = true;
        }
      });
      if (isInvalidFile && isReturn) {
        let msg = "";
        if (filelist.length === 1) {
          msg = "This file type is not supported.";
        } else {
          msg = "Some files are not supported.";
        }
        toast.error(msg, {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "OrderSlideout",
        });
        this.setState({ isSpinner: false});
        return false;
      }
  
      this.setState(
        {
          files,
          newSelectfiles: newfiles,
          isSave: true,
          ispopupshow: false,
          // isSpinner: true,
        },
        () => {
          if (files.length > 0) {
            this.saveOrderfinal("order", false, 0, files);
          }
        }
      );
    };

    
     handleFileDelete(newfiles, file) {
        let request: any = {};
        request.fileUniqueno = file.fileUniqueno;
        request.transactionid = this.state.vendororderid;
        request.transactiontype = "vendorOrder";
    
        this.handleDeleteFileFromDb(request, newfiles, 2);
      }
      handleDeleteFileFromDb(request, newfiles, id) {
        TransactionService.DeleteUploadedFileTransaction(request)
          .then(async (result: any | null) => {
            if (result !== null) {
    
              this.setState({ isSaveSpinner: false, isDisabled: false, isStateChanged: false ,isOpenViewer:false});
              this.GetorderEntryColoumn();    
            }
            resolve();
          })
          .catch((error) => {
            reject();
          });
      }

    isDeleteattachment(file) {
      let newfiles: any = [];
      this.state.savedfiles.forEach((element, idx) => {
        if (Number(file.fileUniqueno) !== Number(element.fileUniqueno)) {
          newfiles.push(element);
        }
      });
      this.handleFileDelete(newfiles, file);
    }
  
   downloadTranactionFile = (file: any) => {
      TransactionService.DownloadTransactionFile(file)
        .then(async (result: any | null) => {
          resolve();
        })
        .catch((error) => {
          reject();
          this.setState({ isSaveSpinner: false });
        });
    };

     handleSelectFileUpload = (eventKey: any, file, index) => {
        if (eventKey === "delete") {
          let request: any = {};
          request = Object.assign(
            {},
            JSON.parse(JSON.stringify(this.state.formData))
          );
          let masg = "";
    
          masg = "Are you sure you want to delete this Attachment?";
    
          confirmAlert({
            title: "Delete Attachment",
    
            message: masg,
            buttons: [
              {
                label: "Yes",
                onClick: () => this.isDeleteattachment(file),
              },
              {
                label: "No",
                onClick: () => reject(),
              },
            ],
    
            closeOnEscape: false,
            closeOnClickOutside: false,
          });
        } else if (eventKey === "download") {
          this.downloadTranactionFile(file);
        }else if(eventKey === "view"){
         this.OpenViewerSingle(index);
        }
      };
      hideBulkselect() {
        this.setState({
          bulkSelect: false,
          chkIds: [],
          selectedChk: [],
          isMapped: "No",
        });
        for (let i = 0; i < this.state.savedfiles.length; i++) {
          this["myRef" + i].current.hideBulkSelect();
        }
      }
    OpenViewer() {
      if (this.state.bulkSelect && this.state.isOpenViewer) {
        this.hideBulkselect();
      }
      this.setState(
        (prevState) => ({
          isOpenViewer: !prevState.isOpenViewer,
          singleView:false,
          fileSelect:
            this.state.savedfiles.length > 0
              ? this.state.savedfiles[0]
              : this.state.newSelectfiles[0],
          isMapped: "No",
          isExtractOption: false,
        }),
        () => {
          this.setState({ defaultView: "doc-view" });
          if (this.state.isOpenViewer) {
            setTimeout(() => {
              const innerWidthSec = this.scrollheight.current
                .getElement()
                .getBoundingClientRect().height;
              this.setState({ scrollAreaHeight: innerWidthSec });
            }, 100);
          }
        }
      );
    }

    OpenViewerSingle(index:any) {
      if (this.state.bulkSelect && this.state.isOpenViewer) {
        this.hideBulkselect();
      }
      this.setState(
        (prevState) => ({
          isOpenViewer: !prevState.isOpenViewer,
          singleView:true,
          singleViewFiles: [this.state.savedfiles[index]],
          fileSelect:
            this.state.savedfiles.length > 0
              ? this.state.savedfiles[0]
              : this.state.newSelectfiles[0],
          isMapped: "No",
          isExtractOption: false,
        }),
        () => {
          this.setState({ defaultView: "doc-view" });
          if (this.state.isOpenViewer) {
            setTimeout(() => {
              const innerWidthSec = this.scrollheight.current
                .getElement()
                .getBoundingClientRect().height;
              this.setState({ scrollAreaHeight: innerWidthSec });
            }, 100);
          }
        }
      );
    }

    scrollToBottom = () => {
      this.parentScroll.current.scrollTo({
        //top: this.parentScroll.current.clientHeight,
        top: this.parentScroll.current.scrollHeight,
        behavior: "smooth",
      });
    };

    updatedCommentItem = () => {
      let updatedItem: any = {};
      this.setState({ isSave: true });
      updatedItem.transcationDate = this.state.formData.transcationDate;
      updatedItem.vendorName = this.state.formData.vendorName;
      updatedItem.amountTotal = this.state.totalAmount;
      return updatedItem;
    };
    CommentModalClose = () => {
      let uniqueno = this.state.formData.uniqueno;
      this.handleDiscard(uniqueno);
    };

    handleDiscard(postID) {
      this.setState({ isStateChanged: false }, () => {
        this.closeSlideOut();
      });
    }

    setTotalPages = (totalpage) => {
      let isextractShow =
        this.state.savedfiles.length === 1 && totalpage === 1 ? true : false;
      this.setState({ isextractShow, isExtractOption: false });
    };
    handleZoom = (event) => {
      let currZoom = this.state.currentZoom;
      let updateZoom;
      if (event === "zoomIn") {
        updateZoom = currZoom * 1.5;
      } else {
        updateZoom = currZoom / 1.5;
      }
      // console.log("updateZoom-" + updateZoom);
      this.setState({ currentZoom: updateZoom });
    };
  
    handleAllCheckbox(event) {
      for (let i = 0; i < this.state.savedfiles.length; i++) {
        this["myRef" + i].current.handleAllCheckbox(event);
      }
    }

  render() {
     const { permissions } = this.props; 
    const hasAddOrderPermission = permissions && permissions['Vendor Orders'] ? permissions['Vendor Orders'].includes('Add Vendor Order') : false;
    const hasEditOrderPermission = permissions && permissions['Vendor Orders'] ? permissions['Vendor Orders'].includes('Edit Vendor Order') : false;
    
    const expandSplitRowForSelected = {
      onlyOneExpanding: false,
      parentClassName: "parent-expand-foo",
      renderer: (row: any, rowIndex: any) => renderItemTableChild(row, rowIndex, true),
      showExpandColumn: true,
      expandByColumnOnly: true,
      onExpandAll: (isExpandAll, results, e) => {
        // ...
      },
      expandHeaderColumnRenderer: ({ isAnyExpands }) => {
        if (isAnyExpands) {
          return <div></div>;
        }
        return <div></div>;
      },
      expandColumnRenderer: ({ expanded }) => {
        if (expanded) {
          return (
            <span className="chevronExpended">
              <img src={chevronRight} alt="chevron Right" />
            </span>
          );
        }
        return (
          <span className="chevronCollpsed">
            <img src={chevronRight} alt="chevron Right" />
          </span>
        );
      },
    };

    const expandSplitRow = {
      onlyOneExpanding: true,
      parentClassName: "parent-expand-foo",
      renderer: (row: any, rowIndex: any) => renderItemTableChild(row, rowIndex, false),
      showExpandColumn: true,
      expandByColumnOnly: true,
      onExpandAll: (isExpandAll, results, e) => {
        // ...
      },
      expandHeaderColumnRenderer: ({ isAnyExpands }) => {
        if (isAnyExpands) {
          return <div></div>;
        }
        return <div></div>;
      },
      expandColumnRenderer: ({ expanded }) => {
        if (expanded) {
          return (
            <span className="chevronExpended">
              <img src={chevronRight} alt="chevron Right" />
            </span>
          );
        }
        return (
          <span className="chevronCollpsed">
            <img src={chevronRight} alt="chevron Right" />
          </span>
        );
      },
    };
    const whiteBgFormatter = (column, colIndex) => {
      return <div className="white-bg"></div>;
    };

    const renderItemTableChild = (mainrow, rowIndex, showSelected = true) => {

      let splitDetail: any = [];
      splitDetail = this.state.jobOrderlistByItem.filter(
        (x) => x.itemId === mainrow.itemId && x.rowType === 2 && (x.selected === showSelected || this.state.vendororderid == 0)
      );

      const columnCOAChild = [
        {
          dataField: "isSelected",
          text: "",
          headerFormatter: this.icheckselectedall,
          classes: "expanding-bar",
          formatter: (cell: any, row: any, rowIndex: any) => {
            const prevOrderidselected = mainrow.itemId;
            this.setState({ prevOrderidselected: prevOrderidselected });
            return (
              <div className="d-flex align-items-center txt-bold">
                <OverlayTrigger
                  placement="bottom"
                  overlay={
                    <Tooltip id="toolp">Click to copy this part</Tooltip>
                  }
                >
                    <a href="#"> 
                  <FontAwesomeIcon
                    icon={faArrowUp}
                    size="xs"
                    onClick={(e) =>
                      this.handleRowSelectionCheck(
                        e,
                        rowIndex,
                        row,
                        "true",
                        "",
                        null
                      )
                    }
                  />
                  </a>
                </OverlayTrigger>
              </div>
            );
          },
        },
        {
          dataField: "JobNo",
          text: "Job No",

          formatter: (cell: any, row: any, rowIndex: any) => {
            return (
              <EllipsisWithTooltip placement="bottom">
                <Button className="btn-link" onClick={() => this.showSlideOut(row, 'job')}>
                  {row.jobNo}
                </Button>
              </EllipsisWithTooltip>
            );
          },
        },
        // {
        //   dataField: "itemDesc",
        //   text: "Item Description",
        //   headerClasses: "coa",
        //   hidden: false,
        //   headerStyle: { width: "400px", textAlign: "left" },
        //   headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
        //   formatter: (cell: any, row: any, rowIndex: any) => {
        //     let id = "txtitemDesc" + rowIndex + "txt";
        //     return (
        //       <div>
        //         <Form.Control
        //           tabIndex={this.state.tabEnable}
        //           id={id}
        //           type="text"
        //           placeholder="Please enter item details"
        //           value={row.itemDesc}
        //           onChange={(e) => this.updateState(e, row, "itemDesc", id)}
        //           autoComplete="off"
        //           //pattern="[+-]?\d+(?:[.,]\d+)?"
        //           maxLength={200}
        //           disabled={false}
        //           title=""
        //         />
        //       </div>
        //     );
        //   },
        // },
        {
          dataField: "partName",
          text: "Part Description",
          classes: "text-truncate",
          headerStyle: { width: "10%" },
          formatter: (cell: any, row: any, rowIndex: any) => {
            return (

              <div className="d-flex align-items-center txt-bold">
                <div style={{ width: '150px' }}>
                  <EllipsisWithTooltip placement="bottom">
                    {row.partName}
                  </EllipsisWithTooltip>
                </div>
              </div>
            );
          },
        },
        {
          dataField: "partNo",
          text: "Part No",

          formatter: (cell: any, row: any, rowIndex: any) => {
            return (
              <EllipsisWithTooltip placement="bottom">
                {row.partNo}
              </EllipsisWithTooltip>
            );
          },
        },
        {
          dataField: "customerPoNumber",
          text: "CO #",
          hidden: false,
          formatter: (cell: any, row: any, rowIndex: any) => {
            return (
              <EllipsisWithTooltip placement="bottom">
                <Button className="btn-link" onClick={() => this.showSlideOut(row, 'customer')}>
                  {row.customerPoNumber}
                </Button>

              </EllipsisWithTooltip>

            );
          },
        },
        {
          dataField: "qty",
          text: "Qty",
          hidden: false,
          headerStyle: { width: "70px" },
          formatter: (cell: any, row: any, rowIndex: any) => {
            let id = "txtexpqty" + rowIndex + "txt";
            let disabled = false;
            //this.props.receivedStatus !== 'Completed' && this.props.receivedStatus !== 'Received' ? false:true;
            return (
              <div>
                <Form.Control
                  tabIndex={this.state.tabEnable}
                  id={id}
                  type="text"
                  // placeholder="Enter Qty"
                  value={row.qty}
                  onChange={(e) => this.updateState(e, row, "expandqty", id)}
                  autoComplete="off"
                  pattern="[+-]?\d+(?:[.,]\d+)?"
                  maxLength={20}
                  disabled={disabled}
                  title=""
                />
              </div>
            );
          },
        },

        {
          dataField: "unit",
          text: "Unit",
          hidden: false,
          formatter: (cell: any, row: any, rowIndex: any) => {
            return (
              <EllipsisWithTooltip placement="bottom">
                {row.unit}
              </EllipsisWithTooltip>
            );
          },
        },

        {
          dataField: "unitPrice",
          text: "Unit Price",
          hidden: false,
          formatter: (cell: any, row: any, rowIndex: any) => {
            return (
              <EllipsisWithTooltip placement="bottom">
                {row.unitPrice}
              </EllipsisWithTooltip>
            );
          },
        },

        {
          dataField: "jobId",
          text: "JobId",
          hidden: true,
          formatter: (cell: any, row: any, rowIndex: any) => {
            return (
              <EllipsisWithTooltip placement="bottom">
                {row.jobId}
              </EllipsisWithTooltip>
            );
          },
        },
        {
          dataField: "ItemId",
          text: "ItemId",
          hidden: true,
          formatter: (cell: any, row: any, rowIndex: any) => {
            return (
              <EllipsisWithTooltip placement="bottom">
                {row.itemId}
              </EllipsisWithTooltip>
            );
          },
        },
        {
          dataField: "ItemId",
          text: "ItemId",
          hidden: true,
          formatter: (cell: any, row: any, rowIndex: any) => {
            return (
              <EllipsisWithTooltip placement="bottom">
                {row.itemId}
              </EllipsisWithTooltip>
            );
          },
        },
        {
          dataField: "",
          text: "",
          headerClasses: "blankLastChildofChild",
        },


      ];

      return (
        <>
          <div className='px-4 p-4'>
            <BootstrapTable
              id="tblCOAchild"
              keyField="rowId"
              data={splitDetail}
              columns={columnCOAChild}
            //rowEvents={this.rowEvents}
            // selectRow={{
            //   mode: 'checkbox', clickToSelect: false, hideSelectAll: false,
            //   selected: splitDetail.filter((x) => x.selected === true).map(r => r.rowId),
            //   onSelect: this.handleOnSelect,
            //   onSelectAll: this.handleOnSelectAll,
            //   hideSelectColumn: this.state.vendororderid > 0 && !this.state.editMode
            // }}

            />
          </div>
        </>
      );
    };

    const AdditionalMaterialItemColumns = [

    {
      dataField: "srno",
      text: "No.",
    },
    {
      dataField: "itemName",
      text: this.state.vendorordertype === "Material" ? "Item Name" : "Process Name",
      headerClasses: "coa",

      headerStyle: { width: "511px" },
      headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),

      formatter: (cell: any, row: any, rowIndex: any) => {
        let btnId = "itemname" + rowIndex + "btn";
        let id = "itemname" + rowIndex + "ddl";
        const defaultitemname = row.defaultitemname;
        let disable = false;
        const options = this.state.vendorordertype === "Material" ?  this.state.inventorydata.filter((ele, ind) => ind === this.state.inventorydata.findIndex(elem => elem.itemname === ele.itemname && ele.itemname !== "")) : this.state.processData;
        return (
          // <div className="disabled-area my-class" onClick={(e)=>this.onclickevent(e)}>
          <div
            style={{ position: 'relative' }}
          //  onClick={() => $('#tbltemplate td.reset-expansion-style').css('overflow', 'inherit')}
          >
            <div className="more-action single-select-image dropdown coa-select">

              {this.state.inventoryLoad && <Typeahead

                  id={"itemname" + rowIndex + "ddl"}
                  inputProps={{
                    className: "rbt-input-main form-control rbt-input form-control form-control itemname" + rowIndex + "ddl truncate-input",
                    title: defaultitemname.length > 0 ? `${defaultitemname[0].itemName}\n${defaultitemname[0].itemDesc}`:'',
                    //onClick: () => this.hoverOutEllipsis()
                  }}
                  options={
                    options
                    // this.state.inventorydata.filter((ele, ind) => ind === this.state.inventorydata.findIndex(elem => elem.itemname === ele.itemname && ele.itemname !== ""))

                  }

                  placeholder={"Enter item Name"}

                // labelKey="label"

                renderMenu={(results: any, menuProps) => (
                  <Menu style={{ zIndex: "-1" }}  {...menuProps}>
                    {results.map((result: any, index: any) => (
                      <>
                        {this.state.inventoryLoad}
                        {result.label !== "" && (
                          <MenuItem
                            option={result}
                            position={index}
                          //        onWheel={() => this.hoverOutEllipsis()}
                          >
                            <EllipsisWithTooltip placement="bottom">
                              {result.label}

                            </EllipsisWithTooltip>
                          </MenuItem>
                        )}

                        {result.itemname === "" && (
                          <MenuItem option={result} position={index}></MenuItem>
                        )}
                      </>
                    ))}
                  </Menu>
                )}

                onChange={this.handleSelectedItem.bind(
                  this,
                  2 + "_" + rowIndex + "_" + defaultitemname
                )}
                selected={row.defaultitemname}
                allowNew
                disabled={this.state.formData.Status == 'Inactive'}
              onBlur={this.handleOutsideClickForAdditionalItems.bind(this, rowIndex)}
              onKeyDown={this.onTAB.bind(this, "itemname-" + rowIndex.toString() + "ddl", rowIndex)}

              />}

              {/*<button id={btnId} style={{ display: "none", width: "100%" }}
                onClick={() => { this.handleCOAFocus(btnId, id, "rbt-input-main form-control rbt-input itemname" + rowIndex + "ddl", rowIndex); }}
                onFocus={() => { this.handleCOAFocus(btnId, id, "rbt-input-main form-control rbt-input itemname" + rowIndex + "ddl", rowIndex); }} >
                {row.partname === "" && (
                  <EllipsisWithTooltip placement="bottom">{"Enter item name"}</EllipsisWithTooltip>
                )}
                {row.partname !== "" && (
                  <EllipsisWithTooltip placement="bottom">{defaultitemname}</EllipsisWithTooltip>
                )}
              </button> */}
            </div>

            <FaPencilAlt

              onClick={() => this.handleEditClick(rowIndex, row.defaultitemname)}
              style={{
                position: 'absolute',
                right: '10px',
                top: '50%',
                transform: 'translateY(-50%)',
                cursor: 'pointer',
              }}
            />

          </div>
        );
      },
    },
  
  {
      dataField: "partNo",
      text: "Part No. | Job No. | Part Description",
      headerClasses: "coa",
      // headerStyle: { width: "600px" },
      headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),

      formatter: (cell: any, row: any, rowIndex: any) => {
        console.log("jo rowww", row);
        let btnId = "partname" + rowIndex + "btn";
        let id = "partname" + rowIndex + "ddl";
        

        if (!row.productJobList || row.productJobList.length === 0) {
          return (
            <div className="pe-5">
            No Part Available
            </div>
          );
        }

        return (
          <div className="m-1" style={{ width: "250px" }}>
            {row.productJobList && row.productJobList.length > 0 && (
              <JOMultiSelect
                name="JO"
                key={rowIndex}
                rowIndex={rowIndex}
                data={row.productJobList}
                label="label"
                value="value"
                placeHolder="Select"
                filtertitle="Search..."
                disable={this.state.formData.Status == "Inactive"}
                disabled={false}
                updateMultiSelectItem={(selectedItem) =>
                  this.updateMultiSelectItem(selectedItem, rowIndex, 2)
                }
              />
            )}
          </div>
        );
      },
    },

    {
      dataField: "qty",
      text: "Qty",
      headerStyle: { width: "200px" },
      hidden: false,
      editable: false,
      headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
      formatter: (cell: any, row: any, rowIndex: any) => {
        console.log("job qty", row);
        let id = "txtreqqty" + rowIndex + "txt";
        let disable = true;
        return (
          <div>
            <Form.Control
              tabIndex={this.state.tabEnable}
              id={id}
              type="text"
              // placeholder="Enter Qty"
              value={row.qty}
              onChange={(e) => this.updateStateAdditionalItems(e, row, "qty", id)}
              autoComplete="off"
              pattern="[+-]?\d+(?:[.,]\d+)?"
              maxLength={20}
              disabled={this.state.formData.Status == "Inactive"}
              onKeyDown={(e: any) => this.onTAB("qty", rowIndex, e)}
              title=""
            />
          </div>
        );
      },
    },
{
      dataField: "unit",
      text: "Unit",
      headerClasses: "coa",

      headerStyle: { width: "230px" },
      headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),

      formatter: (cell: any, row: any, rowIndex: any) => {
        let btnId = "unit" + rowIndex + "btn";
        let id = "unit" + rowIndex + "ddl";
        const defaultitemname = row.defaultunitname;
        let disable = false;
        const options =  this.state.unitList;
        return (
          <div
            style={{ position: 'relative' }}
          >
            <div className="more-action single-select-image dropdown coa-select">

              {this.state.inventoryLoad && <Typeahead

                  id={"itemname" + rowIndex + "ddl"}
                  inputProps={{
                    className: "rbt-input-main form-control rbt-input form-control form-control itemname" + rowIndex + "ddl",
                    title: defaultitemname.length > 0 ? `${defaultitemname[0].itemName}`:'',
                  }}
                  options={ options}
                  placeholder={"Enter Unit"}

                // labelKey="label"

                renderMenu={(results: any, menuProps) => (
                  <Menu style={{ zIndex: "-1" }}  {...menuProps}>
                    {results.map((result: any, index: any) => (
                      <>
                        {/* {this.state.inventoryLoad} */}
                        {result.label !== "" && (
                          <MenuItem
                            option={result}
                            position={index}
                          >
                            <EllipsisWithTooltip placement="bottom">
                              {result.label}

                            </EllipsisWithTooltip>
                          </MenuItem>
                        )}

                        {result.itemname === "" && (
                          <MenuItem option={result} position={index}></MenuItem>
                        )}
                      </>
                    ))}
                  </Menu>
                )}

                onChange={this.handleSelectedItem.bind(
                  this,
                  7 + "_" + rowIndex + "_" + defaultitemname
                )}
                disabled={this.state.disableForm}
                selected={row.defaultunitname}
                allowNew={false}
              onBlur={this.handleOutsideClickForAdditionalItemsUnit.bind(this, rowIndex)}
              onKeyDown={this.onTAB.bind(this, "unit-" + rowIndex.toString() + "ddl", rowIndex)}

              />}
            </div>


          </div>
        );
      },
    },
    {
      dataField: "unitPrice",
      text: "Unit Price",
      headerStyle: { width: "200px" },
      hidden: false,
      editable: false,
      headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
      formatter: (cell: any, row: any, rowIndex: any) => {
        let id = "txtunitPrice" + rowIndex + "txt";
        let disable = true;
        return (
          <div>
            <Form.Control
              tabIndex={this.state.tabEnable}
              id={id}
              type="text"
              // placeholder="Enter Qty"
              value={row.unitPrice}
              onChange={(e) => this.updateStateAdditionalItems(e, row, "unitPrice", id)}
              onBlur={(e: any) => this.amountBlurAdditionalItems(e, rowIndex, "unitPrice", row)}
              onFocus={(e: any) => this.onAmountFocusAdditionalItems(e, rowIndex, id, "unitPrice")}
              autoComplete="off"
              pattern="[+-]?\d+(?:[.,]\d+)?"
              maxLength={20}
              disabled={this.state.formData.Status == "Inactive"}
              title=""
            />
          </div>
        );
      },
    },

      {
      dataField: "discount",
      text: "Discount",
      headerStyle: { width: "200px" },
      hidden: false,
      editable: false,
      headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
      formatter: (cell: any, row: any, rowIndex: any) => {
        let id = "txtdiscount" + rowIndex + "txt";
        let disable = this.state.formData.CustomerID == 0 ? true : false;
        return (
          <div>
            <Form.Control
              tabIndex={this.state.tabEnable}
              id={id}
              type="text"
              placeholder="Enter Discount"
              value={row.discount}
              onChange={(e) => this.updateStateAdditionalItems(e, row, "discount", id)}
              onBlur={(e: any) => this.amountBlurAdditionalItems(e, rowIndex, "discount", row)}
              onFocus={(e: any) => this.onAmountFocusAdditionalItems(e, rowIndex, id, "discount")}
              autoComplete="off"
              pattern="[+-]?\d+(?:[.,]\d+)?"
              maxLength={20}
              disabled={false}
              title=""
              className="form-control form-control-sm"
            />
          </div>
        );
      },
    },

    {
      dataField: "amount",
      text: "Amount",

      headerStyle: { width: "200px" },
      hidden: false,
      editable: false,
      headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
      formatter: (cell: any, row: any, rowIndex: any) => {
        let id = "txtamount" + rowIndex + "txt";
        let disable = true;
        return (
          <div>
            <Form.Control
              tabIndex={this.state.tabEnable}
              id={id}
              type="text"
              // placeholder="Enter Qty"
              // value={Utils.currencyFormat(Number(Utils.removeInvaildCharFromAmount(row.unitPrice)) * row.qty)}
              value={Utils.currencyFormat((Number(Utils.removeInvaildCharFromAmount(row.unitPrice)) * row.qty) - (Number(Utils.removeInvaildCharFromAmount(row.discount)) || 0))}
              onChange={(e) => this.updateStateAdditionalItems(e, row, "amount", id)}
              autoComplete="off"
              pattern="[+-]?\d+(?:[.,]\d+)?"
              maxLength={20}
              disabled={this.state.formData.Status == "Inactive"}
              title=""
            />
          </div>
        );
      },
    },
      {
              dataField: '',
              text: 'Action',
              headerStyle: { width: "2%" },
        
              formatter: (cell: any, row: any, rowIndex: any) => {
                return (
                  <div className="btn-group">
                    <Dropdown
                      // onClick={(e) => { e.stopPropagation(); }}
                      className="more-action"
                    >
                      <Dropdown.Toggle
                        className="btn-outline-primary btn btn-primary-white more"
                        id={"dropdown-more" + rowIndex}
        
                      >
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" />
                          <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" />
                          <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" />
                        </svg>
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                          {!(this.state.additionalMaterialItems.length === 1 || rowIndex == 0 || this.state.formData.Status == "Inactive" )  && (
                            <Dropdown.Item
                              eventKey="deleterow"
                              onClick={() => this.isdeleteconfirm( row)}
                            >
                              Delete
                            </Dropdown.Item>
                          )}
        
                        <Dropdown.Item eventKey={"comments"}  onClick={() => this.handleEditClick1(rowIndex,row.notes)}>{row.notes ? 'Edit Note' : 'Add Note'}</Dropdown.Item>
        
        
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                );
              },
            }


  ];

    const files1 = this.state.savedfiles.map((file, index) => (
              <>
                <div>
                  <li key={file.name}>
                    <div className="d-flex align-items-center justify-content-start">
        
                      <div className="file-info d-flex align-items-center">
                        <div className="name-loader d-flex align-items-center">
                          <div className="name">
                            {/* <EllipsisWithTooltip placement="bottom"> */}
                              {/* <div className="full-name" style={{ fontSize: '14px', marginRight: '70px' }}>{file.name}</div> */}
                              <div className="full-name" style={{ fontSize: '14px',textAlign:'left'}}>{file.name}</div>
                            {/* </EllipsisWithTooltip> */}
                          </div>
                        </div>
                      </div>
                      <div className="action">
                        {
                          <Dropdown
                            className="more-action"
                            
                            onSelect={(event: any) =>
                              this.handleSelectFileUpload(event, file, index)
                            }
                          >
                            <Dropdown.Toggle
                              className="btn-outline-primary btn btn-primary more border-0"
                              id="dropdown-more"
                            >
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" />
                                <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" />
                                <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" />
                              </svg>
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              {this.state.moreActionFileUpload1.map(
                                (item: any, idx: any) => (
                                  <>
                                    {this.state.vendororderid === 0 && (
                                      <Dropdown.Item
                                        //  className={( this.state.moreActionFileUpload1[idx].eventKey === "delete") ? "isHide" : ""}
                                        //className={((this.state.formData.actionType === "copy" || this.state.isError === "NotEdit") && this.state.formData.uniqueno > 0) ? "isHide" : ""}
                                        eventKey={
                                          this.state.moreActionFileUpload1[idx].eventKey
                                        }
                                        key={idx}
                                      >
                                        {this.state.moreActionFileUpload1[idx].name}
                                      </Dropdown.Item>
                                    )}
        
                                    {this.state.vendororderid > 0 && (
                                      <Dropdown.Item
                                        // className={(    this.state.moreActionFileUpload1[idx].eventKey === "delete") ? "isHide" : ""}
                                        eventKey={
                                          this.state.moreActionFileUpload1[idx].eventKey
                                        }
                                        key={idx}
                                      >
                                        {this.state.moreActionFileUpload1[idx].name}
                                      </Dropdown.Item>
                                    )}
                                  </>
                                )
                              )}
                            </Dropdown.Menu>
                          </Dropdown>
                        }
                      </div>
                    </div>
                  </li>
                </div>
              </>
            ));
            const savedfilesCount = this.state.savedfiles.length;
            const allsavedfiles = this.state.savedfiles;
            const currentView = this.state.defaultView;
    
            const handleUpdate = (newtext) => {
              //this.setState({ defaultView: "doc-view"});
              toggleSwitch("doc-view");
              setTimeout(function () {
                var currentPos: any = $(`#${newtext}`).offset()?.top;
                var marginArea = currentPos - 138;
                $(".scroll-area").animate(
                  {
                    scrollTop: marginArea,
                  },
                  500
                );
              }, 500);
            };
        
            const handleUpdateFiles = (docFiles) => {
              //let docViewerFiles : any =[];
              docViewerFiles.push(docFiles);
              //this.setState({ docViewerFiles: docFiles })
            };
        
            const showBulkSelect = (type) => {
              this.setState({ bulkSelect: type === "show" ? true : false });
              for (let i = 0; i < this.state.savedfiles.length; i++) {
                this["myRef" + i].current.showBulkSelect();
              }
            };
        
            const checkBulkSelect = (type, totalpage) => {
              // selectedPage =totalpage;
              if (totalpage === 0) {
                this.footerchk.current.labels[0].innerHTML = "No Page Selected";
              } else if (totalpage === 1) {
                this.footerchk.current.labels[0].innerHTML =
                  totalpage + " Page Selected";
              } else {
                this.footerchk.current.labels[0].innerHTML =
                  totalpage + " Pages Selected";
              }
              if (type === "removeAll") {
                this.footerchk.current.indeterminate = false;
                this.footerchk.current.checked = false;
              } else {
                if (type === "helf") {
                  this.footerchk.current.indeterminate = true;
                } else {
                  this.footerchk.current.indeterminate = false;
                  this.footerchk.current.checked = true;
                }
              }
            };
    
            const toggleSwitch = (event: any) => {
              this.setState({ defaultView: event });
              $(".scroll-area").animate(
                {
                  scrollTop: 0,
                },
                500
              );
            };

    return (
      //  <div className="transaction-slideout invoice-entry pos-fxd index-1000">

      <section>
        <div className="details-drawer"
          style={{ minWidth: "75%", width: "992px", maxWidth: "100%" }}
        // className="back-drop1  viewer-panel1 opacity "
        >
          <ToastContainer
            containerId={"userDetailSlideoutcontainer"}
            autoClose={3000}
          />

          <div className="d-flex">
            {!this.state.isOpenViewer && !this.state.showMailPanel && <div
              className="back-drop1  viewer-panel1 opacity"
              onClick={() => this.closeSlideOut()}
            >
            </div>}

            {this.state.showMailPanel &&
              // <div
              //   className="back-drop  viewer-panel opacity z-2 position-absolute"
              //   style={{ minWidth: "75%", width: "992px", maxWidth: "100%" }}
              // >
              <section>
              <div className="details-drawer"
                style={{ minWidth: "75%", width: "992px", maxWidth: "100%" }}
              // className="back-drop1  viewer-panel1 opacity "
              >
                <div
              className="back-drop1  viewer-panel1 opacity"
              onClick={() => this.cancelSendMail()}
            >
            </div>

                <div
                  className="back-drop viewer-panel  z-3 position-absolute"
                  //className="body-sec viewer-panel back-drop p-0 z-3"
                  style={{ minWidth: "75%", width: "992px", maxWidth: "100%" }}
                >
                  <div
                    className="scroll p-3"
                  >
                    <Form>


                      <div className="row my-2">
                        <div className="col-2 ml-3">
                          <Form.Label className="h6 font-semibold ">Mail To</Form.Label>
                        </div>

                        <FormGroup controlId="mailTo">
                          <div className="col-12 ml-3">
                            <Form.Control type="text" placeholder="MailTo" value={this.state.mailContent.MailTo}
                              onChange={(event: any) => { this.handleChange(event, "MailTo", 0); }}

                            ></Form.Control>
                          </div>
                        </FormGroup>
                      </div>



                      <div className="row my-2">
                        <div className="col-2 ml-3">
                          <Form.Label className="h6 font-semibold">CC</Form.Label>
                        </div>

                        <FormGroup controlId="customerName">
                          <div className="col-12 ml-3">
                            <Form.Control type="text" placeholder="Email" value={this.state.mailContent.CC}
                              onChange={(event: any) => this.handleChange(event, "CC", 0)}
                            ></Form.Control>
                          </div>
                        </FormGroup>
                      </div>

                <div className="row my-2">
                        <div className="col-2 ml-3">
                          <Form.Label className="h6 font-semibold">Subject</Form.Label>
                        </div>

                        <FormGroup controlId="customerName">
                          <div className="col-12 ml-3">
                            <Form.Control type="text" placeholder="Email" value={this.state.mailContent.subject}
                              onChange={(event: any) => this.handleChange(event, "subject", 0)}
                            ></Form.Control>
                          </div>
                        </FormGroup>
                      </div>


                      <div className="row my-2 mb-5">
                        <div className="col-2 ml-4">
                          <Form.Label className="h6 font-semibold">Message</Form.Label>
                        </div>

                        <FormGroup controlId="customerName">
                          <div className="col-12 ml-4">
                            <Form.Control type="text" placeholder="Message"
                              as="textarea"
                              wrap="hard"
                              rows={15}
                              value={this.state.mailContent.Message}
                              onChange={(event: any) => this.handleChange(event, "Message", 0)}
                            ></Form.Control>
                          </div>
                        </FormGroup>
                      </div>






                    </Form>
                  </div>
                  <div className={"footer-section viewer-panel"}
                    style={{ minWidth: "75%", width: "992px", maxWidth: "100%" }}
                  >
                    <div className="d-flex gap-3 align-items-center justify-content-between height-72">
                       <div className="d-flex gap-3 align-items-center">
                                           <Form.Check
                                                key="multiple"
                                                type="checkbox"
                                                label="Send Attachments"
                                                className="small-checkbox text-end ms-2"
                                                checked={this.state.isAttachments}
                                                onChange={this.handleAttachment}
                                              /></div>
                      <div className="d-flex gap-3 align-items-center">
                        <Button
                          id="btnCancelSendMail"
                          variant="primary"
                          type="button"
                          className="space btn btn-primary btn-discard"

                          onClick={() => this.cancelSendMail()}

                        >
                          {"Cancel"}
                        </Button>
                        <Button
                          id="btnSendMail"
                          variant="primary"
                          type="button"
                          onClick={() => this.sendMail()}

                        >
                          {"Send"}
                        </Button>
                      </div>
                    </div>
                  </div>

                </div>
                </div>
                </section>
              // </div>
            }
            {this.state.isOpenViewer && (
                                    <div
                                      className="back-drop viewer-panel-left bg-secondary bg-gradient z-3 position-absolute"
                                      //className="body-sec viewer-panel back-drop p-0 z-3"
                                      style={{ minWidth: "45%", width: "300px", maxWidth: "100%" }}
                        
                                    >
                                      <div
                                        className="scroll"
                                      >
                                        <div className="header-panel d-flex justify-content-between align-items-center">
                                          <div className="page-ttl">Attachments</div>
                                          {/* <div className="toggle-button">
                                            <ButtonGroup aria-label="Basic example">
                                              <ToggleButtonGroup
                                                type="radio"
                                                name="options"
                                                value={this.state.defaultView}
                                                onChange={toggleSwitch}
                                              >
                                                <ToggleButton value={"doc-view"} id={"t1"}>
                                                  <svg
                                                    width="20"
                                                    height="20"
                                                    viewBox="0 0 20 20"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                  >
                                                    <path d="M10.155 12.1267C9.64082 12.1267 9.34082 12.6159 9.34082 13.2709C9.34082 13.93 9.64999 14.3959 10.16 14.3959C10.6742 14.3959 10.9692 13.9059 10.9692 13.2509C10.9692 12.6459 10.6792 12.1267 10.155 12.1267Z" />
                                                    <path d="M11.6666 1.66663H4.99992C4.55789 1.66663 4.13397 1.84222 3.82141 2.15478C3.50885 2.46734 3.33325 2.89127 3.33325 3.33329V16.6666C3.33325 17.1087 3.50885 17.5326 3.82141 17.8451C4.13397 18.1577 4.55789 18.3333 4.99992 18.3333H14.9999C15.4419 18.3333 15.8659 18.1577 16.1784 17.8451C16.491 17.5326 16.6666 17.1087 16.6666 16.6666V6.66663L11.6666 1.66663ZM11.6666 7.49996H10.8333V3.33329L14.9999 7.49996H11.6666Z" />
                                                  </svg>
                                                </ToggleButton>
                                                <ToggleButton value={"grid-view"} id={""}>
                                                  <svg
                                                    width="20"
                                                    height="20"
                                                    viewBox="0 0 20 20"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                  >
                                                    <path d="M3.33333 9.16667H8.33333C8.55435 9.16667 8.76631 9.07887 8.92259 8.92259C9.07887 8.76631 9.16667 8.55435 9.16667 8.33333V3.33333C9.16667 3.11232 9.07887 2.90036 8.92259 2.74408C8.76631 2.5878 8.55435 2.5 8.33333 2.5H3.33333C3.11232 2.5 2.90036 2.5878 2.74408 2.74408C2.5878 2.90036 2.5 3.11232 2.5 3.33333V8.33333C2.5 8.55435 2.5878 8.76631 2.74408 8.92259C2.90036 9.07887 3.11232 9.16667 3.33333 9.16667ZM11.6667 9.16667H16.6667C16.8877 9.16667 17.0996 9.07887 17.2559 8.92259C17.4122 8.76631 17.5 8.55435 17.5 8.33333V3.33333C17.5 3.11232 17.4122 2.90036 17.2559 2.74408C17.0996 2.5878 16.8877 2.5 16.6667 2.5H11.6667C11.4457 2.5 11.2337 2.5878 11.0774 2.74408C10.9211 2.90036 10.8333 3.11232 10.8333 3.33333V8.33333C10.8333 8.55435 10.9211 8.76631 11.0774 8.92259C11.2337 9.07887 11.4457 9.16667 11.6667 9.16667ZM3.33333 17.5H8.33333C8.55435 17.5 8.76631 17.4122 8.92259 17.2559C9.07887 17.0996 9.16667 16.8877 9.16667 16.6667V11.6667C9.16667 11.4457 9.07887 11.2337 8.92259 11.0774C8.76631 10.9211 8.55435 10.8333 8.33333 10.8333H3.33333C3.11232 10.8333 2.90036 10.9211 2.74408 11.0774C2.5878 11.2337 2.5 11.4457 2.5 11.6667V16.6667C2.5 16.8877 2.5878 17.0996 2.74408 17.2559C2.90036 17.4122 3.11232 17.5 3.33333 17.5ZM11.6667 17.5H16.6667C16.8877 17.5 17.0996 17.4122 17.2559 17.2559C17.4122 17.0996 17.5 16.8877 17.5 16.6667V11.6667C17.5 11.4457 17.4122 11.2337 17.2559 11.0774C17.0996 10.9211 16.8877 10.8333 16.6667 10.8333H11.6667C11.4457 10.8333 11.2337 10.9211 11.0774 11.0774C10.9211 11.2337 10.8333 11.4457 10.8333 11.6667V16.6667C10.8333 16.8877 10.9211 17.0996 11.0774 17.2559C11.2337 17.4122 11.4457 17.5 11.6667 17.5Z" />
                                                  </svg>
                                                </ToggleButton>
                                              </ToggleButtonGroup>
                                            </ButtonGroup>
                                          </div> */}
                                          <div className="action d-flex">
                                            <button
                                              type="button"
                                              className="btn wht-bg cross"
                                              style={{backgroundColor:'#164DA0'}}
                                              onClick={this.OpenViewer}
                                            >
                                              <svg
                                                width="12"
                                                height="12"
                                                viewBox="0 0 12 12"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                              >
                                                <path
                                                  d="M10.192 0.343994L5.94897 4.58599L1.70697 0.343994L0.292969 1.75799L4.53497 5.99999L0.292969 10.242L1.70697 11.656L5.94897 7.41399L10.192 11.656L11.606 10.242L7.36397 5.99999L11.606 1.75799L10.192 0.343994Z"
                                                  fill="white"
                                                />
                                              </svg>
                                            </button>
                                          </div>
                                        </div>
                        
                                        <ScrollContainer
                                          className="doc-view scroll-area1"
                                          // className={`scroll-area ${this.state.modalOpen === "yes" ? "modal-open" : ""
                                          //   } ${currentView !== "doc-view" ? "grid-sec" : "doc-sec"}`}
                        
                        
                                          ref={this.scrollheight}
                                          hideScrollbars={false}
                                        >
                                          <>
                                            {(this.state.singleView ? this.state.singleViewFiles : this.state.savedfiles).map((file: any, i: any) => {
                                              return (
                                                <div
                                                  id={`sec_${file.id}`}
                                                  className={this.state.bulkSelect ? "footer-enable" : ""}
                                                >
                                                  <div
                                                    className={
                                                      currentView !== "doc-view" ? "grid-sec" : "doc-sec"
                                                    }
                                                  >
                                                    <PDFViewer
                                                      //ref={childViewerref}
                                                      ref={this["myRef" + i]}
                                                      scrollAreaHeight={this.state.scrollAreaHeight}
                                                      isModalOpen={this["isModalOpen"]}
                                                      uniqueno={this.state.orderID}
                                                      filePreview={file.fileCode}
                                                      defaultView={currentView}
                                                      fileNo={file.fileUniqueno}
                                                      fileCount={savedfilesCount}
                                                      fileName={file.name}
                                                      // docFile={docViewerFiles}
                                                      docFile={allsavedfiles}
                                                      updateState={handleUpdate}
                                                      updateFiles={handleUpdateFiles}
                                                      showBulkSelect={showBulkSelect}
                                                      checkBulkSelect={checkBulkSelect}
                                                      handleFileCheckBox={this["handleFileCheckBox"]}
                                                      handleUpdatedFile={this["handleUpdatedFile"]}
                                                      handleincompleteFile={this["handleincompleteFile"]}
                                                      saveSplitFile={this["saveSplitFile"]}
                                                      pageType={this.props.pageType}
                                                      handleRotate={this["handleRotate"]}
                                                      handlePageRemove={this["handlePageRemove"]}
                                                      selectedChk={this.state.selectedChk}
                                                      selectedZoom={this.state.currentZoom}
                                                      setTotalPages={this["setTotalPages"]}
                                                      isEditPermission={true}
                                                    />
                                                  </div>
                                                </div>
                                              );
                                            })}
                        
                                            {currentView === "doc-view" && (
                                              <div className="zoom-btn">
                                                <ButtonGroup vertical>
                                                  <Button
                                                    onClick={(e) => this.handleZoom("zoomIn")}
                                                    disabled={
                                                      this.state.currentZoom >= 3.375 ? true : false
                                                    }
                                                  >
                                                    <FontAwesomeIcon icon={faPlus} />
                                                  </Button>
                                                  <Button
                                                    onClick={(e) => this.handleZoom("zoomOut")}
                                                    disabled={
                                                      this.state.currentZoom <= 0.44 ? true : false
                                                    }
                                                  >
                                                    <FontAwesomeIcon icon={faMinus} />
                                                  </Button>
                                                </ButtonGroup>
                                              </div>
                                            )}
                                            {this.state.bulkSelect && (
                                              <div className="footer-section-left d-flex align-items-center justify-content-end">
                                                <Form.Check
                                                  
                                                  type="checkbox"
                                                  key={"custom-footer"}
                                                  id={"custom-footer"}
                                                  label={"No Page Selected"}
                                                  onChange={(e: any) => this.handleAllCheckbox(e)}
                                                  ref={this.footerchk}
                                                />
                                              </div>
                                            )}
                                          </>
                                        </ScrollContainer>
                                      </div>
                                    </div>
                                  )}
            

            <Container
              fluid

              className="body-sec viewer-panel back-drop p-0 "
              style={{ minWidth: "75%", width: "892px", maxWidth: "100%" }}

            >
              <div
                className="container-fluid py-1 bg-white d-flex align-items-center round-4"
              >
                <div className="divheader">
                  <h5 className="my-title">


                    {this.state.vendororderid == 0 && <span>New Vendor Order</span>}
                    {this.state.vendororderid != 0 && (
                      <span>Vendor Order No : {this.props.CustomerPoNumber ? this.props.CustomerPoNumber : this.state.formData.CustomerPoNumber}</span>
                    )}
                      {this.state.cancelDate && 
                                          <span className="badge badge-pill badge-primary color-red">
                                            order cancelled - {moment.utc(this.state.cancelDate).format("MM/DD/YYYY")}
                                          </span>
                                           }
                     {this.state.sentDate && 
                                          <span className="badge badge-pill badge-primary color-green">
                                            email sent - {moment.utc(this.state.sentDate).format("MM/DD/YYYY")}
                                          </span>
                                           }
                  
                  </h5>


                  <div className="header-popout ml-auto">

                    <div className="container text-center">
                      <div className="row align-items-start">
                        <div className="col d-none">

                          {this.state.vendororderid == 0 && <BootstrapSwitchButton width={150} height={40} offstyle="success"
                            checked={this.state.vendorordertype !== 'Process'}
                            onlabel='Material'
                            offlabel='Process'
                            disabled={this.state.vendororderid > 0}
                            onChange={(checked: boolean) => {
                              this.setState({ vendorordertype: (checked ? 'Material' : 'Process') });
                            }}
                          />}


                        </div>

                        <div className="col">
                          {this.state.vendororderid != 0
                            //  && this.state.jobTrackerId === 0 
                            //                             && !this.state.processVendorPOCreated && !this.state.materialVendorPOCreated
                            &&

                            <div className="action">

                              <Dropdown
                                className="more-action"

                                onSelect={(event: any) => { this.actionclick(event); }}
                              >
                                <Dropdown.Toggle
                                  className="btn-outline-primary btn btn-primary more"
                                  id="dropdown-more"
                                >
                                  <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" />
                                    <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" />
                                    <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" />
                                  </svg>
                                </Dropdown.Toggle>
                                <Dropdown.Menu>



                                  <Dropdown.Item

                                    eventKey={"Print"}
                                    key={1}
                                  >
                                    {"Print"}
                                  </Dropdown.Item>
                                  {this.state.formData.Status != 'Inactive' && hasEditOrderPermission &&
                                  <>
                                  <Dropdown.Item

                                    eventKey={"Email"}
                                    key={1}
                                  >
                                    {"Email"}
                                  </Dropdown.Item>
                                  <Dropdown.Item

                                    eventKey={"Delete"}
                                    key={1}
                                  >
                                    {"Delete"}
                                  </Dropdown.Item>
                                 <Dropdown.Item

                                    eventKey={"Cancel"}
                                    key={1}
                                  >
                                    {"Cancel"}
                                  </Dropdown.Item>
                                  </>
  }
                                </Dropdown.Menu>
                              </Dropdown>



                            </div>


                          }
                        </div>
                        <div className="col">
                          <button
                            type="button"
                            className="btn btn-primary cross"
                            onClick={this.closeSlideOut}
                          >
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M16.192 6.34399L11.949 10.586L7.70697 6.34399L6.29297 7.75799L10.535 12L6.29297 16.242L7.70697 17.656L11.949 13.414L16.192 17.656L17.606 16.242L13.364 12L17.606 7.75799L16.192 6.34399Z"
                                fill="#ffffff"
                              />
                            </svg>
                          </button>

                        </div>

                      </div>
                    </div>


                    {/* <button
                      type="button"
                      className="btn wht-bg cross"
                      onClick={this.closeSlideOut}
                    >
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M16.192 6.34399L11.949 10.586L7.70697 6.34399L6.29297 7.75799L10.535 12L6.29297 16.242L7.70697 17.656L11.949 13.414L16.192 17.656L17.606 16.242L13.364 12L17.606 7.75799L16.192 6.34399Z"
                          fill="#84888C"
                        />
                      </svg>
                    </button> */}
                  </div>
                </div>
              </div>
              <div
                className="scroll"
              >

                <section className="pb-3">
                  <div className="row g-3">

                    <div className="col-12 col-md-3" >
                      <Form.Group controlId="customerName">
                        <div className="parent my-data">
                          <Form.Label className="font-semibold">
                            Vendor Name
                          </Form.Label>
                          <div
                            tabIndex={this.state.tabEnable}
                            className="type-head"
                          >
                            <VendorSearch
                              ref={this.customerSearch}
                              updateCustomerList={this.updateCustomerList}
                              handleVendorChange={
                                this.handleVendorChange
                              }
                              disabled={this.state.formData.Status == 'Inactive'}
                            />
                          </div>
                        </div>
                      </Form.Group>
                    </div>
                    <div className="col-12 col-md-3" >
                      <Form.Group controlId="buyerName">
                        <div className="parent my-data">
                          <Form.Label className="font-semibold">
                            Contact Name
                          </Form.Label>
                          <div
                            tabIndex={this.state.tabEnable}
                            className="type-head"
                          >    <Typeahead

                              id="selections-example"
                              labelKey="name"
                              // onInputChange={(text: string, e: ChangeEvent<HTMLInputElement>) => {
                              //   this.state.formData.firstname = text;
                              // }}
                              onInputChange={(text: string, e: ChangeEvent<HTMLInputElement>) => {
                                // console.log(text, e);
                                this.state.formData.firstname = text;
                              }}
                              onChange={(e) => this.handleChangeBuyer(e)}
                              options={this.state.options}
                              disabled={this.state.formData.Status == 'Inactive'}
                              placeholder="Select contact details..."
                              selected={this.state.Defaultselected}
                              renderMenu={this._renderMenu}
                            />
                          </div>
                        </div>
                      </Form.Group>
                    </div>

                    <div className="col-12 col-md-2" >
                      <Form.Group controlId="vendorName">
                        <div className="parent my-data">
                          <Form.Label className="font-semibold">
                            Order Date
                          </Form.Label>
                          <div className="date-picker calender-picker">
                            {/* <Form.Control type="text" id="txtOrderDate"
                                                             value={this.state.formData.OrderDate}
                                                             onChange={(event: any) => this.handleChange(event, 'orderDate')} 
                                                            autoComplete='off'
                                                            title=""

                                                        /> */}
                            {/* {  <div className="drop-arrow" onClick={(event: any) => this.handleDatePicker(event, this.trDate)}>
                                                            <svg width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M3.28122e-05 1.19724C3.28122e-05 0.889538 0.253262 0.653982 0.543288 0.653982C0.688297 0.653982 0.833313 0.708449 0.923855 0.816677L4.0023 4.0217L7.08074 0.816677C7.2979 0.599519 7.6424 0.599519 7.84116 0.816677C8.04064 1.01616 8.05831 1.34153 7.85955 1.55941L4.40046 5.18112C4.20098 5.39827 3.85721 5.39828 3.64005 5.19951L3.62166 5.18112L0.145009 1.55941C0.0544669 1.46887 0 1.34226 0 1.19724L3.28122e-05 1.19724Z" fill="#3F4347" />
                                                            </svg>
                                                        </div> } */}

                            <DatePicker
                              
                              id="txtOrderDate"
                              tabIndex={this.state.tabEnable}
                              className="form-control px-0 w-75 text-center pe-5"
                              placeholderText={"MM/DD/YY"}
                              dateFormat="MM/dd/yy"
                              selected={
                                this.state.formData.OrderDate === null
                                  ? new Date(Utils.convertUtcToTimezoneFormat(new Date(), currentUtcTime))
                                  : this.state.formData.OrderDate === ""
                                    ? new Date(Utils.convertUtcToTimezoneFormat(new Date(), currentUtcTime))
                                    : new Date(this.state.formData.OrderDate)
                              }
                              onChange={(event: any) =>
                                this.handleChange(event, "orderDate", 0)
                              }
                              // onKeyDown={(e: any) =>
                              //   this.onTAB("txtOrderDate-1", 0, e)
                              // }
                              onClick={(e: any) =>
                                this.onTAB("txtOrderDate-1", 0, e)
                              }
                              autoComplete="off"
                              disabled={this.state.formData.Status == 'Inactive'}
                            // disabled={isBedgeProcessing && true}
                            />
                          </div>
                        </div>
                      </Form.Group>
                    </div>

                    <div className="col-12 col-md-2" >
                      <Form.Group controlId="vendorName">
                        <div className="parent my-data">
                          <Form.Label className="font-semibold">
                            Due Date
                          </Form.Label>
                          <div className="date-picker calender-picker">
                            <DatePicker
                            ref={this.trDate}
                              id="txtDueDate"
                              tabIndex={this.state.tabEnable}
                              className="form-control px-0 w-75 text-center pe-5"
                              placeholderText={"MM/DD/YY"}
                              dateFormat="MM/dd/yy"
                              selected={
                                this.state.formData.duedate === null
                                  ? new Date(Utils.convertUtcToTimezoneFormat(new Date(), currentUtcTime))
                                  : this.state.formData.duedate === ""
                                    ? new Date(Utils.convertUtcToTimezoneFormat(new Date(), currentUtcTime))
                                    : new Date(this.state.formData.duedate)
                              }
                              onChange={(event: any) =>
                                this.handleChange(event, "dueDate", 0)
                              }
                              onClick={(e: any) =>
                                this.onTAB("txtDueDate-1", 0, e)
                              }
                              disabled={this.state.formData.Status == 'Inactive'}
                              autoComplete="off"
                            />
                          </div>
                        </div>
                      </Form.Group>
                    </div>

                    <div className="col-12 col-md-2" >
                      <Form.Group controlId="customerName">
                        <div className="parent my-data">
                          <Form.Label className="font-semibold">
                            Ship Via
                          </Form.Label>
                          <div
                            tabIndex={this.state.tabEnable}
                            className="type-head"
                          >
                            <Form.Control
                              tabIndex={this.state.tabEnable}
                              id="txtShipVia"
                              type="text"
                              placeholder="Enter Ship Via"
                              value={this.state.formData.ship_via}
                              onChange={(event: any) => this.handleChange(event, 'ship_via', 0)}
                              autoComplete="off"
                              disabled={this.state.formData.Status == 'Inactive'}
                              title=""
                            />
                          </div>
                        </div>
                      </Form.Group>
                    </div>

                    <div className="col-12 col-md-3" >
                      <Form.Group controlId="customerName">
                        <div className="parent my-data">
                          <Form.Label className="font-semibold">
                            Vendor Ref. No.
                          </Form.Label>
                          <div
                            tabIndex={this.state.tabEnable}
                            className="type-head"
                          >
                            <Form.Control
                              tabIndex={this.state.tabEnable}
                              id="txtRefNo"
                              type="text"
                              placeholder="Enter Ref No."
                              value={this.state.formData.refNo}
                              onChange={(event: any) => this.handleChange(event, 'refNo', 0)}
                              autoComplete="off"
                              disabled={this.state.formData.Status == 'Inactive'}
                              title=""
                            />
                          </div>
                        </div>
                      </Form.Group>
                    </div>
                    {this.state.quotationNo &&
                    <div className="col-12 col-md-3" >
                      <Form.Group controlId="customerName">
                        <div className="parent my-data">
                          <Form.Label className="font-semibold">
                            Quotation No.
                          </Form.Label>
                          <div
                            tabIndex={this.state.tabEnable}
                            className="type-head"
                          >
                            <Form.Control
                              tabIndex={this.state.tabEnable}
                              id="txtQuotationNo"
                              type="text"
                              placeholder=""
                              value={this.state.quotationNo}
                              autoComplete="off"
                              disabled={true}
                              title=""
                            />
                          </div>
                        </div>
                      </Form.Group>
                    </div>
                   }

                  </div>
                  <div className="col-12 col-md-2 mt-2" >
                    <Form.Group controlId="customerName">
                      <div className="parent my-data">
                        <Form.Label className="font-semibold">
                          Type
                        </Form.Label>
                        <div
                          tabIndex={this.state.tabEnable}
                          className="type-head"
                        >

<ButtonGroup>
          <ToggleButton
            key={1}
            id={`radio-material`}
            type="radio"
            variant={1 % 2 ? 'outline-primary' : 'secondary'}
            name="radio"
            value="Material"
            disabled={this.state.vendororderid==0?false :true}
            checked={this.state.vendorordertype === "Material"}
            onChange={(e) => this.handleType(e.currentTarget.value)}
            className="z-0"
          >
            Material
          </ToggleButton>
           <ToggleButton
           key={2}
           id={`radio-process`}
           type="radio"
           variant={2 % 2 ? 'secondary' : 'outline-primary'}
           name="radio"
           disabled={this.state.vendororderid==0?false :true}
           value="Process"
           checked={this.state.vendorordertype === "Process"}
           onChange={(e) => this.handleType(e.currentTarget.value)}
           className="z-0"
         >
           Process
         </ToggleButton>
      </ButtonGroup>



                          {/* <SingleDropdownListWithoutSearchBoot
                            itemList={[{ id: "Material", name: "Material" }, { id: "Process", name: "Process" }
                              // , { id: "Miscellaneous", name: "Miscellaneous" }

                            ]}
                            handleSelectedItem={this.handleType}
                            defaultText={"Select"}
                            defaultName={this.state.vendorordertype || "Select"}
                            controlID="1"
                          /> */}

                        </div>
                      </div>
                    </Form.Group>
                  </div>
                </section>

                {/* <Tab.Container transition={false} defaultActiveKey={this.state.vendororderid == 0 ? "first" : this.state.vendorordertype == "Process" ? "second" : this.state.vendorordertype == "Miscellaneous" ? "third" : "first"}  > */}
                {/* {this.state.vendororderid == 0 &&
                    <section className="pb-3">
                      <Nav className="nav nav-underline border-bottom border-top">
                        <Nav.Item className="nav-item">
                          <Nav.Link eventKey="first" onClick={
                            () => this.setState({ vendorordertype: 'Material' })
                          }
                            disabled={this.state.vendororderid == 0 ? false : true}
                          >Materials


                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item className="nav-item">
                          <Nav.Link eventKey="second"
                            onClick={
                              () => this.setState({ vendorordertype: 'Process' })

                            }
                            disabled={this.state.vendororderid == 0 ? false : true}
                          >Process

                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item className="nav-item">
                          <Nav.Link eventKey="third"

                            onClick={
                              () => this.setState({ vendorordertype: 'Miscellaneous' })

                            }
                            disabled={this.state.vendororderid == 0 ? false : true}
                          >Miscellaneous

                          </Nav.Link>
                        </Nav.Item>
                      </Nav>
                    </section>

                  } */}


                {/* <Tab.Content>
                    <Tab.Pane eventKey="first"> */}
                {this.state.vendorordertype === "Material" && (
                  <div
                    // className="scroll p-0"
                  >

                    <section className="pb-3">

                      <div className="card">
                        <div className="card-header fw-bold">
                          Order Details

                        </div>
                        <div className="card-body">
                          <div
                            //   className="transactions-list inpute"
                            //  className="table table-borderless align-middle  transactions-list"
                            className="table table-borderless align-middle transactions-list"
                          >
                            {this.state.inventoryLoad  && (
                              <div className="split-assign-coa">
                                <BootstrapTable
                                  key={this.state.formData.Status}
                                  id="tblAdditionalMaterialItems"
                                  keyField="templateid"
                                  data={this.state.additionalMaterialItems}
                                  columns={AdditionalMaterialItemColumns}
                                />
                              </div>
                            )}
                          </div>

                          <div className="d-flex action-btn align-items-center">

                             {this.state.formData.Status != "Inactive"  &&
                              <Button
                                type="button"
                                className="btn-ghost mr-auto"
                                onClick={this.handleNewRowAdditionalMaterialItems}
                              >

                                <FaCirclePlus className="align-middle lh-1`" /> <span className="align-middle lh-1">Add Item</span>
                              </Button>}
                          </div>
                        </div>

                      </div>

                      {/* <div className="job-link my-2" 
                            onClick={() => { 
                              this.setState(prevState => ({ showSection: !prevState.showSection })); 
                            }}                          >
                          Select from Job Requests<span className="mx-2">            
                            {this.state.showSection ? <FiChevronUp /> : <FiChevronDown />}
                          </span>
                          
                          </div> */}
                       {this.state.formData.Status != "Inactive"  && ( 
                        <div className="d-inline-block mt-2">
                           <span className="font-semibold" style={{color:"#2caf92",marginRight:"3px"}}>+</span>
                          <a onClick={() => {
                            this.setState(prevState => ({ showSection: !prevState.showSection }));
                          }} className="orderLinks" >{this.state.isprevious == false ? "Select from Job Requests" : "Select from Job Requests"}   </a>

                        </div>
                       )}
                      {this.state.showSection && (
                        <>

                          {/* <div className="job-options">
                          <div className="job-option">
                          <span className="px-2 py-2" style={{backgroundColor:"#EBF0F4",borderRadius:"5px"}}>Material</span>
                          </div>
                          </div> */}

                          <section className="mt-4" style={{ marginBottom: '0px' }}>
                            <div className="card">
                              <div className="card-header fw-bold">
                                {/* Order Details - By Job No. */}
                                Select Materials

                              </div>
                              <div className="card-body scroll" style={{maxHeight:'500px'}}>
                                <div
                                  className="table-responsive table table-borderless align-middle transactions-list"

                                >
                                  {this.state.transactionsColumns.length > 0 && this.state.vendorordertype !== 'Process' && !this.state.editMode && (
                                    <div style={{ backgroundColor: 'white' }} >
                                      <BootstrapTable
                                        id="tblOrder"
                                        keyField="rowId"
                                        data={this.state.jobOrderlistByItem.filter(
                                          (x) => x.rowType === 1 && this.state.jobOrderlistByItem.filter(
                                            (a) => a.itemId === x.itemId && a.rowType === 2 && (a.selected === true || this.state.vendororderid == 0)
                                          ).length > 0
                                        )}
                                        columns={this.state.transactionsColumns}
                                        expandRow={expandSplitRowForSelected}

                                      // rowEvents={this.rowEvents1}
                                      />
                                    </div>
                                  )}

                                  {this.state.editMode && this.state.transactionsColumns.length > 0 && this.state.vendorordertype !== 'Process' && (
                                    <div style={{ backgroundColor: 'white', marginBottom: '80px' }} >
                                      <div className="font-semibold mb-2 mt-1">

                                        Select New Items

                                      </div>
                                      <BootstrapTable
                                        id="tblOrderRaw"
                                        keyField="rowId"
                                        data={this.state.jobOrderlistByItem.filter(
                                          (x) => x.rowType === 1 && this.state.jobOrderlistByItem.filter(
                                            (a) => a.itemId === x.itemId && a.rowType === 2 && (a.selected === false || this.state.vendororderid == 0)
                                          ).length > 0
                                        )}
                                        columns={this.state.transactionsColumns}
                                        expandRow={expandSplitRow}

                                      // rowEvents={this.rowEvents1}
                                      />
                                    </div>
                                  )}



                                </div>
                              </div>
                            </div>
                          </section>
                        </>
                      )}
                    </section>
                  </div>
                )}

                {/* </Tab.Pane>

                    <Tab.Pane eventKey="second"> */}
                {this.state.vendorordertype === "Process" && (
                  <div
                    // className="scroll p-0"
                  >
                    <section className="pb-3">

                      <div className="card">
                        <div className="card-header fw-bold">
                          Process Details
                        </div>

                        <div className="card-body">
                          <div
                            //   className="transactions-list inpute"
                            //  className="table table-borderless align-middle  transactions-list"
                            className="table table-borderless align-middle transactions-list"
                          >
                            {this.state.inventoryLoad  && (
                              <div className="split-assign-coa">
                                <BootstrapTable
                                  id="tblAdditionalMaterialItems"
                                  keyField="templateid"
                                  data={this.state.additionalMaterialItems}
                                  columns={AdditionalMaterialItemColumns}
                                />
                              </div>
                            )}
                          </div>

                          <div className="d-flex action-btn align-items-center">

                            {true && 
                              <Button
                                type="button"
                                className="btn-ghost mr-auto"
                                onClick={this.handleNewRowAdditionalMaterialItems}
                              >

                                <FaCirclePlus className="align-middle lh-1`" /> <span className="align-middle lh-1">Add Item</span>
                              </Button>}
                          </div>
                        </div>

                      </div>

                      {/* <div className="job-link my-2" 
                            onClick={() => { 
                              this.setState(prevState => ({ showSection: !prevState.showSection })); 
                            }}                          >
                          Select from Job Requests<span className="mx-2">
                          {this.state.showSection ? <FiChevronUp /> : <FiChevronDown />}
                          </span>
                          
                          </div> */}
                       {this.state.formData.Status != "Inactive"  && ( 
                        <div className="d-inline-block mt-2">
                         <span className="font-semibold" style={{color:"#2caf92",marginRight:"3px"}}>+</span>
                          <a onClick={() => {
                            this.setState(prevState => ({ showSection: !prevState.showSection }));
                          }} className="orderLinks" >{this.state.isprevious == false ? "Select from Job Requests" : "Select from Job Requests"}   </a>

                        </div>
                       )}
                      {this.state.showSection && (
                        <>

                      

                          <section className="mt-4" style={{ marginBottom: '0px' }}>
                            <div className="card">
                              <div className="card-header fw-bold">
                                {/* Order Details */}
                                Select Processes
                              </div>
                              <div className="card-body scroll" style={{maxHeight:'500px'}}>

                                <div
                                  className="table-responsive table table-borderless align-middle transactions-list"

                                >


                                  {this.state.vendorordertype === 'Process' && (
                                    <div style={{ backgroundColor: 'white' }} className="split-assign-coa">
                                      <BootstrapTable
                                        id="tbltemplate"
                                        keyField="id"
                                        data={this.state.jobdetailsdata.filter((x) => x.jobNo!='')}
                                        columns={this.state.templateColumns}
                                      // selectRow={{
                                      //   mode: 'checkbox', clickToSelect: false, hideSelectAll: false, selected: this.state.jobdetailsdata.filter((x) => x.selected === true).map(r => r.id),
                                      //   //selected: this.state.selected,
                                      //   onSelect: this.handleOnSelectForJob,
                                      //   onSelectAll: this.handleOnSelectAllForJob,
                                      //   hideSelectColumn: this.state.vendororderid > 0 && !this.state.editMode
                                      // }}
                                      />
                                    </div>
                                  )}

                                </div>
                              </div>
                              {/* <div className="filter-sec height-172">

                                <br></br>
                                <br></br>

                              </div> */}
                            </div>

                          </section>
                        </>
                      )}
                    </section>
                  </div>
                )}
                {/* </Tab.Pane>
                    <Tab.Pane eventKey="third"> */}
                {this.state.vendorordertype === "Miscellaneouss" && (
                  <div
                    className="scroll p-0"
                  >
                    <section className="pb-3">

                      <div className="card">
                        <div className="card-header fw-bold">
                          Order Details

                        </div>
                        <div className="card-body">
                          <div
                            //   className="transactions-list inpute"
                            //  className="table table-borderless align-middle  transactions-list"
                            className="table table-borderless align-middle transactions-list"
                          >
                            {this.state.inventorydata.length > 0 && (
                              <div className="split-assign-coa">
                                <BootstrapTable
                                  id="tbltemplate"
                                  keyField="templateid"
                                  data={this.state.misclistByItem}
                                  columns={this.state.itemColumns}
                                />
                              </div>
                            )}
                          </div>

                          <div className="d-flex action-btn align-items-center">

                            {true &&
                              <Button
                                type="button"
                                className="btn-ghost mr-auto"
                                onClick={this.handleNewRowitems}
                              >

                                <FaCirclePlus className="align-middle lh-1`" /> <span className="align-middle lh-1">Add Item</span>
                              </Button>}
                          </div>
                        </div>

                        {/* <div className="filter-sec height-172">

<br></br>
<br></br>

</div> */}
                      </div>
                    </section>
                  </div>
                )}
                {/* </Tab.Pane>
                  </Tab.Content>

                </Tab.Container> */}





                {/* <section className="pb-3"> */}
                    <hr></hr>
                    {this.state.formData.Status != "Inactive" && <>
                                                    <div >
                                                    <div className="row">
                                                      <div className="col-12 col-md-6">                 
                                                            <div
                                                              className="filter-sec upload-section"
                                                            >
                                  
                                                              <Form.Group  className="w-100">
                                  
                                                                <div>
                                                                  <Form.Label>
                                                                    {
                                                                      <div className="upload-link mrgn-top">
                                                                        <button
                                                                          type="button"
                                                                          className="btn wht-bg link-btn mr-auto"
                                                                        >
                                                                          Add Attachment
                                                                        </button>
                                                                        <Form.Control
                                                                          id="formControlsFile"
                                                                          type="file"
                                                                          className="form-control-file"
                                                                          multiple
                                                                          onChange={(event: any) =>
                                                                            this.onFileChange(event, "1")
                                                                          }
                                                                          accept="image/*,application/pdf,.doc,.docx,.xls,.xlsx,.csv,.txt,.bmp,.tif,.ppt,.pptx,.rtf,.jpg,.png,.msg,.eml"
                                                                        />
                                                                      </div>
                                                                    }
                                                                  </Form.Label>
                                  
                                                                  {this.state.savedfiles.length > 0 && (
                                                                    <Form.Label className="mr-auto">
                                                                      <div className="upload-link mrgn-top">
                                                                        <button
                                                                          type="button"
                                                                          className="btn wht-bg link-btn mr-auto"
                                                                          onClick={this.OpenViewer}
                                                                        // data-bs-toggle="modal" data-bs-target="#exampleModal"
                                                                        >
                                                                          {this.state.isOpenViewer
                                                                            ? "Close Viewer"
                                                                            : "Open Viewer"}
                                                                        </button>
                                                                      </div>
                                                                    </Form.Label>
                                                                  )}
                                                              
                                                               
                                                                <div className="mt-1 py-3 rounded-3 text-center text-secondary"
                                                                  style={{ border: "solid 1px #c0c0c0" }}>
                                                                  <Dropzone
                                                                    // disabled={isBedgeProcessing}
                                                                    onDrop={this.onDrop}
                                                                  // accept="image/*,application/pdf,.doc,.docx,.xls,.xlsx,.csv,.txt,.bmp,.tif,.ppt,.pptx,.rtf,.jpg,.png,.msg,.eml"
                                                                  >
                                                                    {({
                                                                      getRootProps,
                                                                      getInputProps,
                                                                      isDragActive,
                                                                      isDragReject,
                                                                    }) => (
                                                                      <>
                                                                        <aside style={{paddingBottom:'52px'}}>
                                                                          {/* <ul>{files}</ul> */}
                                                                          <ul>{files1}</ul>
                                                                          <ul style={{textAlign:'left'}}> 
                                                                                                                    {this.state.savedfiles.length> 0 && (
                                                                          
                                                                                                                    <Form.Label>
                                                                                                                    {
                                                                                                                      <div className="upload-link mrgn-top">
                                                                                                                        <button
                                                                                                                          type="button"
                                                                                                                          className="btn"
                                                                                                                          style={{fontSize:'14px'}}
                                                                                                                          onClick={this.handleButtonClick}
                                                                                                                        >
                                                                                                                          <FaCirclePlus style={{color:'#164DA0'}} className="align-middle lh-1`" />{" "}
                                                                                                                          <span style={{color:'#164DA0'}}>Add Attachment</span>
                                                                                                                        </button>
                                                                                                                        <Form.Control
                                                                                                                         ref={this.fileInputRef}
                                                                                                                          id="formControlsFile"
                                                                                                                          type="file"
                                                                                                                          className="form-control-file"
                                                                                                                          multiple
                                                                                                                          onChange={(event: any) =>
                                                                                                                            this.onFileChange(event, "1")
                                                                                                                          }
                                                                                                                          accept="image/*,application/pdf,.doc,.docx,.xls,.xlsx,.csv,.txt,.bmp,.tif,.ppt,.pptx,.rtf,.jpg,.png,.msg,.eml"
                                                                                                                        />
                                                                                                                      </div>
                                                                                                                    }
                                                                                                                    </Form.Label>
                                                                          
                                                                                                                )}</ul>
                                                                        </aside>
                                                                        <section className="container upload-area default">
                                                                          {/* {!this.state.bulkSelect && ( */}
                                                                          {this.state.savedfiles.length < 1 && (
                                                                            <div
                                                                              {...getRootProps({
                                                                                className:
                                                                                  "dropzone align-items-center",
                                                                                onClick:(event) => event,
                                                                                  // this.state.newSelectfiles.length > 0 ||
                                                                                  //   this.state.savedfiles.length > 0
                                                                                  //   ? (event) => event.stopPropagation()
                                                                                  //   : (event) => event,
                                                                              })}
                                                                            >
                                                                              <input {...getInputProps()} />
                                                                              {/* {this.state.newSelectfiles.length < 1 && */}
                                                                                {this.state.savedfiles.length < 1 && (
                                                                                  <p>
                                                                                    Drag and drop attachment or{" "}
                                                                                    <span>browse files</span> to upload.
                                                                                  </p>
                                                                                )}
                                                                              {(this.state.newSelectfiles.length > 0 ||
                                                                                this.state.savedfiles.length > 0)
                                                                                &&
                                                                                isDragActive && (
                                                                                  <p>
                                                                                    Drag and drop attachment here to upload.
                                                                                  </p>
                                                                                )}
                                                                            </div>
                                                                          )}
                                                                
                                                                        </section>
                                  
                                  
                                                                      </>
                                                                    )}
                                  
                                                                  </Dropzone>
                                  
                                                                </div>
                                                                </div>
                                                              </Form.Group>
                                                            </div>
                                                         
                                                      </div>
                                  
                                  
                                                      <div className="col-12 col-md-6">
                                                        {(this.state.vendororderid != 0 &&
                                                          <CommentBox
                                                            ref={this.ChildComment}
                                                            hotelid={this.state.hotelValue}
                                                            entryType={"vendorOrder"}
                                                            //={this.state.formData.actionType === "copy" ? 0 : this.props.pageType === "Invoice" ? this.state.formData.uniqueno : this.state.formData.incompleteUniqueno}
                                                            uniqueNo={this.state.vendororderid}
                                                            precommentlist={this.state.htmlcomment}
                                                            parentScrollMethod={this.scrollToBottom}
                                                            updatedCommentItem={this.updatedCommentItem}
                                                            commentModalClose={this.CommentModalClose}
                                  
                                                          />
                                                        )}
                                                      </div>
                                                    </div>
                                                    </div>
                       
                                                    <div className="filter-sec height-172">
                  
                                      <br></br>
                                      <br></br>
                  
                                      </div>
                {/* </section> */}

                <div className={"footer-section-new viewer-panel"}
                  style={{ minWidth: "75%", width: "992px", maxWidth: "100%" }}
                >
                  <div>
                    <div className="d-flex gap-3 align-items-center justify-content-end height-72">
                      {this.state.isStateChanged && <div className="mr-auto message">
                        <span style={{ color: '#065a8c' }}>You have unsaved changes</span>
                      </div>}

                      <div className="d-flex gap-3 align-items-center">

                        <Button
                          variant="primary"
                          type="button"
                          className="space btn btn-primary btn-discard"
                          onClick={() =>
                            this.handleDiscard(this.state.orderUniqueNo)
                          }
                        >
                          Discard
                        </Button>

                        {((hasEditOrderPermission && this.state.vendororderid > 0) || (hasAddOrderPermission && this.state.vendororderid === 0)) &&
                           (
                            <>

                              <Button
                                id="btnSaveVendor"
                                variant="primary"
                                type="button"
                                onClick={() => this.saveOrder("order", false)}
                                disabled={
                                  this.state.formData.CustomerID === 0
                                    ? false
                                    : false
                                }
                                onKeyDown={(e: any) =>
                                  this.onTAB("btnSaveVendor-1", 0, e)
                                }
                              >
                                {this.state.vendororderid > 0 ? "Update" : "Save"}
                              </Button>
                            </>
                          )}
                        {/* {this.state.vendororderid > 0 && !this.state.editMode && this.props.receivedStatus !== 'Completed' && this.props.receivedStatus !== 'Received' && this.state.vendorordertype != 'Miscellaneouss' &&
                          <Button
                            variant="primary"
                            type="button"

                            onClick={() =>
                              this.handleEdit()
                            }
                          >
                            Add Item
                          </Button>
                        } */}



                        {/* {this.state.vendororderid > 0 && 
                           //!this.state.invoiceCreated &&
                            (<>

                          
                              <Button
                                id="btnDelete"
                                variant="primary"
                                type="button"
                                onClick={() => this.deleteVendorOrder()}
                                disabled={false}
                              // onKeyDown={(e: any) =>
                              //   this.onTAB("btnSave-1", 0, e)
                              // }
                              >
                                {"Delete"}
                              </Button>
                            <Button variant="primary" onClick={this.printOrder}> Print</Button>
                             <Button variant="primary" onClick={this.mailOrder}>SendEmail</Button>
                            </>)
                            } */}


                        {
                          this.state.isApproved == true && this.state.vendororderid > 0 && hasEditOrderPermission && (
                            <>

                              <Button
                                id="btnSubmit"
                                variant="primary"
                                type="button"
                                onClick={() => this.saveOrderfinal("order", true, 0)}
                                disabled={
                                  this.state.formData.CustomerID === 0
                                    ? false
                                    : false
                                }
                                onKeyDown={(e: any) =>
                                  this.onTAB("btnSubmit", 0, e)
                                }
                              >
                                {"Approve"}
                              </Button>
                               <Button
                                id="btnSubmit"
                                variant="primary"
                                type="button"
                                onClick={() => this.saveOrderfinal("order", true, 2)}
                                disabled={
                                  this.state.formData.CustomerID === 0
                                    ? false
                                    : false
                                }
                              >
                                {"Approve & Email"}
                              </Button>
                            </>)}


                        {this.props.receivedStatus != undefined && this.state.vendororderid > 0 && (this.props.receivedStatus == 'Completed') && (<>
                          <Button variant="primary" onClick={this.ConfirmSendtoBack}> Send Back To Receiving</Button>
                        </>)
                        }
                      </div>
                    </div>
                  </div>
                </div>
                </>
                }
              </div>

              {(this.state.showCustomerSlideout &&
                <Customerorderslideout
                  closeSlideOut={this.closeCustomerSlideout}
                  orderid={this.state.orderid}
                >
                </Customerorderslideout>
              )}

              {this.state.showJobSlideout && (

                <JobCreations
                  closeSlideOut={this.closeJobSlideout}
                  jobid={this.state.jobid}
                  orderid={this.state.orderid}
                  CustomerPoNumber={this.state.CustomerPoNumber}
                  poNumber={this.state.poNumber}
                  productid={this.state.productid}
                  partname={this.state.partname}
                  partNo={this.state.partNo}
                  qtyOrdered={this.state.qtyOrdered}

                  itemNo={this.state.itemNo}
                  selectedCustomer={this.state.selectedCustomer}
                  orderdate={this.state.orderdate}
                  dueDate={this.state.dueDate}
                  jobDesc={this.state.jobDesc}
                  id={this.state.orderdetailid}

                >
                </JobCreations>
              )}

              <Modal
                show={this.state.showAfterSaveModelPopup}
                onHide={this.handleClose}
                backdrop="static"
                keyboard={false}
              >
                <Modal.Header closeButton>
                  <Modal.Title>Vendor Order</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  Please choose appropriate option to notify vendor.
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="primary" onClick={this.printOrder}>
                    Print
                  </Button>
                  <Button variant="primary" onClick={this.mailOrder}>SendEmail</Button>
                </Modal.Footer>
              </Modal>

              <Modal show={this.state.showPopup} onHide={() => { this.setState({ showPopup: false }); }}>
                <Modal.Header>
                  <Modal.Title>Edit Item Description</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Form.Group controlId="formDescription">
                    <Form.Label>Item Description</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={4}
                      value={this.state.currentNote}
                      disabled={this.state.formData.Status == "Inactive"}
                      onChange={(e) => { this.setState({ currentNote: e.target.value }); }}
                      placeholder="Edit the description..."
                    />
                  </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={() => { this.setState({ showPopup: false }); }}>
                    Cancel
                  </Button>
                  <Button variant="primary" onClick={this.handleNotesSave}>
                    Save
                  </Button>
                </Modal.Footer>
              </Modal>

{ /* Notes modal */}
   <Modal show={this.state.showPopup1} onHide={()=>{this.setState({showPopup1:false});}}>
          <Modal.Header>
            <Modal.Title>Add Note</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group controlId="formDescription">
              <Form.Label>Add Note</Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                value={this.state.currentNote1}
                disabled={!((hasEditOrderPermission && this.state.vendororderid != 0) || (hasAddOrderPermission && this.state.vendororderid === 0))}
                onChange={(e)=>{this.setState({ currentNote1: e.target.value });}}
                placeholder="Edit the description..."
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={()=>{this.setState({showPopup1:false});}}>
              Cancel
            </Button>
            {((hasEditOrderPermission && this.state.vendororderid != 0) || (hasAddOrderPermission && this.state.vendororderid === 0)) &&
            <Button variant="primary" onClick={this.handleNotesSave1}>
              Save
            </Button>
            }
          </Modal.Footer>
        </Modal>


                 {this.state.confirmPopup && (

               <div
               >
                 <div className="react-confirm-alert-overlay confirm-modal undefined">
                  <div className="react-confirm-alert">
                    <div className="react-confirm-alert-body">
                      <h1>Confirmation</h1>
                      Are you sure that you want to cancel this order?
                      <div className="react-confirm-alert-button-group">
                        <button
                          type="button"
                          className="btn"
                           onClick={()=>{    this.setState({ confirmPopup: false });
                         }}
                        >
                          No
                        </button>
                        <button
                          type="button"
                          className="btn"
                          onClick={() => this.actionclick("confirmCancel",)}
                        >
                          Yes
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            

            </Container>
          </div>



          {(this.state.isSpinner || this.state.isSaveSpinner) && (
            <div className="loader-spinner d-flex justify-content-center align-items-center">
              <Spinner animation="border" variant="success" />
            </div>
          )}

        </div>

      </section>
    );
  }
}

const mapStateToProps = (state) => ({
  permissions: state.PagePermissionReducer.permissions,
  locationId: state.LocationReducer.locationId
});


export default connect(mapStateToProps)(Vendororderslideout);